// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27none%27%3E%3Cpath d=%27M7 7l3 3 3-3%27 stroke=%27%239CA3AF%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236b7280%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20width=%27200%27%20height=%27200%27%3E%3Cfilter%20id=%27n%27%3E%3CfeTurbulence%20type=%27fractalNoise%27%20baseFrequency=%270.9%27%20numOctaves=%273%27%20stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect%20width=%27100%25%27%20height=%27100%25%27%20filter=%27url%28%23n%29%27%20opacity=%270.4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEgMS41TDYgNi41TDExIDEuNSIgc3Ryb2tlPSIjNkI3MjgwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIj48ZmlsdGVyIGlkPSJuIj48ZmVUdXJidWxlbmNlIHR5cGU9ImZyYWN0YWxOb2lzZSIgYmFzZUZyZXF1ZW5jeT0iLjciIG51bU9jdGF2ZXM9IjEwIiBzdGl0Y2hUaWxlcz0ic3RpdGNoIi8+PC9maWx0ZXI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsdGVyPSJ1cmwoI24pIiBvcGFjaXR5PSIuMSIvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20viewBox=%270%200%2024%2024%27%20fill=%27none%27%20stroke=%27%236b7280%27%20stroke-width=%272%27%20stroke-linecap=%27round%27%20stroke-linejoin=%27round%27%3e%3cpolyline%20points=%276%209%2012%2015%2018%209%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20viewBox=%270%200%2024%2024%27%20fill=%27none%27%20stroke=%27%23d97706%27%20stroke-width=%272%27%20stroke-linecap=%27round%27%20stroke-linejoin=%27round%27%3e%3cpolyline%20points=%276%209%2012%2015%2018%209%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/Auro-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/Auro-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/Amaranth-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/Amaranth-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/fonts/BalooBhai2-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./assets/fonts/BalooBhai2-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./assets/fonts/BalooBhai2-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./assets/fonts/DUBAI-LIGHT.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./assets/fonts/DUBAI-REGULAR.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./assets/fonts/DUBAI-MEDIUM.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Montserrat @font-face declaration
   are in public/index.html <head> so they load immediately
   with the page and are not affected by HMR/Fast Refresh. */

/* Remove blinking caret from login form inputs only */
.login-page input[type="text"], .login-page input[type="password"] {
  caret-color: transparent;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/* ! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com *//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: -apple-system, BlinkMacSystemFont, system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    /* Allow document to grow naturally */
    min-height: 100%;
    margin: 0;
    padding: 0;
    /* Prevent bounce effect globally */
    overscroll-behavior-y: none;
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
  }

  /*
   * When the authenticated app shell is mounted (MainLayout), lock the
   * document completely so wheel events that escape inner scroll containers
   * can never shift the page.  !important ensures this wins over inline
   * styles set by modal/dialog cleanup code (e.g. body.style.overflow='unset').
   */
  html.app-shell,
  body.app-shell {
    overflow: hidden !important;
    height: 100vh !important;
    overscroll-behavior: none !important;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  html::-webkit-scrollbar {
    display: none;
  }

  body:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

  body {
  overflow-x: hidden;
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
  font-family: -apple-system, BlinkMacSystemFont, system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

  body:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

  body {
    min-height: 100vh;
    /* Remove fixed height to allow natural scrolling */
    margin: 0;
    padding: 0;
    position: relative;
    transition: background-color 0.2s, color 0.2s;
  }

  #root {
    /* Ensure root container fills the viewport */
    min-height: 100vh;
    position: relative;
  }

  /* Ensure crisp rendering on high-resolution displays */
  * {
    backface-visibility: hidden;
  }

  .public-header {
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    left: 0 !important;
    z-index: 50 !important;
    backface-visibility: visible !important;
  }

  /* Mobile: backdrop-filter on a position:fixed element is a known source of
     the header flickering or vanishing during scroll on Android GPUs, and the
     scrolled/unscrolled toggle re-animates it on every scroll. Use a solid
     background instead — visually near-identical, compositing-safe. */
  @media (max-width: 767px) {
    .public-header {
      -moz-backdrop-filter: none !important;
      backdrop-filter: none !important;
      background-color: #ffffff !important;
    }

    .dark .public-header {
      background-color: #111827 !important;
    }
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    appearance: textfield;
  }
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {
  .\\!container {
    max-width: 640px !important;
  }
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .\\!container {
    max-width: 768px !important;
  }
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .\\!container {
    max-width: 1024px !important;
  }
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .\\!container {
    max-width: 1280px !important;
  }
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .\\!container {
    max-width: 1536px !important;
  }
  .container {
    max-width: 1536px;
  }
}

  .card:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

  .card {
  border-radius: 1rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1.5rem;
  --tw-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

  .card:hover {
  --tw-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  --tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  .card:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

  .input-field {
  width: 100%;
  border-radius: 0.5rem;
  border-width: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

  .input-field:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

  .input-field:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(20 184 166 / var(--tw-ring-opacity, 1));
}

  .input-field:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

  .input-field:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

  /* Force white modal body background to override page bg */

  /* macOS Sonoma style select */
  select.input-field {
  cursor: pointer;
  appearance: none;
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
  padding-right: 2rem;
}
  select.input-field:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
  select.input-field:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
  select.input-field:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
  select.input-field:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
  select.input-field:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
  select.input-field:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
  select.input-field {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: right 0.3rem center;
    background-repeat: no-repeat;
    background-size: 1.25rem;
  }

  /* macOS Sonoma style textarea */
  textarea.input-field {
  resize: vertical;
}

  /* Rx-style underline inputs (like PrescriptionPanel) */
  .input-rx:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
  .input-rx {
  width: 100%;
  border-width: 0px;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
  background-color: transparent;
  padding: 0px;
  padding-bottom: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
  .input-rx:is(.dark *):is(.dark *)::placeholder {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
  .input-rx::placeholder {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
  .input-rx:focus {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  .input-rx:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
  .input-rx:is(.dark *)::placeholder {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

  .input-rx:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

  .input-rx.read-only:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

  .input-rx.read-only {
  cursor: default;
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

  .input-rx.read-only:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

  /* Rx-style label */
  .label-rx:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
  .label-rx {
  margin-bottom: 0.25rem;
  display: block;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
  .label-rx:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

  /* Required indicator for Rx labels */
  .label-rx-required::after {
    content: ' *';
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1));
  }

  /* Rx-style select */
  select.input-rx {
  cursor: pointer;
  appearance: none;
  background-color: transparent;
  padding-right: 1.5rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: right 0px center;
    background-repeat: no-repeat;
    background-size: 14px;
}

  /* Rx-style textarea */
  textarea.input-rx {
  min-height: 28px;
  resize: vertical;
}

  /* Triage check-in panel — fields render a touch larger than the text-xs
     utility on the elements (13px instead of 12px) for readability. */
  .triage-checkin input.input-rx,
  .triage-checkin select.input-rx,
  .triage-checkin textarea.input-rx {
    font-size: 12.5px;
  }

  /* Dark mode table styling */
  table:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

  thead:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

  thead th:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

  tbody:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

  tbody tr:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

  tbody tr:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

  tbody td:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

  /* Dark mode for common table wrapper classes */
  .bg-white:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

  .border-gray-200:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

  .text-gray-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

  .text-gray-700:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

  .text-gray-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

  .text-gray-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.-inset-1 {
  inset: -0.25rem;
}
.-inset-10 {
  inset: -2.5rem;
}
.-inset-2 {
  inset: -0.5rem;
}
.inset-0 {
  inset: 0px;
}
.inset-0\\.5 {
  inset: 0.125rem;
}
.inset-8 {
  inset: 2rem;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-0\\.5 {
  bottom: -0.125rem;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-1\\.5 {
  bottom: -0.375rem;
}
.-bottom-10 {
  bottom: -2.5rem;
}
.-bottom-12 {
  bottom: -3rem;
}
.-bottom-2 {
  bottom: -0.5rem;
}
.-bottom-24 {
  bottom: -6rem;
}
.-bottom-32 {
  bottom: -8rem;
}
.-bottom-5 {
  bottom: -1.25rem;
}
.-bottom-6 {
  bottom: -1.5rem;
}
.-bottom-8 {
  bottom: -2rem;
}
.-left-1\\.5 {
  left: -0.375rem;
}
.-left-10 {
  left: -2.5rem;
}
.-left-12 {
  left: -3rem;
}
.-left-2\\.5 {
  left: -0.625rem;
}
.-left-20 {
  left: -5rem;
}
.-left-24 {
  left: -6rem;
}
.-left-32 {
  left: -8rem;
}
.-left-8 {
  left: -2rem;
}
.-right-0\\.5 {
  right: -0.125rem;
}
.-right-1 {
  right: -0.25rem;
}
.-right-1\\.5 {
  right: -0.375rem;
}
.-right-10 {
  right: -2.5rem;
}
.-right-12 {
  right: -3rem;
}
.-right-16 {
  right: -4rem;
}
.-right-2 {
  right: -0.5rem;
}
.-right-24 {
  right: -6rem;
}
.-right-3 {
  right: -0.75rem;
}
.-right-32 {
  right: -8rem;
}
.-right-40 {
  right: -10rem;
}
.-right-8 {
  right: -2rem;
}
.-top-0 {
  top: -0px;
}
.-top-0\\.5 {
  top: -0.125rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-10 {
  top: -2.5rem;
}
.-top-12 {
  top: -3rem;
}
.-top-16 {
  top: -4rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-2\\.5 {
  top: -0.625rem;
}
.-top-24 {
  top: -6rem;
}
.-top-32 {
  top: -8rem;
}
.-top-4 {
  top: -1rem;
}
.-top-40 {
  top: -10rem;
}
.-top-6 {
  top: -1.5rem;
}
.-top-7 {
  top: -1.75rem;
}
.-top-8 {
  top: -2rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-0\\.5 {
  bottom: 0.125rem;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-1\\.5 {
  bottom: 0.375rem;
}
.bottom-16 {
  bottom: 4rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-40 {
  bottom: 10rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-8 {
  bottom: 2rem;
}
.bottom-\\[-6px\\] {
  bottom: -6px;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-0\\.5 {
  left: 0.125rem;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\.5 {
  left: 0.375rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-1\\/3 {
  left: 33.333333%;
}
.left-12 {
  left: 3rem;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-2\\/3 {
  left: 66.666667%;
}
.left-3 {
  left: 0.75rem;
}
.left-3\\.5 {
  left: 0.875rem;
}
.left-4 {
  left: 1rem;
}
.left-5 {
  left: 1.25rem;
}
.left-6 {
  left: 1.5rem;
}
.left-7 {
  left: 1.75rem;
}
.left-8 {
  left: 2rem;
}
.left-\\[10\\%\\] {
  left: 10%;
}
.left-\\[13px\\] {
  left: 13px;
}
.left-\\[15px\\] {
  left: 15px;
}
.left-\\[18px\\] {
  left: 18px;
}
.left-\\[21px\\] {
  left: 21px;
}
.left-\\[34px\\] {
  left: 34px;
}
.left-\\[45\\%\\] {
  left: 45%;
}
.left-full {
  left: 100%;
}
.right-0 {
  right: 0px;
}
.right-0\\.5 {
  right: 0.125rem;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\.5 {
  right: 0.375rem;
}
.right-1\\/3 {
  right: 33.333333%;
}
.right-10 {
  right: 2.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-2\\.5 {
  right: 0.625rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-6 {
  right: 1.5rem;
}
.right-7 {
  right: 1.75rem;
}
.right-\\[7\\.5rem\\] {
  right: 7.5rem;
}
.right-\\[8\\%\\] {
  right: 8%;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-1\\/3 {
  top: 33.333333%;
}
.top-10 {
  top: 2.5rem;
}
.top-14 {
  top: 3.5rem;
}
.top-16 {
  top: 4rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-2\\/3 {
  top: 66.666667%;
}
.top-20 {
  top: 5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-32 {
  top: 8rem;
}
.top-4 {
  top: 1rem;
}
.top-40 {
  top: 10rem;
}
.top-5 {
  top: 1.25rem;
}
.top-6 {
  top: 1.5rem;
}
.top-8 {
  top: 2rem;
}
.top-\\[13rem\\] {
  top: 13rem;
}
.top-\\[26px\\] {
  top: 26px;
}
.top-\\[40px\\] {
  top: 40px;
}
.top-\\[calc\\(100\\%\\+4px\\)\\] {
  top: calc(100% + 4px);
}
.top-full {
  top: 100%;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[10000\\] {
  z-index: 10000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[110\\] {
  z-index: 110;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[200\\] {
  z-index: 200;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[70\\] {
  z-index: 70;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-5 {
  grid-column: span 5 / span 5;
}
.col-span-full {
  grid-column: 1 / -1;
}
.\\!m-0 {
  margin: 0px !important;
}
.-m-6 {
  margin: -1.5rem;
}
.m-2 {
  margin: 0.5rem;
}
.m-4 {
  margin: 1rem;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-2\\.5 {
  margin-left: -0.625rem;
  margin-right: -0.625rem;
}
.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.-my-1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.-my-3 {
  margin-top: -0.75rem;
  margin-bottom: -0.75rem;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-mb-2 {
  margin-bottom: -0.5rem;
}
.-mb-2\\.5 {
  margin-bottom: -0.625rem;
}
.-mb-4 {
  margin-bottom: -1rem;
}
.-mb-8 {
  margin-bottom: -2rem;
}
.-mb-\\[60px\\] {
  margin-bottom: -60px;
}
.-mb-px {
  margin-bottom: -1px;
}
.-ml-0\\.5 {
  margin-left: -0.125rem;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-ml-8 {
  margin-left: -2rem;
}
.-mr-10 {
  margin-right: -2.5rem;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.-mt-10 {
  margin-top: -2.5rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.-mt-40 {
  margin-top: -10rem;
}
.-mt-6 {
  margin-top: -1.5rem;
}
.-mt-px {
  margin-top: -1px;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-px {
  margin-bottom: 1px;
}
.ml-0 {
  margin-left: 0px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-12 {
  margin-left: 3rem;
}
.ml-16 {
  margin-left: 4rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-2\\.5 {
  margin-left: 0.625rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-3\\.5 {
  margin-left: 0.875rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-7 {
  margin-left: 1.75rem;
}
.ml-8 {
  margin-left: 2rem;
}
.ml-\\[18px\\] {
  margin-left: 18px;
}
.ml-auto {
  margin-left: auto;
}
.ml-px {
  margin-left: 1px;
}
.mr-0\\.5 {
  margin-right: 0.125rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-80 {
  margin-top: 20rem;
}
.mt-\\[18px\\] {
  margin-top: 18px;
}
.mt-\\[1px\\] {
  margin-top: 1px;
}
.mt-\\[3px\\] {
  margin-top: 3px;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-auto {
  margin-top: auto;
}
.mt-px {
  margin-top: 1px;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.\\!block {
  display: block !important;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.\\!inline {
  display: inline !important;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.aspect-\\[3\\/4\\] {
  aspect-ratio: 3/4;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.\\!h-4 {
  height: 1rem !important;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-44 {
  height: 11rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-52 {
  height: 13rem;
}
.h-56 {
  height: 14rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-9 {
  height: 2.25rem;
}
.h-96 {
  height: 24rem;
}
.h-\\[140px\\] {
  height: 140px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[180px\\] {
  height: 180px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[240px\\] {
  height: 240px;
}
.h-\\[245px\\] {
  height: 245px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[24rem\\] {
  height: 24rem;
}
.h-\\[250px\\] {
  height: 250px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[260px\\] {
  height: 260px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[26rem\\] {
  height: 26rem;
}
.h-\\[280px\\] {
  height: 280px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[28rem\\] {
  height: 28rem;
}
.h-\\[290px\\] {
  height: 290px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[420px\\] {
  height: 420px;
}
.h-\\[520px\\] {
  height: 520px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[634px\\] {
  height: 634px;
}
.h-\\[70\\%\\] {
  height: 70%;
}
.h-\\[70vh\\] {
  height: 70vh;
}
.h-\\[75vh\\] {
  height: 75vh;
}
.h-\\[86\\%\\] {
  height: 86%;
}
.h-\\[92\\%\\] {
  height: 92%;
}
.h-\\[calc\\(100vh-180px\\)\\] {
  height: calc(100vh - 180px);
}
.h-\\[calc\\(100vh-200px\\)\\] {
  height: calc(100vh - 200px);
}
.h-\\[calc\\(100vh-260px\\)\\] {
  height: calc(100vh - 260px);
}
.h-\\[calc\\(100vh-64px\\)\\] {
  height: calc(100vh - 64px);
}
.h-\\[min\\(788px\\2c calc\\(100vh-232px\\)\\)\\] {
  height: min(788px, calc(100vh - 232px));
}
.h-\\[min\\(94vh\\2c 980px\\)\\] {
  height: min(94vh, 980px);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-16 {
  max-height: 4rem;
}
.max-h-20 {
  max-height: 5rem;
}
.max-h-24 {
  max-height: 6rem;
}
.max-h-28 {
  max-height: 7rem;
}
.max-h-32 {
  max-height: 8rem;
}
.max-h-36 {
  max-height: 9rem;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-44 {
  max-height: 11rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-52 {
  max-height: 13rem;
}
.max-h-56 {
  max-height: 14rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[100px\\] {
  max-height: 100px;
}
.max-h-\\[105vh\\] {
  max-height: 105vh;
}
.max-h-\\[160px\\] {
  max-height: 160px;
}
.max-h-\\[180px\\] {
  max-height: 180px;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[220px\\] {
  max-height: 220px;
}
.max-h-\\[240px\\] {
  max-height: 240px;
}
.max-h-\\[24rem\\] {
  max-height: 24rem;
}
.max-h-\\[260px\\] {
  max-height: 260px;
}
.max-h-\\[280px\\] {
  max-height: 280px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[340px\\] {
  max-height: 340px;
}
.max-h-\\[350px\\] {
  max-height: 350px;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[420px\\] {
  max-height: 420px;
}
.max-h-\\[450px\\] {
  max-height: 450px;
}
.max-h-\\[46vh\\] {
  max-height: 46vh;
}
.max-h-\\[480px\\] {
  max-height: 480px;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[50vh\\] {
  max-height: 50vh;
}
.max-h-\\[520px\\] {
  max-height: 520px;
}
.max-h-\\[55vh\\] {
  max-height: 55vh;
}
.max-h-\\[600px\\] {
  max-height: 600px;
}
.max-h-\\[60px\\] {
  max-height: 60px;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[62vh\\] {
  max-height: 62vh;
}
.max-h-\\[65vh\\] {
  max-height: 65vh;
}
.max-h-\\[68vh\\] {
  max-height: 68vh;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[72vh\\] {
  max-height: 72vh;
}
.max-h-\\[75vh\\] {
  max-height: 75vh;
}
.max-h-\\[800px\\] {
  max-height: 800px;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[92vh\\] {
  max-height: 92vh;
}
.max-h-\\[95vh\\] {
  max-height: 95vh;
}
.max-h-\\[calc\\(100dvh-320px\\)\\] {
  max-height: calc(100dvh - 320px);
}
.max-h-\\[calc\\(100dvh-380px\\)\\] {
  max-height: calc(100dvh - 380px);
}
.max-h-\\[calc\\(100vh-11rem\\)\\] {
  max-height: calc(100vh - 11rem);
}
.max-h-\\[calc\\(100vh-120px\\)\\] {
  max-height: calc(100vh - 120px);
}
.max-h-\\[calc\\(100vh-200px\\)\\] {
  max-height: calc(100vh - 200px);
}
.max-h-\\[calc\\(100vh-220px\\)\\] {
  max-height: calc(100vh - 220px);
}
.max-h-\\[calc\\(100vh-240px\\)\\] {
  max-height: calc(100vh - 240px);
}
.max-h-\\[calc\\(100vh-300px\\)\\] {
  max-height: calc(100vh - 300px);
}
.max-h-\\[calc\\(100vh-340px\\)\\] {
  max-height: calc(100vh - 340px);
}
.max-h-\\[calc\\(100vh-80px\\)\\] {
  max-height: calc(100vh - 80px);
}
.max-h-\\[calc\\(105vh-110px\\)\\] {
  max-height: calc(105vh - 110px);
}
.max-h-\\[calc\\(85vh-110px\\)\\] {
  max-height: calc(85vh - 110px);
}
.max-h-\\[calc\\(85vh-120px\\)\\] {
  max-height: calc(85vh - 120px);
}
.max-h-\\[calc\\(85vh-130px\\)\\] {
  max-height: calc(85vh - 130px);
}
.max-h-\\[calc\\(85vh-140px\\)\\] {
  max-height: calc(85vh - 140px);
}
.max-h-\\[calc\\(90vh-76px\\)\\] {
  max-height: calc(90vh - 76px);
}
.max-h-full {
  max-height: 100%;
}
.\\!min-h-\\[28px\\] {
  min-height: 28px !important;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-28 {
  min-height: 7rem;
}
.min-h-32 {
  min-height: 8rem;
}
.min-h-52 {
  min-height: 13rem;
}
.min-h-\\[1\\.75rem\\] {
  min-height: 1.75rem;
}
.min-h-\\[105px\\] {
  min-height: 105px;
}
.min-h-\\[11rem\\] {
  min-height: 11rem;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.min-h-\\[180px\\] {
  min-height: 180px;
}
.min-h-\\[2\\.25rem\\] {
  min-height: 2.25rem;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[22rem\\] {
  min-height: 22rem;
}
.min-h-\\[260px\\] {
  min-height: 260px;
}
.min-h-\\[28px\\] {
  min-height: 28px;
}
.min-h-\\[29px\\] {
  min-height: 29px;
}
.min-h-\\[340px\\] {
  min-height: 340px;
}
.min-h-\\[36px\\] {
  min-height: 36px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.min-h-\\[480px\\] {
  min-height: 480px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-\\[50px\\] {
  min-height: 50px;
}
.min-h-\\[54px\\] {
  min-height: 54px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-\\[72px\\] {
  min-height: 72px;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[92px\\] {
  min-height: 92px;
}
.min-h-\\[96px\\] {
  min-height: 96px;
}
.min-h-\\[calc\\(100vh-64px\\)\\] {
  min-height: calc(100vh - 64px);
}
.min-h-full {
  min-height: 100%;
}
.min-h-min {
  min-height: min-content;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-16 {
  width: 4rem !important;
}
.\\!w-4 {
  width: 1rem !important;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-2\\/4 {
  width: 50%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[10\\.5rem\\] {
  width: 10.5rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[108px\\] {
  width: 108px;
}
.w-\\[11\\%\\] {
  width: 11%;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[112px\\] {
  width: 112px;
}
.w-\\[118px\\] {
  width: 118px;
}
.w-\\[12\\%\\] {
  width: 12%;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[13\\%\\] {
  width: 13%;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[132px\\] {
  width: 132px;
}
.w-\\[136px\\] {
  width: 136px;
}
.w-\\[14\\%\\] {
  width: 14%;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[148px\\] {
  width: 148px;
}
.w-\\[15\\%\\] {
  width: 15%;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[16\\%\\] {
  width: 16%;
}
.w-\\[168px\\] {
  width: 168px;
}
.w-\\[17\\%\\] {
  width: 17%;
}
.w-\\[170px\\] {
  width: 170px;
}
.w-\\[18\\%\\] {
  width: 18%;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[196px\\] {
  width: 196px;
}
.w-\\[2\\.5px\\] {
  width: 2.5px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[22\\%\\] {
  width: 22%;
}
.w-\\[220px\\] {
  width: 220px;
}
.w-\\[24rem\\] {
  width: 24rem;
}
.w-\\[26rem\\] {
  width: 26rem;
}
.w-\\[28px\\] {
  width: 28px;
}
.w-\\[28rem\\] {
  width: 28rem;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[32rem\\] {
  width: 32rem;
}
.w-\\[34\\%\\] {
  width: 34%;
}
.w-\\[340px\\] {
  width: 340px;
}
.w-\\[35\\%\\] {
  width: 35%;
}
.w-\\[3px\\] {
  width: 3px;
}
.w-\\[5\\%\\] {
  width: 5%;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[6\\%\\] {
  width: 6%;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[68px\\] {
  width: 68px;
}
.w-\\[7\\%\\] {
  width: 7%;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[70px\\] {
  width: 70px;
}
.w-\\[74px\\] {
  width: 74px;
}
.w-\\[8\\%\\] {
  width: 8%;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[84\\%\\] {
  width: 84%;
}
.w-\\[86\\%\\] {
  width: 86%;
}
.w-\\[9\\%\\] {
  width: 9%;
}
.w-\\[90px\\] {
  width: 90px;
}
.w-\\[92\\%\\] {
  width: 92%;
}
.w-\\[95vw\\] {
  width: 95vw;
}
.w-\\[98px\\] {
  width: 98px;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-28 {
  min-width: 7rem;
}
.min-w-4 {
  min-width: 1rem;
}
.min-w-7 {
  min-width: 1.75rem;
}
.min-w-\\[1\\.5rem\\] {
  min-width: 1.5rem;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[1080px\\] {
  min-width: 1080px;
}
.min-w-\\[110px\\] {
  min-width: 110px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[130px\\] {
  min-width: 130px;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[14px\\] {
  min-width: 14px;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[16px\\] {
  min-width: 16px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[18px\\] {
  min-width: 18px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[20px\\] {
  min-width: 20px;
}
.min-w-\\[210px\\] {
  min-width: 210px;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[22px\\] {
  min-width: 22px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[26px\\] {
  min-width: 26px;
}
.min-w-\\[280px\\] {
  min-width: 280px;
}
.min-w-\\[28px\\] {
  min-width: 28px;
}
.min-w-\\[32px\\] {
  min-width: 32px;
}
.min-w-\\[36px\\] {
  min-width: 36px;
}
.min-w-\\[400px\\] {
  min-width: 400px;
}
.min-w-\\[40px\\] {
  min-width: 40px;
}
.min-w-\\[42px\\] {
  min-width: 42px;
}
.min-w-\\[48px\\] {
  min-width: 48px;
}
.min-w-\\[50px\\] {
  min-width: 50px;
}
.min-w-\\[56px\\] {
  min-width: 56px;
}
.min-w-\\[60px\\] {
  min-width: 60px;
}
.min-w-\\[700px\\] {
  min-width: 700px;
}
.min-w-\\[72px\\] {
  min-width: 72px;
}
.min-w-\\[760px\\] {
  min-width: 760px;
}
.min-w-\\[800px\\] {
  min-width: 800px;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.min-w-\\[82px\\] {
  min-width: 82px;
}
.min-w-\\[900px\\] {
  min-width: 900px;
}
.min-w-\\[90px\\] {
  min-width: 90px;
}
.min-w-\\[980px\\] {
  min-width: 980px;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.max-w-0 {
  max-width: 0px;
}
.max-w-12 {
  max-width: 3rem;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[110px\\] {
  max-width: 110px;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[130px\\] {
  max-width: 130px;
}
.max-w-\\[1380px\\] {
  max-width: 1380px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[1500px\\] {
  max-width: 1500px;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[170px\\] {
  max-width: 170px;
}
.max-w-\\[1760px\\] {
  max-width: 1760px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[18rem\\] {
  max-width: 18rem;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[240px\\] {
  max-width: 240px;
}
.max-w-\\[250px\\] {
  max-width: 250px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[340px\\] {
  max-width: 340px;
}
.max-w-\\[34rem\\] {
  max-width: 34rem;
}
.max-w-\\[360px\\] {
  max-width: 360px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[420px\\] {
  max-width: 420px;
}
.max-w-\\[42rem\\] {
  max-width: 42rem;
}
.max-w-\\[44rem\\] {
  max-width: 44rem;
}
.max-w-\\[50\\%\\] {
  max-width: 50%;
}
.max-w-\\[52rem\\] {
  max-width: 52rem;
}
.max-w-\\[56rem\\] {
  max-width: 56rem;
}
.max-w-\\[5rem\\] {
  max-width: 5rem;
}
.max-w-\\[60\\%\\] {
  max-width: 60%;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[620px\\] {
  max-width: 620px;
}
.max-w-\\[660px\\] {
  max-width: 660px;
}
.max-w-\\[70\\%\\] {
  max-width: 70%;
}
.max-w-\\[72px\\] {
  max-width: 72px;
}
.max-w-\\[75\\%\\] {
  max-width: 75%;
}
.max-w-\\[80px\\] {
  max-width: 80px;
}
.max-w-\\[80rem\\] {
  max-width: 80rem;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.max-w-\\[88px\\] {
  max-width: 88px;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[90px\\] {
  max-width: 90px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-screen-2xl {
  max-width: 1536px;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-\\[10\\] {
  flex: 10 1;
}
.flex-\\[115\\] {
  flex: 115 1;
}
.flex-\\[25\\] {
  flex: 25 1;
}
.flex-\\[2\\] {
  flex: 2 1;
}
.flex-none {
  flex: none;
}
.flex-shrink {
  flex-shrink: 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.table-fixed {
  table-layout: fixed;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-center {
  transform-origin: center;
}
.origin-top-right {
  transform-origin: top right;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2 {
  --tw-translate-x: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\.5 {
  --tw-translate-y: -0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2\\.5 {
  --tw-translate-x: 0.625rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-3 {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-3\\.5 {
  --tw-translate-x: 0.875rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5 {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[18px\\] {
  --tw-translate-x: 18px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-12 {
  --tw-rotate: -12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-12 {
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.98\\] {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.03\\] {
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.animate-\\[fadeIn_0\\.2s_ease-in-out\\] {
  animation: fadeIn 0.2s ease-in-out;
}
.animate-\\[fadeIn_0\\.2s_ease-out\\] {
  animation: fadeIn 0.2s ease-out;
}
.animate-\\[scaleIn_0\\.2s_ease-out\\] {
  animation: scaleIn 0.2s ease-out;
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-col-resize {
  cursor: col-resize;
}
.cursor-default {
  cursor: default;
}
.cursor-e-resize {
  cursor: e-resize;
}
.cursor-grab {
  cursor: grab;
}
.cursor-help {
  cursor: help;
}
.cursor-move {
  cursor: move;
}
.cursor-n-resize {
  cursor: n-resize;
}
.cursor-ne-resize {
  cursor: ne-resize;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-ns-resize {
  cursor: ns-resize;
}
.cursor-nw-resize {
  cursor: nw-resize;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-s-resize {
  cursor: s-resize;
}
.cursor-se-resize {
  cursor: se-resize;
}
.cursor-sw-resize {
  cursor: sw-resize;
}
.cursor-text {
  cursor: text;
}
.cursor-w-resize {
  cursor: w-resize;
}
.cursor-wait {
  cursor: wait;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.\\!resize-none {
  resize: none !important;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.scroll-mt-20 {
  scroll-margin-top: 5rem;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.appearance-none {
  appearance: none;
}
.columns-1 {
  columns: 1;
}
.columns-2 {
  columns: 2;
}
.break-inside-avoid {
  page-break-inside: avoid;
  break-inside: avoid;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.grid-cols-\\[1\\.15fr_1fr\\] {
  grid-template-columns: 1.15fr 1fr;
}
.grid-cols-\\[110px_1fr\\] {
  grid-template-columns: 110px 1fr;
}
.grid-cols-\\[1fr_0fr\\] {
  grid-template-columns: 1fr 0fr;
}
.grid-cols-\\[1fr_1fr_1fr\\] {
  grid-template-columns: 1fr 1fr 1fr;
}
.grid-cols-\\[1fr_400px\\] {
  grid-template-columns: 1fr 400px;
}
.grid-cols-\\[1fr_48px\\] {
  grid-template-columns: 1fr 48px;
}
.grid-cols-\\[1fr_auto_1fr\\] {
  grid-template-columns: 1fr auto 1fr;
}
.grid-cols-\\[2\\.5rem_6rem\\] {
  grid-template-columns: 2.5rem 6rem;
}
.grid-cols-\\[3fr_2\\.6fr_2fr\\] {
  grid-template-columns: 3fr 2.6fr 2fr;
}
.grid-cols-\\[9fr_5\\.5fr_5\\.5fr\\] {
  grid-template-columns: 9fr 5.5fr 5.5fr;
}
.grid-cols-\\[max-content_1fr\\] {
  grid-template-columns: max-content 1fr;
}
.grid-cols-\\[minmax\\(180px\\2c 2fr\\)_minmax\\(66px\\2c 0\\.4fr\\)_minmax\\(70px\\2c 0\\.4fr\\)_minmax\\(80px\\2c 0\\.5fr\\)_minmax\\(80px\\2c 0\\.5fr\\)_minmax\\(150px\\2c 1\\.2fr\\)_auto\\] {
  grid-template-columns: minmax(180px,2fr) minmax(66px,0.4fr) minmax(70px,0.4fr) minmax(80px,0.5fr) minmax(80px,0.5fr) minmax(150px,1.2fr) auto;
}
.grid-cols-\\[minmax\\(220px\\2c 2fr\\)_minmax\\(76px\\2c 0\\.45fr\\)_minmax\\(84px\\2c 0\\.5fr\\)_minmax\\(84px\\2c 0\\.5fr\\)_minmax\\(140px\\2c 0\\.9fr\\)_auto\\] {
  grid-template-columns: minmax(220px,2fr) minmax(76px,0.45fr) minmax(84px,0.5fr) minmax(84px,0.5fr) minmax(140px,0.9fr) auto;
}
.grid-cols-\\[minmax\\(220px\\2c 2fr\\)_minmax\\(76px\\2c 0\\.45fr\\)_minmax\\(84px\\2c 0\\.5fr\\)_minmax\\(84px\\2c 0\\.5fr\\)_minmax\\(84px\\2c 0\\.5fr\\)_minmax\\(84px\\2c 0\\.5fr\\)_auto\\] {
  grid-template-columns: minmax(220px,2fr) minmax(76px,0.45fr) minmax(84px,0.5fr) minmax(84px,0.5fr) minmax(84px,0.5fr) minmax(84px,0.5fr) auto;
}
.grid-rows-\\[0fr\\] {
  grid-template-rows: 0fr;
}
.grid-rows-\\[1fr\\] {
  grid-template-rows: 1fr;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.content-start {
  align-content: flex-start;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-3\\.5 {
  gap: 0.875rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[20rem\\] {
  gap: 20rem;
}
.gap-\\[2px\\] {
  gap: 2px;
}
.gap-px {
  gap: 1px;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-10 {
  column-gap: 2.5rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-2\\.5 {
  column-gap: 0.625rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-0 {
  row-gap: 0px;
}
.gap-y-0\\.5 {
  row-gap: 0.125rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-2\\.5 {
  row-gap: 0.625rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-3\\.5 {
  row-gap: 0.875rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.gap-y-5 {
  row-gap: 1.25rem;
}
.gap-y-\\[1px\\] {
  row-gap: 1px;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.375rem * var(--tw-space-x-reverse));
  margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.625rem * var(--tw-space-x-reverse));
  margin-left: calc(0.625rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-x-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(0px * var(--tw-divide-x-reverse));
  border-left-width: calc(0px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-amber-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(255 251 235 / var(--tw-divide-opacity, 1));
}
.divide-blue-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(239 246 255 / var(--tw-divide-opacity, 1));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-gray-100\\/50 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(243 244 246 / 0.5);
}
.divide-gray-100\\/60 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(243 244 246 / 0.6);
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.divide-gray-200\\/50 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(229 231 235 / 0.5);
}
.divide-gray-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-divide-opacity, 1));
}
.divide-purple-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-divide-opacity, 1));
}
.divide-slate-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-divide-opacity, 1));
}
.divide-teal-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(240 253 250 / var(--tw-divide-opacity, 1));
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.self-stretch {
  align-self: stretch;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-x-clip {
  overflow-x: clip;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[3rem\\] {
  border-radius: 3rem;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-3xl {
  border-bottom-right-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-xl {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-r-2xl {
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-xl {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl-xl {
  border-bottom-left-radius: 0.75rem;
}
.rounded-br-lg {
  border-bottom-right-radius: 0.5rem;
}
.rounded-br-xl {
  border-bottom-right-radius: 0.75rem;
}
.rounded-tl-xl {
  border-top-left-radius: 0.75rem;
}
.rounded-tr-\\[2rem\\] {
  border-top-right-radius: 2rem;
}
.rounded-tr-xl {
  border-top-right-radius: 0.75rem;
}
.\\!border-0 {
  border-width: 0px !important;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-\\[3px\\] {
  border-width: 3px;
}
.border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.\\!border-b-0 {
  border-bottom-width: 0px !important;
}
.\\!border-l-0 {
  border-left-width: 0px !important;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-\\[0\\.5px\\] {
  border-bottom-width: 0.5px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-0 {
  border-left-width: 0px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-dashed {
  border-style: dashed;
}
.\\!border-red-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-teal-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1)) !important;
}
.border-amber-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-amber-100\\/50 {
  border-color: rgb(254 243 199 / 0.5);
}
.border-amber-100\\/80 {
  border-color: rgb(254 243 199 / 0.8);
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-200\\/50 {
  border-color: rgb(253 230 138 / 0.5);
}
.border-amber-200\\/60 {
  border-color: rgb(253 230 138 / 0.6);
}
.border-amber-200\\/70 {
  border-color: rgb(253 230 138 / 0.7);
}
.border-amber-200\\/80 {
  border-color: rgb(253 230 138 / 0.8);
}
.border-amber-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-300\\/30 {
  border-color: rgb(252 211 77 / 0.3);
}
.border-amber-300\\/70 {
  border-color: rgb(252 211 77 / 0.7);
}
.border-amber-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-400\\/60 {
  border-color: rgb(251 191 36 / 0.6);
}
.border-amber-50\\/60 {
  border-color: rgb(255 251 235 / 0.6);
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-amber-500\\/20 {
  border-color: rgb(245 158 11 / 0.2);
}
.border-amber-600 {
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity, 1));
}
.border-black\\/\\[0\\.06\\] {
  border-color: rgb(0 0 0 / 0.06);
}
.border-black\\/\\[0\\.08\\] {
  border-color: rgb(0 0 0 / 0.08);
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-100\\/30 {
  border-color: rgb(219 234 254 / 0.3);
}
.border-blue-100\\/50 {
  border-color: rgb(219 234 254 / 0.5);
}
.border-blue-100\\/60 {
  border-color: rgb(219 234 254 / 0.6);
}
.border-blue-100\\/70 {
  border-color: rgb(219 234 254 / 0.7);
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-200\\/50 {
  border-color: rgb(191 219 254 / 0.5);
}
.border-blue-200\\/60 {
  border-color: rgb(191 219 254 / 0.6);
}
.border-blue-200\\/70 {
  border-color: rgb(191 219 254 / 0.7);
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-blue-400\\/60 {
  border-color: rgb(96 165 250 / 0.6);
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-500\\/20 {
  border-color: rgb(59 130 246 / 0.2);
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-blue-700 {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}
.border-current {
  border-color: currentColor;
}
.border-cyan-100 {
  --tw-border-opacity: 1;
  border-color: rgb(207 250 254 / var(--tw-border-opacity, 1));
}
.border-cyan-100\\/70 {
  border-color: rgb(207 250 254 / 0.7);
}
.border-cyan-200 {
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / var(--tw-border-opacity, 1));
}
.border-cyan-200\\/50 {
  border-color: rgb(165 243 252 / 0.5);
}
.border-cyan-300 {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity, 1));
}
.border-cyan-400 {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity, 1));
}
.border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.border-cyan-600 {
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity, 1));
}
.border-emerald-100 {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-100\\/50 {
  border-color: rgb(209 250 229 / 0.5);
}
.border-emerald-100\\/60 {
  border-color: rgb(209 250 229 / 0.6);
}
.border-emerald-100\\/70 {
  border-color: rgb(209 250 229 / 0.7);
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-200\\/50 {
  border-color: rgb(167 243 208 / 0.5);
}
.border-emerald-200\\/60 {
  border-color: rgb(167 243 208 / 0.6);
}
.border-emerald-200\\/70 {
  border-color: rgb(167 243 208 / 0.7);
}
.border-emerald-300 {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-emerald-300\\/30 {
  border-color: rgb(110 231 183 / 0.3);
}
.border-emerald-400 {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.border-emerald-400\\/30 {
  border-color: rgb(52 211 153 / 0.3);
}
.border-emerald-400\\/60 {
  border-color: rgb(52 211 153 / 0.6);
}
.border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/20 {
  border-color: rgb(16 185 129 / 0.2);
}
.border-emerald-600 {
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity, 1));
}
.border-emerald-800\\/40 {
  border-color: rgb(6 95 70 / 0.4);
}
.border-fuchsia-200 {
  --tw-border-opacity: 1;
  border-color: rgb(245 208 254 / var(--tw-border-opacity, 1));
}
.border-fuchsia-400 {
  --tw-border-opacity: 1;
  border-color: rgb(232 121 249 / var(--tw-border-opacity, 1));
}
.border-fuchsia-800\\/40 {
  border-color: rgb(134 25 143 / 0.4);
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-100\\/50 {
  border-color: rgb(243 244 246 / 0.5);
}
.border-gray-100\\/60 {
  border-color: rgb(243 244 246 / 0.6);
}
.border-gray-100\\/80 {
  border-color: rgb(243 244 246 / 0.8);
}
.border-gray-100\\/90 {
  border-color: rgb(243 244 246 / 0.9);
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-200\\/30 {
  border-color: rgb(229 231 235 / 0.3);
}
.border-gray-200\\/50 {
  border-color: rgb(229 231 235 / 0.5);
}
.border-gray-200\\/60 {
  border-color: rgb(229 231 235 / 0.6);
}
.border-gray-200\\/70 {
  border-color: rgb(229 231 235 / 0.7);
}
.border-gray-200\\/80 {
  border-color: rgb(229 231 235 / 0.8);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-300\\/30 {
  border-color: rgb(209 213 219 / 0.3);
}
.border-gray-300\\/60 {
  border-color: rgb(209 213 219 / 0.6);
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-400\\/20 {
  border-color: rgb(156 163 175 / 0.2);
}
.border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity, 1));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-gray-500\\/20 {
  border-color: rgb(107 114 128 / 0.2);
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-gray-700\\/30 {
  border-color: rgb(55 65 81 / 0.3);
}
.border-gray-700\\/50 {
  border-color: rgb(55 65 81 / 0.5);
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.border-gray-950 {
  --tw-border-opacity: 1;
  border-color: rgb(3 7 18 / var(--tw-border-opacity, 1));
}
.border-green-100 {
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity, 1));
}
.border-green-100\\/30 {
  border-color: rgb(220 252 231 / 0.3);
}
.border-green-100\\/50 {
  border-color: rgb(220 252 231 / 0.5);
}
.border-green-100\\/60 {
  border-color: rgb(220 252 231 / 0.6);
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-200\\/50 {
  border-color: rgb(187 247 208 / 0.5);
}
.border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-green-300\\/60 {
  border-color: rgb(134 239 172 / 0.6);
}
.border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-green-400\\/20 {
  border-color: rgb(74 222 128 / 0.2);
}
.border-green-400\\/30 {
  border-color: rgb(74 222 128 / 0.3);
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-green-600 {
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity, 1));
}
.border-indigo-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-100\\/30 {
  border-color: rgb(224 231 255 / 0.3);
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-200\\/60 {
  border-color: rgb(199 210 254 / 0.6);
}
.border-indigo-200\\/70 {
  border-color: rgb(199 210 254 / 0.7);
}
.border-indigo-200\\/80 {
  border-color: rgb(199 210 254 / 0.8);
}
.border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.border-indigo-400 {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-indigo-500\\/30 {
  border-color: rgb(99 102 241 / 0.3);
}
.border-indigo-600 {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-lime-100 {
  --tw-border-opacity: 1;
  border-color: rgb(236 252 203 / var(--tw-border-opacity, 1));
}
.border-lime-200 {
  --tw-border-opacity: 1;
  border-color: rgb(217 249 157 / var(--tw-border-opacity, 1));
}
.border-orange-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity, 1));
}
.border-orange-100\\/30 {
  border-color: rgb(255 237 213 / 0.3);
}
.border-orange-100\\/60 {
  border-color: rgb(255 237 213 / 0.6);
}
.border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-orange-200\\/50 {
  border-color: rgb(254 215 170 / 0.5);
}
.border-orange-200\\/60 {
  border-color: rgb(254 215 170 / 0.6);
}
.border-orange-200\\/70 {
  border-color: rgb(254 215 170 / 0.7);
}
.border-orange-200\\/80 {
  border-color: rgb(254 215 170 / 0.8);
}
.border-orange-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
}
.border-orange-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
}
.border-orange-400\\/20 {
  border-color: rgb(251 146 60 / 0.2);
}
.border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.border-orange-600 {
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity, 1));
}
.border-pink-100 {
  --tw-border-opacity: 1;
  border-color: rgb(252 231 243 / var(--tw-border-opacity, 1));
}
.border-pink-100\\/30 {
  border-color: rgb(252 231 243 / 0.3);
}
.border-pink-100\\/50 {
  border-color: rgb(252 231 243 / 0.5);
}
.border-pink-200 {
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}
.border-pink-300 {
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / var(--tw-border-opacity, 1));
}
.border-pink-400 {
  --tw-border-opacity: 1;
  border-color: rgb(244 114 182 / var(--tw-border-opacity, 1));
}
.border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity, 1));
}
.border-pink-600 {
  --tw-border-opacity: 1;
  border-color: rgb(219 39 119 / var(--tw-border-opacity, 1));
}
.border-primary-100\\/60 {
  border-color: rgb(179 232 224 / 0.6);
}
.border-primary-200 {
  --tw-border-opacity: 1;
  border-color: rgb(128 218 202 / var(--tw-border-opacity, 1));
}
.border-primary-300 {
  --tw-border-opacity: 1;
  border-color: rgb(77 203 181 / var(--tw-border-opacity, 1));
}
.border-primary-500 {
  --tw-border-opacity: 1;
  border-color: rgb(26 145 121 / var(--tw-border-opacity, 1));
}
.border-primary-600 {
  --tw-border-opacity: 1;
  border-color: rgb(22 128 105 / var(--tw-border-opacity, 1));
}
.border-purple-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}
.border-purple-100\\/30 {
  border-color: rgb(243 232 255 / 0.3);
}
.border-purple-100\\/50 {
  border-color: rgb(243 232 255 / 0.5);
}
.border-purple-100\\/60 {
  border-color: rgb(243 232 255 / 0.6);
}
.border-purple-100\\/70 {
  border-color: rgb(243 232 255 / 0.7);
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-200\\/50 {
  border-color: rgb(233 213 255 / 0.5);
}
.border-purple-200\\/60 {
  border-color: rgb(233 213 255 / 0.6);
}
.border-purple-200\\/70 {
  border-color: rgb(233 213 255 / 0.7);
}
.border-purple-200\\/80 {
  border-color: rgb(233 213 255 / 0.8);
}
.border-purple-300 {
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}
.border-purple-400 {
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
}
.border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.border-purple-600 {
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
}
.border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-100\\/50 {
  border-color: rgb(254 226 226 / 0.5);
}
.border-red-100\\/60 {
  border-color: rgb(254 226 226 / 0.6);
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-200\\/50 {
  border-color: rgb(254 202 202 / 0.5);
}
.border-red-200\\/60 {
  border-color: rgb(254 202 202 / 0.6);
}
.border-red-200\\/70 {
  border-color: rgb(254 202 202 / 0.7);
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-400\\/20 {
  border-color: rgb(248 113 113 / 0.2);
}
.border-red-400\\/50 {
  border-color: rgb(248 113 113 / 0.5);
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/20 {
  border-color: rgb(239 68 68 / 0.2);
}
.border-red-500\\/30 {
  border-color: rgb(239 68 68 / 0.3);
}
.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-red-700 {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1));
}
.border-red-800 {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}
.border-rose-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.border-rose-100\\/60 {
  border-color: rgb(255 228 230 / 0.6);
}
.border-rose-100\\/70 {
  border-color: rgb(255 228 230 / 0.7);
}
.border-rose-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-200\\/50 {
  border-color: rgb(254 205 211 / 0.5);
}
.border-rose-200\\/60 {
  border-color: rgb(254 205 211 / 0.6);
}
.border-rose-200\\/70 {
  border-color: rgb(254 205 211 / 0.7);
}
.border-rose-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}
.border-rose-300\\/30 {
  border-color: rgb(253 164 175 / 0.3);
}
.border-rose-300\\/70 {
  border-color: rgb(253 164 175 / 0.7);
}
.border-rose-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity, 1));
}
.border-rose-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.border-rose-600 {
  --tw-border-opacity: 1;
  border-color: rgb(225 29 72 / var(--tw-border-opacity, 1));
}
.border-sky-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity, 1));
}
.border-sky-100\\/50 {
  border-color: rgb(224 242 254 / 0.5);
}
.border-sky-200 {
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.border-sky-400 {
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / var(--tw-border-opacity, 1));
}
.border-sky-500 {
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity, 1));
}
.border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-100\\/80 {
  border-color: rgb(241 245 249 / 0.8);
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/50 {
  border-color: rgb(226 232 240 / 0.5);
}
.border-slate-200\\/60 {
  border-color: rgb(226 232 240 / 0.6);
}
.border-slate-200\\/80 {
  border-color: rgb(226 232 240 / 0.8);
}
.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-400 {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.border-slate-50 {
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity, 1));
}
.border-slate-600 {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.border-slate-800 {
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.border-teal-100 {
  --tw-border-opacity: 1;
  border-color: rgb(204 251 241 / var(--tw-border-opacity, 1));
}
.border-teal-100\\/60 {
  border-color: rgb(204 251 241 / 0.6);
}
.border-teal-100\\/70 {
  border-color: rgb(204 251 241 / 0.7);
}
.border-teal-100\\/80 {
  border-color: rgb(204 251 241 / 0.8);
}
.border-teal-200 {
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity, 1));
}
.border-teal-200\\/50 {
  border-color: rgb(153 246 228 / 0.5);
}
.border-teal-200\\/60 {
  border-color: rgb(153 246 228 / 0.6);
}
.border-teal-200\\/70 {
  border-color: rgb(153 246 228 / 0.7);
}
.border-teal-300 {
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity, 1));
}
.border-teal-300\\/60 {
  border-color: rgb(94 234 212 / 0.6);
}
.border-teal-400 {
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity, 1));
}
.border-teal-400\\/60 {
  border-color: rgb(45 212 191 / 0.6);
}
.border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}
.border-teal-500\\/20 {
  border-color: rgb(20 184 166 / 0.2);
}
.border-teal-500\\/30 {
  border-color: rgb(20 184 166 / 0.3);
}
.border-teal-500\\/40 {
  border-color: rgb(20 184 166 / 0.4);
}
.border-teal-600 {
  --tw-border-opacity: 1;
  border-color: rgb(13 148 136 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-violet-100 {
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity, 1));
}
.border-violet-200 {
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}
.border-violet-200\\/50 {
  border-color: rgb(221 214 254 / 0.5);
}
.border-violet-200\\/60 {
  border-color: rgb(221 214 254 / 0.6);
}
.border-violet-200\\/70 {
  border-color: rgb(221 214 254 / 0.7);
}
.border-violet-300 {
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.border-violet-400 {
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}
.border-violet-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.border-violet-500\\/20 {
  border-color: rgb(139 92 246 / 0.2);
}
.border-violet-600 {
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity, 1));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/30 {
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/40 {
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/5 {
  border-color: rgb(255 255 255 / 0.05);
}
.border-white\\/50 {
  border-color: rgb(255 255 255 / 0.5);
}
.border-white\\/60 {
  border-color: rgb(255 255 255 / 0.6);
}
.border-white\\/70 {
  border-color: rgb(255 255 255 / 0.7);
}
.border-white\\/80 {
  border-color: rgb(255 255 255 / 0.8);
}
.border-white\\/90 {
  border-color: rgb(255 255 255 / 0.9);
}
.border-yellow-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 249 195 / var(--tw-border-opacity, 1));
}
.border-yellow-100\\/30 {
  border-color: rgb(254 249 195 / 0.3);
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-yellow-400 {
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}
.border-l-amber-400 {
  --tw-border-opacity: 1;
  border-left-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-l-blue-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-l-cyan-400 {
  --tw-border-opacity: 1;
  border-left-color: rgb(34 211 238 / var(--tw-border-opacity, 1));
}
.border-l-gray-300 {
  --tw-border-opacity: 1;
  border-left-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-l-green-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-l-orange-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.border-l-pink-600 {
  --tw-border-opacity: 1;
  border-left-color: rgb(219 39 119 / var(--tw-border-opacity, 1));
}
.border-l-primary-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(26 145 121 / var(--tw-border-opacity, 1));
}
.border-l-red-400 {
  --tw-border-opacity: 1;
  border-left-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-l-red-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-l-rose-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.border-l-teal-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}
.border-l-yellow-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}
.border-t-blue-500 {
  --tw-border-opacity: 1;
  border-top-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-t-gray-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-t-indigo-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-t-primary-500 {
  --tw-border-opacity: 1;
  border-top-color: rgb(26 145 121 / var(--tw-border-opacity, 1));
}
.border-t-teal-500 {
  --tw-border-opacity: 1;
  border-top-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}
.border-t-teal-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(13 148 136 / var(--tw-border-opacity, 1));
}
.border-t-transparent {
  border-top-color: transparent;
}
.border-t-white {
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-opacity-20 {
  --tw-border-opacity: 0.2;
}
.bg-\\[\\#0a2540\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(10 37 64 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0fdfa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-100\\/50 {
  background-color: rgb(254 243 199 / 0.5);
}
.bg-amber-100\\/70 {
  background-color: rgb(254 243 199 / 0.7);
}
.bg-amber-100\\/80 {
  background-color: rgb(254 243 199 / 0.8);
}
.bg-amber-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1));
}
.bg-amber-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / var(--tw-bg-opacity, 1));
}
.bg-amber-300\\/30 {
  background-color: rgb(252 211 77 / 0.3);
}
.bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-400\\/15 {
  background-color: rgb(251 191 36 / 0.15);
}
.bg-amber-400\\/40 {
  background-color: rgb(251 191 36 / 0.4);
}
.bg-amber-400\\/60 {
  background-color: rgb(251 191 36 / 0.6);
}
.bg-amber-400\\/80 {
  background-color: rgb(251 191 36 / 0.8);
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/20 {
  background-color: rgb(255 251 235 / 0.2);
}
.bg-amber-50\\/30 {
  background-color: rgb(255 251 235 / 0.3);
}
.bg-amber-50\\/40 {
  background-color: rgb(255 251 235 / 0.4);
}
.bg-amber-50\\/50 {
  background-color: rgb(255 251 235 / 0.5);
}
.bg-amber-50\\/60 {
  background-color: rgb(255 251 235 / 0.6);
}
.bg-amber-50\\/70 {
  background-color: rgb(255 251 235 / 0.7);
}
.bg-amber-50\\/80 {
  background-color: rgb(255 251 235 / 0.8);
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/10 {
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-500\\/30 {
  background-color: rgb(245 158 11 / 0.3);
}
.bg-amber-500\\/90 {
  background-color: rgb(245 158 11 / 0.9);
}
.bg-amber-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/0 {
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/90 {
  background-color: rgb(0 0 0 / 0.9);
}
.bg-black\\/\\[0\\.05\\] {
  background-color: rgb(0 0 0 / 0.05);
}
.bg-black\\/\\[0\\.06\\] {
  background-color: rgb(0 0 0 / 0.06);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-100\\/50 {
  background-color: rgb(219 234 254 / 0.5);
}
.bg-blue-100\\/80 {
  background-color: rgb(219 234 254 / 0.8);
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-200\\/50 {
  background-color: rgb(191 219 254 / 0.5);
}
.bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-400\\/60 {
  background-color: rgb(96 165 250 / 0.6);
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/20 {
  background-color: rgb(239 246 255 / 0.2);
}
.bg-blue-50\\/30 {
  background-color: rgb(239 246 255 / 0.3);
}
.bg-blue-50\\/40 {
  background-color: rgb(239 246 255 / 0.4);
}
.bg-blue-50\\/50 {
  background-color: rgb(239 246 255 / 0.5);
}
.bg-blue-50\\/60 {
  background-color: rgb(239 246 255 / 0.6);
}
.bg-blue-50\\/70 {
  background-color: rgb(239 246 255 / 0.7);
}
.bg-blue-50\\/80 {
  background-color: rgb(239 246 255 / 0.8);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/10 {
  background-color: rgb(59 130 246 / 0.1);
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-current {
  background-color: currentColor;
}
.bg-cyan-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.bg-cyan-100\\/50 {
  background-color: rgb(207 250 254 / 0.5);
}
.bg-cyan-200\\/30 {
  background-color: rgb(165 243 252 / 0.3);
}
.bg-cyan-300\\/20 {
  background-color: rgb(103 232 249 / 0.2);
}
.bg-cyan-300\\/30 {
  background-color: rgb(103 232 249 / 0.3);
}
.bg-cyan-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 211 238 / var(--tw-bg-opacity, 1));
}
.bg-cyan-400\\/20 {
  background-color: rgb(34 211 238 / 0.2);
}
.bg-cyan-400\\/60 {
  background-color: rgb(34 211 238 / 0.6);
}
.bg-cyan-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.bg-cyan-50\\/30 {
  background-color: rgb(236 254 255 / 0.3);
}
.bg-cyan-50\\/40 {
  background-color: rgb(236 254 255 / 0.4);
}
.bg-cyan-50\\/50 {
  background-color: rgb(236 254 255 / 0.5);
}
.bg-cyan-50\\/60 {
  background-color: rgb(236 254 255 / 0.6);
}
.bg-cyan-50\\/90 {
  background-color: rgb(236 254 255 / 0.9);
}
.bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500\\/10 {
  background-color: rgb(6 182 212 / 0.1);
}
.bg-cyan-500\\/20 {
  background-color: rgb(6 182 212 / 0.2);
}
.bg-cyan-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100\\/30 {
  background-color: rgb(209 250 229 / 0.3);
}
.bg-emerald-100\\/80 {
  background-color: rgb(209 250 229 / 0.8);
}
.bg-emerald-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity, 1));
}
.bg-emerald-200\\/60 {
  background-color: rgb(167 243 208 / 0.6);
}
.bg-emerald-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity, 1));
}
.bg-emerald-300\\/30 {
  background-color: rgb(110 231 183 / 0.3);
}
.bg-emerald-300\\/60 {
  background-color: rgb(110 231 183 / 0.6);
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400\\/15 {
  background-color: rgb(52 211 153 / 0.15);
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/30 {
  background-color: rgb(236 253 245 / 0.3);
}
.bg-emerald-50\\/40 {
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-50\\/50 {
  background-color: rgb(236 253 245 / 0.5);
}
.bg-emerald-50\\/60 {
  background-color: rgb(236 253 245 / 0.6);
}
.bg-emerald-50\\/70 {
  background-color: rgb(236 253 245 / 0.7);
}
.bg-emerald-50\\/80 {
  background-color: rgb(236 253 245 / 0.8);
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10 {
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/20 {
  background-color: rgb(16 185 129 / 0.2);
}
.bg-emerald-500\\/80 {
  background-color: rgb(16 185 129 / 0.8);
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600\\/90 {
  background-color: rgb(5 150 105 / 0.9);
}
.bg-emerald-900\\/15 {
  background-color: rgb(6 78 59 / 0.15);
}
.bg-fuchsia-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 232 255 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(232 121 249 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-50\\/40 {
  background-color: rgb(253 244 255 / 0.4);
}
.bg-fuchsia-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-900\\/15 {
  background-color: rgb(112 26 117 / 0.15);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-100\\/50 {
  background-color: rgb(243 244 246 / 0.5);
}
.bg-gray-100\\/60 {
  background-color: rgb(243 244 246 / 0.6);
}
.bg-gray-100\\/80 {
  background-color: rgb(243 244 246 / 0.8);
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-200\\/50 {
  background-color: rgb(229 231 235 / 0.5);
}
.bg-gray-200\\/60 {
  background-color: rgb(229 231 235 / 0.6);
}
.bg-gray-200\\/70 {
  background-color: rgb(229 231 235 / 0.7);
}
.bg-gray-200\\/80 {
  background-color: rgb(229 231 235 / 0.8);
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-400\\/10 {
  background-color: rgb(156 163 175 / 0.1);
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/20 {
  background-color: rgb(249 250 251 / 0.2);
}
.bg-gray-50\\/30 {
  background-color: rgb(249 250 251 / 0.3);
}
.bg-gray-50\\/40 {
  background-color: rgb(249 250 251 / 0.4);
}
.bg-gray-50\\/50 {
  background-color: rgb(249 250 251 / 0.5);
}
.bg-gray-50\\/60 {
  background-color: rgb(249 250 251 / 0.6);
}
.bg-gray-50\\/70 {
  background-color: rgb(249 250 251 / 0.7);
}
.bg-gray-50\\/80 {
  background-color: rgb(249 250 251 / 0.8);
}
.bg-gray-50\\/90 {
  background-color: rgb(249 250 251 / 0.9);
}
.bg-gray-50\\/95 {
  background-color: rgb(249 250 251 / 0.95);
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-500\\/10 {
  background-color: rgb(107 114 128 / 0.1);
}
.bg-gray-500\\/20 {
  background-color: rgb(107 114 128 / 0.2);
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-800\\/30 {
  background-color: rgb(31 41 55 / 0.3);
}
.bg-gray-800\\/50 {
  background-color: rgb(31 41 55 / 0.5);
}
.bg-gray-800\\/90 {
  background-color: rgb(31 41 55 / 0.9);
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-gray-900\\/10 {
  background-color: rgb(17 24 39 / 0.1);
}
.bg-gray-900\\/20 {
  background-color: rgb(17 24 39 / 0.2);
}
.bg-gray-900\\/40 {
  background-color: rgb(17 24 39 / 0.4);
}
.bg-gray-900\\/50 {
  background-color: rgb(17 24 39 / 0.5);
}
.bg-gray-900\\/60 {
  background-color: rgb(17 24 39 / 0.6);
}
.bg-gray-900\\/70 {
  background-color: rgb(17 24 39 / 0.7);
}
.bg-gray-900\\/90 {
  background-color: rgb(17 24 39 / 0.9);
}
.bg-gray-900\\/\\[0\\.06\\] {
  background-color: rgb(17 24 39 / 0.06);
}
.bg-gray-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity, 1));
}
.bg-gray-950\\/50 {
  background-color: rgb(3 7 18 / 0.5);
}
.bg-gray-950\\/70 {
  background-color: rgb(3 7 18 / 0.7);
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-100\\/70 {
  background-color: rgb(220 252 231 / 0.7);
}
.bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
.bg-green-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity, 1));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-400\\/40 {
  background-color: rgb(74 222 128 / 0.4);
}
.bg-green-400\\/80 {
  background-color: rgb(74 222 128 / 0.8);
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-50\\/20 {
  background-color: rgb(240 253 244 / 0.2);
}
.bg-green-50\\/30 {
  background-color: rgb(240 253 244 / 0.3);
}
.bg-green-50\\/40 {
  background-color: rgb(240 253 244 / 0.4);
}
.bg-green-50\\/50 {
  background-color: rgb(240 253 244 / 0.5);
}
.bg-green-50\\/60 {
  background-color: rgb(240 253 244 / 0.6);
}
.bg-green-50\\/70 {
  background-color: rgb(240 253 244 / 0.7);
}
.bg-green-50\\/80 {
  background-color: rgb(240 253 244 / 0.8);
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/10 {
  background-color: rgb(34 197 94 / 0.1);
}
.bg-green-500\\/20 {
  background-color: rgb(34 197 94 / 0.2);
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-200\\/60 {
  background-color: rgb(199 210 254 / 0.6);
}
.bg-indigo-300\\/70 {
  background-color: rgb(165 180 252 / 0.7);
}
.bg-indigo-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}
.bg-indigo-400\\/60 {
  background-color: rgb(129 140 248 / 0.6);
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/20 {
  background-color: rgb(238 242 255 / 0.2);
}
.bg-indigo-50\\/30 {
  background-color: rgb(238 242 255 / 0.3);
}
.bg-indigo-50\\/40 {
  background-color: rgb(238 242 255 / 0.4);
}
.bg-indigo-50\\/50 {
  background-color: rgb(238 242 255 / 0.5);
}
.bg-indigo-50\\/60 {
  background-color: rgb(238 242 255 / 0.6);
}
.bg-indigo-50\\/80 {
  background-color: rgb(238 242 255 / 0.8);
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500\\/20 {
  background-color: rgb(99 102 241 / 0.2);
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-indigo-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.bg-lime-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity, 1));
}
.bg-lime-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(247 254 231 / var(--tw-bg-opacity, 1));
}
.bg-lime-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity, 1));
}
.bg-orange-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity, 1));
}
.bg-orange-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-50\\/20 {
  background-color: rgb(255 247 237 / 0.2);
}
.bg-orange-50\\/30 {
  background-color: rgb(255 247 237 / 0.3);
}
.bg-orange-50\\/40 {
  background-color: rgb(255 247 237 / 0.4);
}
.bg-orange-50\\/50 {
  background-color: rgb(255 247 237 / 0.5);
}
.bg-orange-50\\/60 {
  background-color: rgb(255 247 237 / 0.6);
}
.bg-orange-50\\/80 {
  background-color: rgb(255 247 237 / 0.8);
}
.bg-orange-50\\/90 {
  background-color: rgb(255 247 237 / 0.9);
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-500\\/10 {
  background-color: rgb(249 115 22 / 0.1);
}
.bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-orange-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity, 1));
}
.bg-pink-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
.bg-pink-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1));
}
.bg-pink-400\\/30 {
  background-color: rgb(244 114 182 / 0.3);
}
.bg-pink-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.bg-pink-50\\/20 {
  background-color: rgb(253 242 248 / 0.2);
}
.bg-pink-50\\/30 {
  background-color: rgb(253 242 248 / 0.3);
}
.bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity, 1));
}
.bg-pink-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity, 1));
}
.bg-primary-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(179 232 224 / var(--tw-bg-opacity, 1));
}
.bg-primary-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(230 247 245 / var(--tw-bg-opacity, 1));
}
.bg-primary-50\\/50 {
  background-color: rgb(230 247 245 / 0.5);
}
.bg-primary-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(26 145 121 / var(--tw-bg-opacity, 1));
}
.bg-primary-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 128 105 / var(--tw-bg-opacity, 1));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-100\\/70 {
  background-color: rgb(243 232 255 / 0.7);
}
.bg-purple-100\\/80 {
  background-color: rgb(243 232 255 / 0.8);
}
.bg-purple-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(216 180 254 / var(--tw-bg-opacity, 1));
}
.bg-purple-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1));
}
.bg-purple-400\\/10 {
  background-color: rgb(192 132 252 / 0.1);
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50\\/20 {
  background-color: rgb(250 245 255 / 0.2);
}
.bg-purple-50\\/30 {
  background-color: rgb(250 245 255 / 0.3);
}
.bg-purple-50\\/40 {
  background-color: rgb(250 245 255 / 0.4);
}
.bg-purple-50\\/50 {
  background-color: rgb(250 245 255 / 0.5);
}
.bg-purple-50\\/60 {
  background-color: rgb(250 245 255 / 0.6);
}
.bg-purple-50\\/70 {
  background-color: rgb(250 245 255 / 0.7);
}
.bg-purple-50\\/80 {
  background-color: rgb(250 245 255 / 0.8);
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-purple-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 33 168 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-100\\/80 {
  background-color: rgb(254 226 226 / 0.8);
}
.bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
.bg-red-200\\/50 {
  background-color: rgb(254 202 202 / 0.5);
}
.bg-red-200\\/60 {
  background-color: rgb(254 202 202 / 0.6);
}
.bg-red-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1));
}
.bg-red-300\\/30 {
  background-color: rgb(252 165 165 / 0.3);
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-400\\/80 {
  background-color: rgb(248 113 113 / 0.8);
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/20 {
  background-color: rgb(254 242 242 / 0.2);
}
.bg-red-50\\/30 {
  background-color: rgb(254 242 242 / 0.3);
}
.bg-red-50\\/40 {
  background-color: rgb(254 242 242 / 0.4);
}
.bg-red-50\\/50 {
  background-color: rgb(254 242 242 / 0.5);
}
.bg-red-50\\/60 {
  background-color: rgb(254 242 242 / 0.6);
}
.bg-red-50\\/70 {
  background-color: rgb(254 242 242 / 0.7);
}
.bg-red-50\\/80 {
  background-color: rgb(254 242 242 / 0.8);
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10 {
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/20 {
  background-color: rgb(239 68 68 / 0.2);
}
.bg-red-500\\/30 {
  background-color: rgb(239 68 68 / 0.3);
}
.bg-red-500\\/80 {
  background-color: rgb(239 68 68 / 0.8);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.bg-red-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity, 1));
}
.bg-rose-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-100\\/50 {
  background-color: rgb(255 228 230 / 0.5);
}
.bg-rose-200\\/30 {
  background-color: rgb(254 205 211 / 0.3);
}
.bg-rose-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity, 1));
}
.bg-rose-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/20 {
  background-color: rgb(255 241 242 / 0.2);
}
.bg-rose-50\\/30 {
  background-color: rgb(255 241 242 / 0.3);
}
.bg-rose-50\\/40 {
  background-color: rgb(255 241 242 / 0.4);
}
.bg-rose-50\\/50 {
  background-color: rgb(255 241 242 / 0.5);
}
.bg-rose-50\\/60 {
  background-color: rgb(255 241 242 / 0.6);
}
.bg-rose-50\\/70 {
  background-color: rgb(255 241 242 / 0.7);
}
.bg-rose-50\\/80 {
  background-color: rgb(255 241 242 / 0.8);
}
.bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-rose-500\\/10 {
  background-color: rgb(244 63 94 / 0.1);
}
.bg-rose-500\\/15 {
  background-color: rgb(244 63 94 / 0.15);
}
.bg-rose-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.bg-rose-600\\/90 {
  background-color: rgb(225 29 72 / 0.9);
}
.bg-sky-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity, 1));
}
.bg-sky-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-sky-50\\/40 {
  background-color: rgb(240 249 255 / 0.4);
}
.bg-sky-50\\/80 {
  background-color: rgb(240 249 255 / 0.8);
}
.bg-sky-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-100\\/70 {
  background-color: rgb(241 245 249 / 0.7);
}
.bg-slate-100\\/80 {
  background-color: rgb(241 245 249 / 0.8);
}
.bg-slate-100\\/90 {
  background-color: rgb(241 245 249 / 0.9);
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-200\\/50 {
  background-color: rgb(226 232 240 / 0.5);
}
.bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/40 {
  background-color: rgb(248 250 252 / 0.4);
}
.bg-slate-50\\/50 {
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-50\\/60 {
  background-color: rgb(248 250 252 / 0.6);
}
.bg-slate-50\\/70 {
  background-color: rgb(248 250 252 / 0.7);
}
.bg-slate-50\\/80 {
  background-color: rgb(248 250 252 / 0.8);
}
.bg-slate-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
.bg-slate-500\\/10 {
  background-color: rgb(100 116 139 / 0.1);
}
.bg-slate-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-800\\/95 {
  background-color: rgb(30 41 59 / 0.95);
}
.bg-slate-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/45 {
  background-color: rgb(15 23 42 / 0.45);
}
.bg-slate-900\\/95 {
  background-color: rgb(15 23 42 / 0.95);
}
.bg-slate-950\\/45 {
  background-color: rgb(2 6 23 / 0.45);
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}
.bg-teal-100\\/40 {
  background-color: rgb(204 251 241 / 0.4);
}
.bg-teal-100\\/50 {
  background-color: rgb(204 251 241 / 0.5);
}
.bg-teal-100\\/70 {
  background-color: rgb(204 251 241 / 0.7);
}
.bg-teal-100\\/80 {
  background-color: rgb(204 251 241 / 0.8);
}
.bg-teal-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / var(--tw-bg-opacity, 1));
}
.bg-teal-200\\/30 {
  background-color: rgb(153 246 228 / 0.3);
}
.bg-teal-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(94 234 212 / var(--tw-bg-opacity, 1));
}
.bg-teal-300\\/30 {
  background-color: rgb(94 234 212 / 0.3);
}
.bg-teal-300\\/60 {
  background-color: rgb(94 234 212 / 0.6);
}
.bg-teal-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity, 1));
}
.bg-teal-400\\/10 {
  background-color: rgb(45 212 191 / 0.1);
}
.bg-teal-400\\/20 {
  background-color: rgb(45 212 191 / 0.2);
}
.bg-teal-400\\/60 {
  background-color: rgb(45 212 191 / 0.6);
}
.bg-teal-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-teal-50\\/20 {
  background-color: rgb(240 253 250 / 0.2);
}
.bg-teal-50\\/30 {
  background-color: rgb(240 253 250 / 0.3);
}
.bg-teal-50\\/40 {
  background-color: rgb(240 253 250 / 0.4);
}
.bg-teal-50\\/50 {
  background-color: rgb(240 253 250 / 0.5);
}
.bg-teal-50\\/60 {
  background-color: rgb(240 253 250 / 0.6);
}
.bg-teal-50\\/70 {
  background-color: rgb(240 253 250 / 0.7);
}
.bg-teal-50\\/80 {
  background-color: rgb(240 253 250 / 0.8);
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
.bg-teal-500\\/10 {
  background-color: rgb(20 184 166 / 0.1);
}
.bg-teal-500\\/15 {
  background-color: rgb(20 184 166 / 0.15);
}
.bg-teal-500\\/20 {
  background-color: rgb(20 184 166 / 0.2);
}
.bg-teal-500\\/80 {
  background-color: rgb(20 184 166 / 0.8);
}
.bg-teal-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity, 1));
}
.bg-teal-600\\/10 {
  background-color: rgb(13 148 136 / 0.1);
}
.bg-teal-600\\/40 {
  background-color: rgb(13 148 136 / 0.4);
}
.bg-teal-600\\/70 {
  background-color: rgb(13 148 136 / 0.7);
}
.bg-transparent {
  background-color: transparent;
}
.bg-violet-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-violet-300\\/15 {
  background-color: rgb(196 181 253 / 0.15);
}
.bg-violet-300\\/20 {
  background-color: rgb(196 181 253 / 0.2);
}
.bg-violet-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity, 1));
}
.bg-violet-400\\/60 {
  background-color: rgb(167 139 250 / 0.6);
}
.bg-violet-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-50\\/30 {
  background-color: rgb(245 243 255 / 0.3);
}
.bg-violet-50\\/40 {
  background-color: rgb(245 243 255 / 0.4);
}
.bg-violet-50\\/50 {
  background-color: rgb(245 243 255 / 0.5);
}
.bg-violet-50\\/60 {
  background-color: rgb(245 243 255 / 0.6);
}
.bg-violet-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-violet-500\\/10 {
  background-color: rgb(139 92 246 / 0.1);
}
.bg-violet-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/0 {
  background-color: rgb(255 255 255 / 0);
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/25 {
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/40 {
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/5 {
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/75 {
  background-color: rgb(255 255 255 / 0.75);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/85 {
  background-color: rgb(255 255 255 / 0.85);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-100\\/30 {
  background-color: rgb(254 249 195 / 0.3);
}
.bg-yellow-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity, 1));
}
.bg-yellow-200\\/50 {
  background-color: rgb(254 240 138 / 0.5);
}
.bg-yellow-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity, 1));
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50\\/20 {
  background-color: rgb(254 252 232 / 0.2);
}
.bg-yellow-50\\/40 {
  background-color: rgb(254 252 232 / 0.4);
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.bg-opacity-10 {
  --tw-bg-opacity: 0.1;
}
.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
.bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}
.bg-opacity-75 {
  --tw-bg-opacity: 0.75;
}
.bg-\\[linear-gradient\\(to_top\\2c \\#ffffff\\2c transparent_30\\%\\)\\2c linear-gradient\\(to_bottom_right\\2c \\#f0fdfa\\2c \\#ffffff_55\\%\\2c \\#ecfeff\\)\\] {
  background-image: linear-gradient(to top,#ffffff,transparent 30%),linear-gradient(to bottom right,#f0fdfa,#ffffff 55%,#ecfeff);
}
.bg-\\[radial-gradient\\(ellipse_70\\%_50\\%_at_50\\%_0\\%\\2c _var\\(--tw-gradient-stops\\)\\)\\] {
  background-image: radial-gradient(ellipse 70% 50% at 50% 0%, var(--tw-gradient-stops));
}
.bg-\\[radial-gradient\\(ellipse_70\\%_50\\%_at_50\\%_25\\%\\2c _var\\(--tw-gradient-stops\\)\\)\\] {
  background-image: radial-gradient(ellipse 70% 50% at 50% 25%, var(--tw-gradient-stops));
}
.bg-\\[radial-gradient\\(ellipse_at_top_right\\2c _var\\(--tw-gradient-stops\\)\\)\\] {
  background-image: radial-gradient(ellipse at top right, var(--tw-gradient-stops));
}
.bg-\\[url\\(\\'data\\:image\\/svg\\+xml\\2c \\%3Csvg\\%20xmlns\\=\\%27http\\:\\/\\/www\\.w3\\.org\\/2000\\/svg\\%27\\%20width\\=\\%27200\\%27\\%20height\\=\\%27200\\%27\\%3E\\%3Cfilter\\%20id\\=\\%27n\\%27\\%3E\\%3CfeTurbulence\\%20type\\=\\%27fractalNoise\\%27\\%20baseFrequency\\=\\%270\\.9\\%27\\%20numOctaves\\=\\%273\\%27\\%20stitchTiles\\=\\%27stitch\\%27\\/\\%3E\\%3C\\/filter\\%3E\\%3Crect\\%20width\\=\\%27100\\%25\\%27\\%20height\\=\\%27100\\%25\\%27\\%20filter\\=\\%27url\\(\\%23n\\)\\%27\\%20opacity\\=\\%270\\.4\\%27\\/\\%3E\\%3C\\/svg\\%3E\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.bg-\\[url\\(\\'data\\:image\\/svg\\+xml\\;base64\\2c PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI\\+PHBhdGggZD0iTTEgMS41TDYgNi41TDExIDEuNSIgc3Ryb2tlPSIjNkI3MjgwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8\\+PC9zdmc\\+\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.bg-\\[url\\(\\'data\\:image\\/svg\\+xml\\;base64\\2c PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIj48ZmlsdGVyIGlkPSJuIj48ZmVUdXJidWxlbmNlIHR5cGU9ImZyYWN0YWxOb2lzZSIgYmFzZUZyZXF1ZW5jeT0iLjciIG51bU9jdGF2ZXM9IjEwIiBzdGl0Y2hUaWxlcz0ic3RpdGNoIi8\\+PC9maWx0ZXI\\+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsdGVyPSJ1cmwoI24pIiBvcGFjaXR5PSIuMSIvPjwvc3ZnPg\\=\\=\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.bg-\\[url\\(\\'data\\:image\\/svg\\+xml\\;charset\\=UTF-8\\2c \\%3csvg\\%20xmlns\\=\\%27http\\:\\/\\/www\\.w3\\.org\\/2000\\/svg\\%27\\%20viewBox\\=\\%270\\%200\\%2024\\%2024\\%27\\%20fill\\=\\%27none\\%27\\%20stroke\\=\\%27\\%236b7280\\%27\\%20stroke-width\\=\\%272\\%27\\%20stroke-linecap\\=\\%27round\\%27\\%20stroke-linejoin\\=\\%27round\\%27\\%3e\\%3cpolyline\\%20points\\=\\%276\\%209\\%2012\\%2015\\%2018\\%209\\%27\\%3e\\%3c\\/polyline\\%3e\\%3c\\/svg\\%3e\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.bg-\\[url\\(\\'data\\:image\\/svg\\+xml\\;charset\\=UTF-8\\2c \\%3csvg\\%20xmlns\\=\\%27http\\:\\/\\/www\\.w3\\.org\\/2000\\/svg\\%27\\%20viewBox\\=\\%270\\%200\\%2024\\%2024\\%27\\%20fill\\=\\%27none\\%27\\%20stroke\\=\\%27\\%23d97706\\%27\\%20stroke-width\\=\\%272\\%27\\%20stroke-linecap\\=\\%27round\\%27\\%20stroke-linejoin\\=\\%27round\\%27\\%3e\\%3cpolyline\\%20points\\=\\%276\\%209\\%2012\\%2015\\%2018\\%209\\%27\\%3e\\%3c\\/polyline\\%3e\\%3c\\/svg\\%3e\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-amber-400 {
  --tw-gradient-from: #fbbf24 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50 {
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50\\/30 {
  --tw-gradient-from: rgb(255 251 235 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50\\/80 {
  --tw-gradient-from: rgb(255 251 235 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500 {
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500\\/10 {
  --tw-gradient-from: rgb(245 158 11 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/70 {
  --tw-gradient-from: rgb(0 0 0 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-100 {
  --tw-gradient-from: #dbeafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 234 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-200\\/60 {
  --tw-gradient-from: rgb(191 219 254 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(191 219 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400 {
  --tw-gradient-from: #60a5fa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50 {
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/40 {
  --tw-gradient-from: rgb(239 246 255 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/80 {
  --tw-gradient-from: rgb(239 246 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500 {
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500\\/10 {
  --tw-gradient-from: rgb(59 130 246 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600 {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-100 {
  --tw-gradient-from: #cffafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(207 250 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-200\\/60 {
  --tw-gradient-from: rgb(165 243 252 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(165 243 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-400 {
  --tw-gradient-from: #22d3ee var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 211 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-50 {
  --tw-gradient-from: #ecfeff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 254 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500 {
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-600 {
  --tw-gradient-from: #0891b2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(8 145 178 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-400 {
  --tw-gradient-from: #34d399 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50 {
  --tw-gradient-from: #ecfdf5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50\\/30 {
  --tw-gradient-from: rgb(236 253 245 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50\\/80 {
  --tw-gradient-from: rgb(236 253 245 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500 {
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500\\/5 {
  --tw-gradient-from: rgb(16 185 129 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-600 {
  --tw-gradient-from: #059669 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 150 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-fuchsia-400 {
  --tw-gradient-from: #e879f9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(232 121 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-100\\/90 {
  --tw-gradient-from: rgb(243 244 246 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 244 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-200 {
  --tw-gradient-from: #e5e7eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(229 231 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-400 {
  --tw-gradient-from: #9ca3af var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 163 175 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50 {
  --tw-gradient-from: #f9fafb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50\\/40 {
  --tw-gradient-from: rgb(249 250 251 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50\\/50 {
  --tw-gradient-from: rgb(249 250 251 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50\\/80 {
  --tw-gradient-from: rgb(249 250 251 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-500 {
  --tw-gradient-from: #6b7280 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(107 114 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-600 {
  --tw-gradient-from: #4b5563 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(75 85 99 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-700 {
  --tw-gradient-from: #374151 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(55 65 81 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-800 {
  --tw-gradient-from: #1f2937 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(31 41 55 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900 {
  --tw-gradient-from: #111827 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900\\/80 {
  --tw-gradient-from: rgb(17 24 39 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-100 {
  --tw-gradient-from: #dcfce7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 252 231 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-400 {
  --tw-gradient-from: #4ade80 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(74 222 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-50 {
  --tw-gradient-from: #f0fdf4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 244 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500 {
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600 {
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-100 {
  --tw-gradient-from: #e0e7ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(224 231 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-400 {
  --tw-gradient-from: #818cf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(129 140 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50 {
  --tw-gradient-from: #eef2ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/60 {
  --tw-gradient-from: rgb(238 242 255 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/80 {
  --tw-gradient-from: rgb(238 242 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500 {
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600 {
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lime-500 {
  --tw-gradient-from: #84cc16 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(132 204 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-100 {
  --tw-gradient-from: #ffedd5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 237 213 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-200\\/60 {
  --tw-gradient-from: rgb(254 215 170 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 215 170 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-400 {
  --tw-gradient-from: #fb923c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-50 {
  --tw-gradient-from: #fff7ed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-50\\/40 {
  --tw-gradient-from: rgb(255 247 237 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500 {
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500\\/10 {
  --tw-gradient-from: rgb(249 115 22 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-600 {
  --tw-gradient-from: #ea580c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 88 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-100 {
  --tw-gradient-from: #fce7f3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(252 231 243 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-400 {
  --tw-gradient-from: #f472b6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 114 182 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-50 {
  --tw-gradient-from: #fdf2f8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 242 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-50\\/50 {
  --tw-gradient-from: rgb(253 242 248 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 242 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-50\\/60 {
  --tw-gradient-from: rgb(253 242 248 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 242 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-50\\/80 {
  --tw-gradient-from: rgb(253 242 248 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 242 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500 {
  --tw-gradient-from: #ec4899 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-600 {
  --tw-gradient-from: #db2777 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 39 119 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-400 {
  --tw-gradient-from: #2dbea5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(45 190 165 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-50 {
  --tw-gradient-from: #e6f7f5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(230 247 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-500 {
  --tw-gradient-from: #1a9179 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 145 121 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-100 {
  --tw-gradient-from: #f3e8ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 232 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-200\\/60 {
  --tw-gradient-from: rgb(233 213 255 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(233 213 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-300 {
  --tw-gradient-from: #d8b4fe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(216 180 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-400 {
  --tw-gradient-from: #c084fc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 132 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-400\\/70 {
  --tw-gradient-from: rgb(192 132 252 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 132 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50 {
  --tw-gradient-from: #faf5ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50\\/40 {
  --tw-gradient-from: rgb(250 245 255 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50\\/50 {
  --tw-gradient-from: rgb(250 245 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50\\/80 {
  --tw-gradient-from: rgb(250 245 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500 {
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500\\/10 {
  --tw-gradient-from: rgb(168 85 247 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600 {
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-400 {
  --tw-gradient-from: #f87171 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 113 113 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-50 {
  --tw-gradient-from: #fef2f2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 242 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-50\\/50 {
  --tw-gradient-from: rgb(254 242 242 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 242 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500 {
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-600 {
  --tw-gradient-from: #dc2626 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 38 38 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-400 {
  --tw-gradient-from: #fb7185 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 113 133 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-50 {
  --tw-gradient-from: #fff1f2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 241 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-50\\/30 {
  --tw-gradient-from: rgb(255 241 242 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 241 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-50\\/80 {
  --tw-gradient-from: rgb(255 241 242 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 241 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-500 {
  --tw-gradient-from: #f43f5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 63 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-400 {
  --tw-gradient-from: #38bdf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(56 189 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-50 {
  --tw-gradient-from: #f0f9ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 249 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-500 {
  --tw-gradient-from: #0ea5e9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-100 {
  --tw-gradient-from: #f1f5f9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(241 245 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-200\\/60 {
  --tw-gradient-from: rgb(226 232 240 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(226 232 240 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-400 {
  --tw-gradient-from: #94a3b8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(148 163 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50 {
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50\\/50 {
  --tw-gradient-from: rgb(248 250 252 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-500 {
  --tw-gradient-from: #64748b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(100 116 139 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-600 {
  --tw-gradient-from: #475569 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(71 85 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-700 {
  --tw-gradient-from: #334155 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(51 65 85 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900\\/80 {
  --tw-gradient-from: rgb(15 23 42 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-100 {
  --tw-gradient-from: #ccfbf1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(204 251 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-100\\/40 {
  --tw-gradient-from: rgb(204 251 241 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(204 251 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-100\\/50 {
  --tw-gradient-from: rgb(204 251 241 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(204 251 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-100\\/60 {
  --tw-gradient-from: rgb(204 251 241 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(204 251 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-100\\/80 {
  --tw-gradient-from: rgb(204 251 241 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(204 251 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-400 {
  --tw-gradient-from: #2dd4bf var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(45 212 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-400\\/0 {
  --tw-gradient-from: rgb(45 212 191 / 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(45 212 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-400\\/15 {
  --tw-gradient-from: rgb(45 212 191 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(45 212 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-400\\/20 {
  --tw-gradient-from: rgb(45 212 191 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(45 212 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-400\\/25 {
  --tw-gradient-from: rgb(45 212 191 / 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(45 212 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-50 {
  --tw-gradient-from: #f0fdfa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-50\\/30 {
  --tw-gradient-from: rgb(240 253 250 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-50\\/40 {
  --tw-gradient-from: rgb(240 253 250 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-50\\/50 {
  --tw-gradient-from: rgb(240 253 250 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-50\\/60 {
  --tw-gradient-from: rgb(240 253 250 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-50\\/70 {
  --tw-gradient-from: rgb(240 253 250 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-50\\/80 {
  --tw-gradient-from: rgb(240 253 250 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-500 {
  --tw-gradient-from: #14b8a6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-500\\/10 {
  --tw-gradient-from: rgb(20 184 166 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-500\\/5 {
  --tw-gradient-from: rgb(20 184 166 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-600 {
  --tw-gradient-from: #0d9488 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(13 148 136 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-700 {
  --tw-gradient-from: #0f766e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 118 110 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-950 {
  --tw-gradient-from: #042f2e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(4 47 46 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-400 {
  --tw-gradient-from: #a78bfa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(167 139 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-50 {
  --tw-gradient-from: #f5f3ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 243 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500 {
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/35 {
  --tw-gradient-from: rgb(255 255 255 / 0.35) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/90 {
  --tw-gradient-from: rgb(255 255 255 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-200 {
  --tw-gradient-from: #fef08a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 240 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-500 {
  --tw-gradient-from: #eab308 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 179 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-amber-50 {
  --tw-gradient-to: rgb(255 251 235 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fffbeb var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-300\\/10 {
  --tw-gradient-to: rgb(103 232 249 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(103 232 249 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-300\\/20 {
  --tw-gradient-to: rgb(103 232 249 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(103 232 249 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-50 {
  --tw-gradient-to: rgb(236 254 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ecfeff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-500 {
  --tw-gradient-to: rgb(6 182 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #06b6d4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-emerald-500 {
  --tw-gradient-to: rgb(16 185 129 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #10b981 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-emerald-500\\/5 {
  --tw-gradient-to: rgb(16 185 129 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(16 185 129 / 0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gray-100 {
  --tw-gradient-to: rgb(243 244 246 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f3f4f6 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gray-700 {
  --tw-gradient-to: rgb(55 65 81 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #374151 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gray-800 {
  --tw-gradient-to: rgb(31 41 55 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1f2937 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gray-900 {
  --tw-gradient-to: rgb(17 24 39 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #111827 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-green-200 {
  --tw-gradient-to: rgb(187 247 208 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #bbf7d0 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-500 {
  --tw-gradient-to: rgb(99 102 241 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6366f1 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-orange-400 {
  --tw-gradient-to: rgb(251 146 60 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fb923c var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-orange-50 {
  --tw-gradient-to: rgb(255 247 237 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff7ed var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-orange-500 {
  --tw-gradient-to: rgb(249 115 22 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f97316 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-orange-600 {
  --tw-gradient-to: rgb(234 88 12 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ea580c var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-50 {
  --tw-gradient-to: rgb(250 245 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #faf5ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-500 {
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-red-600 {
  --tw-gradient-to: rgb(220 38 38 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #dc2626 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-rose-50 {
  --tw-gradient-to: rgb(255 241 242 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff1f2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-sky-50 {
  --tw-gradient-to: rgb(240 249 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f0f9ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-100 {
  --tw-gradient-to: rgb(241 245 249 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f1f5f9 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-200\\/40 {
  --tw-gradient-to: rgb(226 232 240 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(226 232 240 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-50 {
  --tw-gradient-to: rgb(248 250 252 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f8fafc var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-700 {
  --tw-gradient-to: rgb(51 65 85 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #334155 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-900\\/70 {
  --tw-gradient-to: rgb(15 23 42 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(15 23 42 / 0.7) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-300\\/60 {
  --tw-gradient-to: rgb(94 234 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(94 234 212 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-400 {
  --tw-gradient-to: rgb(45 212 191 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #2dd4bf var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-400\\/10 {
  --tw-gradient-to: rgb(45 212 191 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(45 212 191 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-50\\/30 {
  --tw-gradient-to: rgb(240 253 250 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(240 253 250 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-500 {
  --tw-gradient-to: rgb(20 184 166 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #14b8a6 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-500\\/20 {
  --tw-gradient-to: rgb(20 184 166 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(20 184 166 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-500\\/5 {
  --tw-gradient-to: rgb(20 184 166 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(20 184 166 / 0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-800 {
  --tw-gradient-to: rgb(17 94 89 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #115e59 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/30 {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/60 {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/75 {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.75) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-yellow-400 {
  --tw-gradient-to: rgb(250 204 21 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #facc15 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-amber-100 {
  --tw-gradient-to: #fef3c7 var(--tw-gradient-to-position);
}
.to-amber-100\\/50 {
  --tw-gradient-to: rgb(254 243 199 / 0.5) var(--tw-gradient-to-position);
}
.to-amber-200 {
  --tw-gradient-to: #fde68a var(--tw-gradient-to-position);
}
.to-amber-300\\/70 {
  --tw-gradient-to: rgb(252 211 77 / 0.7) var(--tw-gradient-to-position);
}
.to-amber-400 {
  --tw-gradient-to: #fbbf24 var(--tw-gradient-to-position);
}
.to-amber-50 {
  --tw-gradient-to: #fffbeb var(--tw-gradient-to-position);
}
.to-amber-50\\/30 {
  --tw-gradient-to: rgb(255 251 235 / 0.3) var(--tw-gradient-to-position);
}
.to-amber-50\\/60 {
  --tw-gradient-to: rgb(255 251 235 / 0.6) var(--tw-gradient-to-position);
}
.to-amber-500 {
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
}
.to-amber-500\\/5 {
  --tw-gradient-to: rgb(245 158 11 / 0.05) var(--tw-gradient-to-position);
}
.to-amber-600 {
  --tw-gradient-to: #d97706 var(--tw-gradient-to-position);
}
.to-amber-700 {
  --tw-gradient-to: #b45309 var(--tw-gradient-to-position);
}
.to-black\\/10 {
  --tw-gradient-to: rgb(0 0 0 / 0.1) var(--tw-gradient-to-position);
}
.to-blue-100 {
  --tw-gradient-to: #dbeafe var(--tw-gradient-to-position);
}
.to-blue-100\\/50 {
  --tw-gradient-to: rgb(219 234 254 / 0.5) var(--tw-gradient-to-position);
}
.to-blue-50 {
  --tw-gradient-to: #eff6ff var(--tw-gradient-to-position);
}
.to-blue-50\\/50 {
  --tw-gradient-to: rgb(239 246 255 / 0.5) var(--tw-gradient-to-position);
}
.to-blue-50\\/80 {
  --tw-gradient-to: rgb(239 246 255 / 0.8) var(--tw-gradient-to-position);
}
.to-blue-500 {
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-blue-600 {
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.to-blue-700 {
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}
.to-cyan-100\\/80 {
  --tw-gradient-to: rgb(207 250 254 / 0.8) var(--tw-gradient-to-position);
}
.to-cyan-200 {
  --tw-gradient-to: #a5f3fc var(--tw-gradient-to-position);
}
.to-cyan-300 {
  --tw-gradient-to: #67e8f9 var(--tw-gradient-to-position);
}
.to-cyan-400 {
  --tw-gradient-to: #22d3ee var(--tw-gradient-to-position);
}
.to-cyan-400\\/10 {
  --tw-gradient-to: rgb(34 211 238 / 0.1) var(--tw-gradient-to-position);
}
.to-cyan-50 {
  --tw-gradient-to: #ecfeff var(--tw-gradient-to-position);
}
.to-cyan-50\\/20 {
  --tw-gradient-to: rgb(236 254 255 / 0.2) var(--tw-gradient-to-position);
}
.to-cyan-50\\/30 {
  --tw-gradient-to: rgb(236 254 255 / 0.3) var(--tw-gradient-to-position);
}
.to-cyan-50\\/40 {
  --tw-gradient-to: rgb(236 254 255 / 0.4) var(--tw-gradient-to-position);
}
.to-cyan-50\\/50 {
  --tw-gradient-to: rgb(236 254 255 / 0.5) var(--tw-gradient-to-position);
}
.to-cyan-500 {
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-cyan-500\\/10 {
  --tw-gradient-to: rgb(6 182 212 / 0.1) var(--tw-gradient-to-position);
}
.to-cyan-500\\/5 {
  --tw-gradient-to: rgb(6 182 212 / 0.05) var(--tw-gradient-to-position);
}
.to-cyan-600 {
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-cyan-700 {
  --tw-gradient-to: #0e7490 var(--tw-gradient-to-position);
}
.to-emerald-100 {
  --tw-gradient-to: #d1fae5 var(--tw-gradient-to-position);
}
.to-emerald-100\\/50 {
  --tw-gradient-to: rgb(209 250 229 / 0.5) var(--tw-gradient-to-position);
}
.to-emerald-200 {
  --tw-gradient-to: #a7f3d0 var(--tw-gradient-to-position);
}
.to-emerald-400 {
  --tw-gradient-to: #34d399 var(--tw-gradient-to-position);
}
.to-emerald-50 {
  --tw-gradient-to: #ecfdf5 var(--tw-gradient-to-position);
}
.to-emerald-500 {
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}
.to-emerald-500\\/10 {
  --tw-gradient-to: rgb(16 185 129 / 0.1) var(--tw-gradient-to-position);
}
.to-emerald-500\\/5 {
  --tw-gradient-to: rgb(16 185 129 / 0.05) var(--tw-gradient-to-position);
}
.to-emerald-600 {
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-emerald-700 {
  --tw-gradient-to: #047857 var(--tw-gradient-to-position);
}
.to-fuchsia-50 {
  --tw-gradient-to: #fdf4ff var(--tw-gradient-to-position);
}
.to-fuchsia-500 {
  --tw-gradient-to: #d946ef var(--tw-gradient-to-position);
}
.to-fuchsia-600 {
  --tw-gradient-to: #c026d3 var(--tw-gradient-to-position);
}
.to-gray-100 {
  --tw-gradient-to: #f3f4f6 var(--tw-gradient-to-position);
}
.to-gray-100\\/50 {
  --tw-gradient-to: rgb(243 244 246 / 0.5) var(--tw-gradient-to-position);
}
.to-gray-200 {
  --tw-gradient-to: #e5e7eb var(--tw-gradient-to-position);
}
.to-gray-50 {
  --tw-gradient-to: #f9fafb var(--tw-gradient-to-position);
}
.to-gray-50\\/30 {
  --tw-gradient-to: rgb(249 250 251 / 0.3) var(--tw-gradient-to-position);
}
.to-gray-50\\/50 {
  --tw-gradient-to: rgb(249 250 251 / 0.5) var(--tw-gradient-to-position);
}
.to-gray-50\\/60 {
  --tw-gradient-to: rgb(249 250 251 / 0.6) var(--tw-gradient-to-position);
}
.to-gray-50\\/80 {
  --tw-gradient-to: rgb(249 250 251 / 0.8) var(--tw-gradient-to-position);
}
.to-gray-500 {
  --tw-gradient-to: #6b7280 var(--tw-gradient-to-position);
}
.to-gray-600 {
  --tw-gradient-to: #4b5563 var(--tw-gradient-to-position);
}
.to-gray-700 {
  --tw-gradient-to: #374151 var(--tw-gradient-to-position);
}
.to-gray-800 {
  --tw-gradient-to: #1f2937 var(--tw-gradient-to-position);
}
.to-gray-900 {
  --tw-gradient-to: #111827 var(--tw-gradient-to-position);
}
.to-green-200 {
  --tw-gradient-to: #bbf7d0 var(--tw-gradient-to-position);
}
.to-green-50 {
  --tw-gradient-to: #f0fdf4 var(--tw-gradient-to-position);
}
.to-green-50\\/40 {
  --tw-gradient-to: rgb(240 253 244 / 0.4) var(--tw-gradient-to-position);
}
.to-green-50\\/50 {
  --tw-gradient-to: rgb(240 253 244 / 0.5) var(--tw-gradient-to-position);
}
.to-green-500 {
  --tw-gradient-to: #22c55e var(--tw-gradient-to-position);
}
.to-green-600 {
  --tw-gradient-to: #16a34a var(--tw-gradient-to-position);
}
.to-indigo-100 {
  --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}
.to-indigo-400 {
  --tw-gradient-to: #818cf8 var(--tw-gradient-to-position);
}
.to-indigo-50 {
  --tw-gradient-to: #eef2ff var(--tw-gradient-to-position);
}
.to-indigo-50\\/40 {
  --tw-gradient-to: rgb(238 242 255 / 0.4) var(--tw-gradient-to-position);
}
.to-indigo-500 {
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-indigo-600 {
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-lime-600 {
  --tw-gradient-to: #65a30d var(--tw-gradient-to-position);
}
.to-orange-200 {
  --tw-gradient-to: #fed7aa var(--tw-gradient-to-position);
}
.to-orange-50 {
  --tw-gradient-to: #fff7ed var(--tw-gradient-to-position);
}
.to-orange-50\\/50 {
  --tw-gradient-to: rgb(255 247 237 / 0.5) var(--tw-gradient-to-position);
}
.to-orange-500 {
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-orange-500\\/10 {
  --tw-gradient-to: rgb(249 115 22 / 0.1) var(--tw-gradient-to-position);
}
.to-orange-600 {
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}
.to-pink-200 {
  --tw-gradient-to: #fbcfe8 var(--tw-gradient-to-position);
}
.to-pink-50 {
  --tw-gradient-to: #fdf2f8 var(--tw-gradient-to-position);
}
.to-pink-50\\/40 {
  --tw-gradient-to: rgb(253 242 248 / 0.4) var(--tw-gradient-to-position);
}
.to-pink-50\\/50 {
  --tw-gradient-to: rgb(253 242 248 / 0.5) var(--tw-gradient-to-position);
}
.to-pink-500 {
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-pink-500\\/5 {
  --tw-gradient-to: rgb(236 72 153 / 0.05) var(--tw-gradient-to-position);
}
.to-pink-600 {
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}
.to-pink-700 {
  --tw-gradient-to: #be185d var(--tw-gradient-to-position);
}
.to-primary-100\\/50 {
  --tw-gradient-to: rgb(179 232 224 / 0.5) var(--tw-gradient-to-position);
}
.to-primary-400 {
  --tw-gradient-to: #2dbea5 var(--tw-gradient-to-position);
}
.to-primary-50\\/50 {
  --tw-gradient-to: rgb(230 247 245 / 0.5) var(--tw-gradient-to-position);
}
.to-primary-600 {
  --tw-gradient-to: #168069 var(--tw-gradient-to-position);
}
.to-primary-700 {
  --tw-gradient-to: #136f5a var(--tw-gradient-to-position);
}
.to-purple-200 {
  --tw-gradient-to: #e9d5ff var(--tw-gradient-to-position);
}
.to-purple-50 {
  --tw-gradient-to: #faf5ff var(--tw-gradient-to-position);
}
.to-purple-50\\/30 {
  --tw-gradient-to: rgb(250 245 255 / 0.3) var(--tw-gradient-to-position);
}
.to-purple-50\\/40 {
  --tw-gradient-to: rgb(250 245 255 / 0.4) var(--tw-gradient-to-position);
}
.to-purple-50\\/50 {
  --tw-gradient-to: rgb(250 245 255 / 0.5) var(--tw-gradient-to-position);
}
.to-purple-50\\/80 {
  --tw-gradient-to: rgb(250 245 255 / 0.8) var(--tw-gradient-to-position);
}
.to-purple-500 {
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-purple-600 {
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-purple-700 {
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}
.to-red-100\\/50 {
  --tw-gradient-to: rgb(254 226 226 / 0.5) var(--tw-gradient-to-position);
}
.to-red-200 {
  --tw-gradient-to: #fecaca var(--tw-gradient-to-position);
}
.to-red-50 {
  --tw-gradient-to: #fef2f2 var(--tw-gradient-to-position);
}
.to-red-50\\/40 {
  --tw-gradient-to: rgb(254 242 242 / 0.4) var(--tw-gradient-to-position);
}
.to-red-500 {
  --tw-gradient-to: #ef4444 var(--tw-gradient-to-position);
}
.to-red-600 {
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}
.to-red-700 {
  --tw-gradient-to: #b91c1c var(--tw-gradient-to-position);
}
.to-rose-100 {
  --tw-gradient-to: #ffe4e6 var(--tw-gradient-to-position);
}
.to-rose-200 {
  --tw-gradient-to: #fecdd3 var(--tw-gradient-to-position);
}
.to-rose-50 {
  --tw-gradient-to: #fff1f2 var(--tw-gradient-to-position);
}
.to-rose-50\\/40 {
  --tw-gradient-to: rgb(255 241 242 / 0.4) var(--tw-gradient-to-position);
}
.to-rose-50\\/50 {
  --tw-gradient-to: rgb(255 241 242 / 0.5) var(--tw-gradient-to-position);
}
.to-rose-50\\/60 {
  --tw-gradient-to: rgb(255 241 242 / 0.6) var(--tw-gradient-to-position);
}
.to-rose-500 {
  --tw-gradient-to: #f43f5e var(--tw-gradient-to-position);
}
.to-rose-600 {
  --tw-gradient-to: #e11d48 var(--tw-gradient-to-position);
}
.to-rose-700 {
  --tw-gradient-to: #be123c var(--tw-gradient-to-position);
}
.to-sky-100 {
  --tw-gradient-to: #e0f2fe var(--tw-gradient-to-position);
}
.to-sky-500 {
  --tw-gradient-to: #0ea5e9 var(--tw-gradient-to-position);
}
.to-sky-600 {
  --tw-gradient-to: #0284c7 var(--tw-gradient-to-position);
}
.to-slate-100 {
  --tw-gradient-to: #f1f5f9 var(--tw-gradient-to-position);
}
.to-slate-100\\/80 {
  --tw-gradient-to: rgb(241 245 249 / 0.8) var(--tw-gradient-to-position);
}
.to-slate-200 {
  --tw-gradient-to: #e2e8f0 var(--tw-gradient-to-position);
}
.to-slate-50 {
  --tw-gradient-to: #f8fafc var(--tw-gradient-to-position);
}
.to-slate-50\\/60 {
  --tw-gradient-to: rgb(248 250 252 / 0.6) var(--tw-gradient-to-position);
}
.to-slate-500 {
  --tw-gradient-to: #64748b var(--tw-gradient-to-position);
}
.to-slate-600 {
  --tw-gradient-to: #475569 var(--tw-gradient-to-position);
}
.to-slate-700 {
  --tw-gradient-to: #334155 var(--tw-gradient-to-position);
}
.to-slate-900 {
  --tw-gradient-to: #0f172a var(--tw-gradient-to-position);
}
.to-teal-100 {
  --tw-gradient-to: #ccfbf1 var(--tw-gradient-to-position);
}
.to-teal-100\\/50 {
  --tw-gradient-to: rgb(204 251 241 / 0.5) var(--tw-gradient-to-position);
}
.to-teal-200 {
  --tw-gradient-to: #99f6e4 var(--tw-gradient-to-position);
}
.to-teal-400 {
  --tw-gradient-to: #2dd4bf var(--tw-gradient-to-position);
}
.to-teal-400\\/0 {
  --tw-gradient-to: rgb(45 212 191 / 0) var(--tw-gradient-to-position);
}
.to-teal-50 {
  --tw-gradient-to: #f0fdfa var(--tw-gradient-to-position);
}
.to-teal-50\\/30 {
  --tw-gradient-to: rgb(240 253 250 / 0.3) var(--tw-gradient-to-position);
}
.to-teal-50\\/40 {
  --tw-gradient-to: rgb(240 253 250 / 0.4) var(--tw-gradient-to-position);
}
.to-teal-50\\/50 {
  --tw-gradient-to: rgb(240 253 250 / 0.5) var(--tw-gradient-to-position);
}
.to-teal-50\\/60 {
  --tw-gradient-to: rgb(240 253 250 / 0.6) var(--tw-gradient-to-position);
}
.to-teal-50\\/80 {
  --tw-gradient-to: rgb(240 253 250 / 0.8) var(--tw-gradient-to-position);
}
.to-teal-500 {
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-teal-600 {
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}
.to-teal-700 {
  --tw-gradient-to: #0f766e var(--tw-gradient-to-position);
}
.to-teal-900\\/60 {
  --tw-gradient-to: rgb(19 78 74 / 0.6) var(--tw-gradient-to-position);
}
.to-teal-950 {
  --tw-gradient-to: #042f2e var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-violet-100 {
  --tw-gradient-to: #ede9fe var(--tw-gradient-to-position);
}
.to-violet-100\\/50 {
  --tw-gradient-to: rgb(237 233 254 / 0.5) var(--tw-gradient-to-position);
}
.to-violet-200 {
  --tw-gradient-to: #ddd6fe var(--tw-gradient-to-position);
}
.to-violet-300\\/15 {
  --tw-gradient-to: rgb(196 181 253 / 0.15) var(--tw-gradient-to-position);
}
.to-violet-300\\/25 {
  --tw-gradient-to: rgb(196 181 253 / 0.25) var(--tw-gradient-to-position);
}
.to-violet-50 {
  --tw-gradient-to: #f5f3ff var(--tw-gradient-to-position);
}
.to-violet-50\\/40 {
  --tw-gradient-to: rgb(245 243 255 / 0.4) var(--tw-gradient-to-position);
}
.to-violet-500 {
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
}
.to-violet-500\\/5 {
  --tw-gradient-to: rgb(139 92 246 / 0.05) var(--tw-gradient-to-position);
}
.to-violet-600 {
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.to-white\\/60 {
  --tw-gradient-to: rgb(255 255 255 / 0.6) var(--tw-gradient-to-position);
}
.to-yellow-200 {
  --tw-gradient-to: #fef08a var(--tw-gradient-to-position);
}
.to-yellow-50 {
  --tw-gradient-to: #fefce8 var(--tw-gradient-to-position);
}
.to-yellow-50\\/40 {
  --tw-gradient-to: rgb(254 252 232 / 0.4) var(--tw-gradient-to-position);
}
.to-yellow-500 {
  --tw-gradient-to: #eab308 var(--tw-gradient-to-position);
}
.to-yellow-600 {
  --tw-gradient-to: #ca8a04 var(--tw-gradient-to-position);
}
.bg-\\[length\\:1\\.25rem\\] {
  background-size: 1.25rem;
}
.bg-\\[length\\:10px\\] {
  background-size: 10px;
}
.bg-\\[length\\:10px_6px\\] {
  background-size: 10px 6px;
}
.bg-\\[length\\:12px\\] {
  background-size: 12px;
}
.bg-\\[length\\:14px\\] {
  background-size: 14px;
}
.bg-\\[length\\:1rem\\] {
  background-size: 1rem;
}
.bg-clip-text {
  background-clip: text;
}
.bg-\\[center_right_0\\.25rem\\] {
  background-position: center right 0.25rem;
}
.bg-\\[center_right_0\\.5rem\\] {
  background-position: center right 0.5rem;
}
.bg-\\[position\\:right_0\\.75rem_center\\] {
  background-position: right 0.75rem center;
}
.bg-\\[right_0\\.3rem_center\\] {
  background-position: right 0.3rem center;
}
.bg-\\[right_0px_center\\] {
  background-position: right 0px center;
}
.bg-\\[right_2px_center\\] {
  background-position: right 2px center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.fill-amber-400 {
  fill: #fbbf24;
}
.fill-amber-500 {
  fill: #f59e0b;
}
.fill-current {
  fill: currentColor;
}
.fill-purple-300 {
  fill: #d8b4fe;
}
.fill-teal-300 {
  fill: #5eead4;
}
.fill-white\\/90 {
  fill: rgb(255 255 255 / 0.9);
}
.fill-yellow-400 {
  fill: #facc15;
}
.stroke-\\[2\\.5\\] {
  stroke-width: 2.5;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-fill {
  object-fit: fill;
}
.object-\\[50\\%_30\\%\\] {
  object-position: 50% 30%;
}
.\\!p-0 {
  padding: 0px !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[2px\\] {
  padding: 2px;
}
.p-\\[3px\\] {
  padding: 3px;
}
.p-\\[4px\\] {
  padding: 4px;
}
.p-px {
  padding: 1px;
}
.\\!py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-14 {
  padding-bottom: 3.5rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[60px\\] {
  padding-bottom: 60px;
}
.pl-0 {
  padding-left: 0px;
}
.pl-0\\.5 {
  padding-left: 0.125rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-1\\.5 {
  padding-left: 0.375rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-11 {
  padding-left: 2.75rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-16 {
  padding-left: 4rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-3\\.5 {
  padding-left: 0.875rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pl-\\[calc\\(theme\\(spacing\\.2\\)\\+1\\.5rem\\+theme\\(spacing\\.2\\)\\)\\] {
  padding-left: calc(0.5rem + 1.5rem + 0.5rem);
}
.pr-0 {
  padding-right: 0px;
}
.pr-0\\.5 {
  padding-right: 0.125rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-1\\.5 {
  padding-right: 0.375rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-11 {
  padding-right: 2.75rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-20 {
  padding-right: 5rem;
}
.pr-24 {
  padding-right: 6rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-24 {
  padding-top: 6rem;
}
.pt-28 {
  padding-top: 7rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-3\\.5 {
  padding-top: 0.875rem;
}
.pt-32 {
  padding-top: 8rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[7px\\] {
  padding-top: 7px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.align-bottom {
  vertical-align: bottom;
}
.align-super {
  vertical-align: super;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: -apple-system, BlinkMacSystemFont, system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-7xl {
  font-size: 4.5rem;
  line-height: 1;
}
.text-\\[10\\.5px\\] {
  font-size: 10.5px;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12\\.5px\\] {
  font-size: 12.5px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13\\.5px\\] {
  font-size: 13.5px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[3\\.25rem\\] {
  font-size: 3.25rem;
}
.text-\\[4px\\] {
  font-size: 4px;
}
.text-\\[5px\\] {
  font-size: 5px;
}
.text-\\[6px\\] {
  font-size: 6px;
}
.text-\\[7px\\] {
  font-size: 7px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.lining-nums {
  --tw-numeric-figure: lining-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-\\[1\\.05\\] {
  line-height: 1.05;
}
.leading-\\[15px\\] {
  line-height: 15px;
}
.leading-\\[19px\\] {
  line-height: 19px;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.08em\\] {
  letter-spacing: 0.08em;
}
.tracking-\\[0\\.12em\\] {
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.14em\\] {
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.15em\\] {
  letter-spacing: 0.15em;
}
.tracking-\\[0\\.16em\\] {
  letter-spacing: 0.16em;
}
.tracking-\\[0\\.18em\\] {
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.1em\\] {
  letter-spacing: 0.1em;
}
.tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.4em\\] {
  letter-spacing: 0.4em;
}
.tracking-\\[0\\.5em\\] {
  letter-spacing: 0.5em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-tighter {
  letter-spacing: -0.05em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-amber-100 {
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}
.text-amber-200 {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.text-amber-300 {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-300\\/70 {
  color: rgb(252 211 77 / 0.7);
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-500\\/60 {
  color: rgb(245 158 11 / 0.6);
}
.text-amber-500\\/80 {
  color: rgb(245 158 11 / 0.8);
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-700\\/80 {
  color: rgb(180 83 9 / 0.8);
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-100 {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-blue-200 {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-500\\/80 {
  color: rgb(59 130 246 / 0.8);
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-600\\/80 {
  color: rgb(37 99 235 / 0.8);
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-cyan-100 {
  --tw-text-opacity: 1;
  color: rgb(207 250 254 / var(--tw-text-opacity, 1));
}
.text-cyan-400 {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity, 1));
}
.text-cyan-500\\/70 {
  color: rgb(6 182 212 / 0.7);
}
.text-cyan-500\\/80 {
  color: rgb(6 182 212 / 0.8);
}
.text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.text-cyan-800 {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}
.text-cyan-900 {
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity, 1));
}
.text-emerald-100 {
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity, 1));
}
.text-emerald-200 {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-300 {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-500\\/80 {
  color: rgb(16 185 129 / 0.8);
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-600\\/70 {
  color: rgb(5 150 105 / 0.7);
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-fuchsia-400 {
  --tw-text-opacity: 1;
  color: rgb(232 121 249 / var(--tw-text-opacity, 1));
}
.text-fuchsia-600 {
  --tw-text-opacity: 1;
  color: rgb(192 38 211 / var(--tw-text-opacity, 1));
}
.text-fuchsia-700 {
  --tw-text-opacity: 1;
  color: rgb(162 28 175 / var(--tw-text-opacity, 1));
}
.text-fuchsia-800 {
  --tw-text-opacity: 1;
  color: rgb(134 25 143 / var(--tw-text-opacity, 1));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-gray-950 {
  --tw-text-opacity: 1;
  color: rgb(3 7 18 / var(--tw-text-opacity, 1));
}
.text-green-100 {
  --tw-text-opacity: 1;
  color: rgb(220 252 231 / var(--tw-text-opacity, 1));
}
.text-green-200 {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity, 1));
}
.text-green-200\\/70 {
  color: rgb(187 247 208 / 0.7);
}
.text-green-300 {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.text-indigo-100 {
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity, 1));
}
.text-indigo-200 {
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity, 1));
}
.text-indigo-300 {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-500\\/80 {
  color: rgb(99 102 241 / 0.8);
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-600\\/80 {
  color: rgb(79 70 229 / 0.8);
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-inherit {
  color: inherit;
}
.text-lime-700 {
  --tw-text-opacity: 1;
  color: rgb(77 124 15 / var(--tw-text-opacity, 1));
}
.text-lime-800 {
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity, 1));
}
.text-lime-900 {
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / var(--tw-text-opacity, 1));
}
.text-orange-100 {
  --tw-text-opacity: 1;
  color: rgb(255 237 213 / var(--tw-text-opacity, 1));
}
.text-orange-200 {
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / var(--tw-text-opacity, 1));
}
.text-orange-300 {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-orange-50 {
  --tw-text-opacity: 1;
  color: rgb(255 247 237 / var(--tw-text-opacity, 1));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-orange-800 {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity, 1));
}
.text-pink-100 {
  --tw-text-opacity: 1;
  color: rgb(252 231 243 / var(--tw-text-opacity, 1));
}
.text-pink-200 {
  --tw-text-opacity: 1;
  color: rgb(251 207 232 / var(--tw-text-opacity, 1));
}
.text-pink-200\\/70 {
  color: rgb(251 207 232 / 0.7);
}
.text-pink-400 {
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}
.text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity, 1));
}
.text-pink-600 {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-pink-700 {
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.text-pink-800 {
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / var(--tw-text-opacity, 1));
}
.text-pink-900 {
  --tw-text-opacity: 1;
  color: rgb(131 24 67 / var(--tw-text-opacity, 1));
}
.text-primary-500 {
  --tw-text-opacity: 1;
  color: rgb(26 145 121 / var(--tw-text-opacity, 1));
}
.text-primary-600 {
  --tw-text-opacity: 1;
  color: rgb(22 128 105 / var(--tw-text-opacity, 1));
}
.text-primary-700 {
  --tw-text-opacity: 1;
  color: rgb(19 111 90 / var(--tw-text-opacity, 1));
}
.text-primary-800 {
  --tw-text-opacity: 1;
  color: rgb(15 93 74 / var(--tw-text-opacity, 1));
}
.text-purple-100 {
  --tw-text-opacity: 1;
  color: rgb(243 232 255 / var(--tw-text-opacity, 1));
}
.text-purple-200 {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.text-purple-300 {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.text-purple-400 {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}
.text-red-100 {
  --tw-text-opacity: 1;
  color: rgb(254 226 226 / var(--tw-text-opacity, 1));
}
.text-red-200 {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-700\\/80 {
  color: rgb(185 28 28 / 0.8);
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-rose-100 {
  --tw-text-opacity: 1;
  color: rgb(255 228 230 / var(--tw-text-opacity, 1));
}
.text-rose-200 {
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity, 1));
}
.text-rose-300 {
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}
.text-rose-400 {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-400\\/70 {
  color: rgb(251 113 133 / 0.7);
}
.text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-500\\/80 {
  color: rgb(244 63 94 / 0.8);
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700 {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-rose-700\\/80 {
  color: rgb(190 18 60 / 0.8);
}
.text-rose-800 {
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.text-rose-900 {
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity, 1));
}
.text-sky-500 {
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity, 1));
}
.text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.text-sky-700 {
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-sky-800 {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-sky-900 {
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity, 1));
}
.text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-teal-100 {
  --tw-text-opacity: 1;
  color: rgb(204 251 241 / var(--tw-text-opacity, 1));
}
.text-teal-100\\/70 {
  color: rgb(204 251 241 / 0.7);
}
.text-teal-100\\/80 {
  color: rgb(204 251 241 / 0.8);
}
.text-teal-200 {
  --tw-text-opacity: 1;
  color: rgb(153 246 228 / var(--tw-text-opacity, 1));
}
.text-teal-300 {
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity, 1));
}
.text-teal-400 {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity, 1));
}
.text-teal-500\\/70 {
  color: rgb(20 184 166 / 0.7);
}
.text-teal-500\\/80 {
  color: rgb(20 184 166 / 0.8);
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.text-teal-600\\/70 {
  color: rgb(13 148 136 / 0.7);
}
.text-teal-600\\/80 {
  color: rgb(13 148 136 / 0.8);
}
.text-teal-600\\/90 {
  color: rgb(13 148 136 / 0.9);
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-teal-700\\/80 {
  color: rgb(15 118 110 / 0.8);
}
.text-teal-800 {
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity, 1));
}
.text-teal-800\\/80 {
  color: rgb(17 94 89 / 0.8);
}
.text-teal-900 {
  --tw-text-opacity: 1;
  color: rgb(19 78 74 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-violet-100 {
  --tw-text-opacity: 1;
  color: rgb(237 233 254 / var(--tw-text-opacity, 1));
}
.text-violet-200 {
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity, 1));
}
.text-violet-400 {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-violet-500 {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-violet-500\\/80 {
  color: rgb(139 92 246 / 0.8);
}
.text-violet-600 {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-600\\/80 {
  color: rgb(124 58 237 / 0.8);
}
.text-violet-700 {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-violet-800 {
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-violet-900 {
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/40 {
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/50 {
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/60 {
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.decoration-gray-200 {
  text-decoration-color: #e5e7eb;
}
.decoration-gray-300 {
  text-decoration-color: #d1d5db;
}
.decoration-rose-400\\/50 {
  text-decoration-color: rgb(251 113 133 / 0.5);
}
.decoration-rose-400\\/60 {
  text-decoration-color: rgb(251 113 133 / 0.6);
}
.decoration-rose-500\\/60 {
  text-decoration-color: rgb(244 63 94 / 0.6);
}
.decoration-2 {
  text-decoration-thickness: 2px;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
.accent-amber-500 {
  accent-color: #f59e0b;
}
.accent-red-500 {
  accent-color: #ef4444;
}
.accent-violet-600 {
  accent-color: #7c3aed;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-5 {
  opacity: 0.05;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.mix-blend-soft-light {
  mix-blend-mode: soft-light;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-1px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 -1px 3px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 -1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_4px_rgba\\(20\\2c 184\\2c 166\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 0 0 4px rgba(20,184,166,0.12);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.18\\)\\] {
  --tw-shadow: 0 12px 32px rgba(0,0,0,0.18);
  --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_48px_-12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\2c 0_2px_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 16px 48px -12px rgba(0,0,0,0.3),0 2px 8px rgba(0,0,0,0.06);
  --tw-shadow-colored: 0 16px 48px -12px var(--tw-shadow-color), 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 1px 0 rgba(0,0,0,0.08);
  --tw-shadow-colored: 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 1px 2px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 1px 2px rgba(0,0,0,0.06);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 1px 2px rgba(0,0,0,0.08);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 1px 3px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\2c 0_0_0_0\\.5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 1px 3px rgba(0,0,0,0.08),0 0 0 0.5px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color), 0 0 0 0.5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\2c inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.9\\)\\] {
  --tw-shadow: 0 1px 3px rgba(0,0,0,0.12),inset 0 1px 0 rgba(255,255,255,0.9);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color), inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 1px 3px rgba(0,0,0,0.12);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_-12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 20px 50px -12px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 20px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_70px_rgba\\(217\\2c 119\\2c 6\\2c 0\\.22\\)\\] {
  --tw-shadow: 0 20px 70px rgba(217,119,6,0.22);
  --tw-shadow-colored: 0 20px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_70px_rgba\\(8\\2c 145\\2c 178\\2c 0\\.22\\)\\] {
  --tw-shadow: 0 20px 70px rgba(8,145,178,0.22);
  --tw-shadow-colored: 0 20px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_12px_-2px_rgba\\(20\\2c 184\\2c 166\\2c 0\\.4\\)\\] {
  --tw-shadow: 0 4px 12px -2px rgba(20,184,166,0.4);
  --tw-shadow-colored: 0 4px 12px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_-4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\] {
  --tw-shadow: 0 8px 24px -4px rgba(0,0,0,0.15);
  --tw-shadow-colored: 0 8px 24px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.10\\)\\] {
  --tw-shadow: 0 8px 40px rgba(0,0,0,0.10);
  --tw-shadow-colored: 0 8px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: inset 0 1px 1px rgba(0,0,0,0.04);
  --tw-shadow-colored: inset 0 1px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\] {
  --tw-shadow: inset 0 1px 2px rgba(0,0,0,0.05);
  --tw-shadow-colored: inset 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\] {
  --tw-shadow: inset 0 1px 2px rgba(0,0,0,0.06);
  --tw-shadow-colored: inset 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\] {
  --tw-shadow: inset 0 1px 2px rgba(0,0,0,0.35);
  --tw-shadow-colored: inset 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card {
  --tw-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-amber-200\\/50 {
  --tw-shadow-color: rgb(253 230 138 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-300 {
  --tw-shadow-color: #fcd34d;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-300\\/40 {
  --tw-shadow-color: rgb(252 211 77 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-400\\/20 {
  --tw-shadow-color: rgb(251 191 36 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-500\\/20 {
  --tw-shadow-color: rgb(245 158 11 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-500\\/25 {
  --tw-shadow-color: rgb(245 158 11 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-500\\/30 {
  --tw-shadow-color: rgb(245 158 11 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/10 {
  --tw-shadow-color: rgb(0 0 0 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/40 {
  --tw-shadow-color: rgb(0 0 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/\\[0\\.04\\] {
  --tw-shadow-color: rgb(0 0 0 / 0.04);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/\\[0\\.06\\] {
  --tw-shadow-color: rgb(0 0 0 / 0.06);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-200\\/50 {
  --tw-shadow-color: rgb(191 219 254 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-300 {
  --tw-shadow-color: #93c5fd;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-300\\/40 {
  --tw-shadow-color: rgb(147 197 253 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/20 {
  --tw-shadow-color: rgb(59 130 246 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/25 {
  --tw-shadow-color: rgb(59 130 246 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/30 {
  --tw-shadow-color: rgb(59 130 246 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/20 {
  --tw-shadow-color: rgb(6 182 212 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/25 {
  --tw-shadow-color: rgb(6 182 212 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/30 {
  --tw-shadow-color: rgb(6 182 212 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-200\\/50 {
  --tw-shadow-color: rgb(167 243 208 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-300 {
  --tw-shadow-color: #6ee7b7;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-300\\/40 {
  --tw-shadow-color: rgb(110 231 183 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-400\\/20 {
  --tw-shadow-color: rgb(52 211 153 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/20 {
  --tw-shadow-color: rgb(16 185 129 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/25 {
  --tw-shadow-color: rgb(16 185 129 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/30 {
  --tw-shadow-color: rgb(16 185 129 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-100 {
  --tw-shadow-color: #f3f4f6;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-100\\/50 {
  --tw-shadow-color: rgb(243 244 246 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-200\\/30 {
  --tw-shadow-color: rgb(229 231 235 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-200\\/40 {
  --tw-shadow-color: rgb(229 231 235 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-900\\/5 {
  --tw-shadow-color: rgb(17 24 39 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/20 {
  --tw-shadow-color: rgb(34 197 94 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/25 {
  --tw-shadow-color: rgb(34 197 94 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/30 {
  --tw-shadow-color: rgb(34 197 94 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-300\\/50 {
  --tw-shadow-color: rgb(165 180 252 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/20 {
  --tw-shadow-color: rgb(99 102 241 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/25 {
  --tw-shadow-color: rgb(99 102 241 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/30 {
  --tw-shadow-color: rgb(99 102 241 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/20 {
  --tw-shadow-color: rgb(249 115 22 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/30 {
  --tw-shadow-color: rgb(249 115 22 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/20 {
  --tw-shadow-color: rgb(236 72 153 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/20 {
  --tw-shadow-color: rgb(168 85 247 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/25 {
  --tw-shadow-color: rgb(168 85 247 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/30 {
  --tw-shadow-color: rgb(168 85 247 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-900\\/40 {
  --tw-shadow-color: rgb(88 28 135 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/20 {
  --tw-shadow-color: rgb(239 68 68 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/25 {
  --tw-shadow-color: rgb(239 68 68 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/30 {
  --tw-shadow-color: rgb(239 68 68 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-400\\/20 {
  --tw-shadow-color: rgb(251 113 133 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-500\\/20 {
  --tw-shadow-color: rgb(244 63 94 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-500\\/25 {
  --tw-shadow-color: rgb(244 63 94 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-500\\/30 {
  --tw-shadow-color: rgb(244 63 94 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-600\\/20 {
  --tw-shadow-color: rgb(225 29 72 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-500\\/25 {
  --tw-shadow-color: rgb(100 116 139 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-500\\/30 {
  --tw-shadow-color: rgb(100 116 139 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-900\\/15 {
  --tw-shadow-color: rgb(15 23 42 / 0.15);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-200 {
  --tw-shadow-color: #99f6e4;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-200\\/40 {
  --tw-shadow-color: rgb(153 246 228 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/10 {
  --tw-shadow-color: rgb(20 184 166 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/20 {
  --tw-shadow-color: rgb(20 184 166 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/25 {
  --tw-shadow-color: rgb(20 184 166 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/30 {
  --tw-shadow-color: rgb(20 184 166 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/5 {
  --tw-shadow-color: rgb(20 184 166 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-violet-500\\/20 {
  --tw-shadow-color: rgb(139 92 246 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-violet-500\\/25 {
  --tw-shadow-color: rgb(139 92 246 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[1\\.5px\\] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1.5px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[2\\.5px\\] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2.5px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-amber-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 243 199 / var(--tw-ring-opacity, 1));
}
.ring-amber-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity, 1));
}
.ring-amber-200\\/50 {
  --tw-ring-color: rgb(253 230 138 / 0.5);
}
.ring-amber-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 211 77 / var(--tw-ring-opacity, 1));
}
.ring-amber-300\\/50 {
  --tw-ring-color: rgb(252 211 77 / 0.5);
}
.ring-amber-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}
.ring-amber-500\\/60 {
  --tw-ring-color: rgb(245 158 11 / 0.6);
}
.ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}
.ring-black\\/5 {
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.ring-black\\/\\[0\\.04\\] {
  --tw-ring-color: rgb(0 0 0 / 0.04);
}
.ring-black\\/\\[0\\.05\\] {
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.ring-blue-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}
.ring-blue-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}
.ring-blue-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
.ring-blue-300\\/50 {
  --tw-ring-color: rgb(147 197 253 / 0.5);
}
.ring-current {
  --tw-ring-color: currentColor;
}
.ring-cyan-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(207 250 254 / var(--tw-ring-opacity, 1));
}
.ring-cyan-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 243 252 / var(--tw-ring-opacity, 1));
}
.ring-emerald-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 250 229 / var(--tw-ring-opacity, 1));
}
.ring-emerald-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 243 208 / var(--tw-ring-opacity, 1));
}
.ring-emerald-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(110 231 183 / var(--tw-ring-opacity, 1));
}
.ring-emerald-300\\/50 {
  --tw-ring-color: rgb(110 231 183 / 0.5);
}
.ring-emerald-500\\/60 {
  --tw-ring-color: rgb(16 185 129 / 0.6);
}
.ring-gray-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 244 246 / var(--tw-ring-opacity, 1));
}
.ring-gray-100\\/80 {
  --tw-ring-color: rgb(243 244 246 / 0.8);
}
.ring-gray-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity, 1));
}
.ring-gray-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}
.ring-gray-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}
.ring-gray-900\\/20 {
  --tw-ring-color: rgb(17 24 39 / 0.2);
}
.ring-green-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 252 231 / var(--tw-ring-opacity, 1));
}
.ring-green-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(187 247 208 / var(--tw-ring-opacity, 1));
}
.ring-green-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(134 239 172 / var(--tw-ring-opacity, 1));
}
.ring-green-300\\/50 {
  --tw-ring-color: rgb(134 239 172 / 0.5);
}
.ring-indigo-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.ring-indigo-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity, 1));
}
.ring-indigo-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity, 1));
}
.ring-indigo-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.ring-orange-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 237 213 / var(--tw-ring-opacity, 1));
}
.ring-orange-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity, 1));
}
.ring-orange-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 186 116 / var(--tw-ring-opacity, 1));
}
.ring-orange-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 115 22 / var(--tw-ring-opacity, 1));
}
.ring-pink-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 231 243 / var(--tw-ring-opacity, 1));
}
.ring-pink-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 207 232 / var(--tw-ring-opacity, 1));
}
.ring-primary-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(77 203 181 / var(--tw-ring-opacity, 1));
}
.ring-purple-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 232 255 / var(--tw-ring-opacity, 1));
}
.ring-purple-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(233 213 255 / var(--tw-ring-opacity, 1));
}
.ring-purple-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(216 180 254 / var(--tw-ring-opacity, 1));
}
.ring-purple-300\\/50 {
  --tw-ring-color: rgb(216 180 254 / 0.5);
}
.ring-purple-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}
.ring-red-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 226 226 / var(--tw-ring-opacity, 1));
}
.ring-red-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity, 1));
}
.ring-red-200\\/60 {
  --tw-ring-color: rgb(254 202 202 / 0.6);
}
.ring-red-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity, 1));
}
.ring-red-400\\/20 {
  --tw-ring-color: rgb(248 113 113 / 0.2);
}
.ring-red-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}
.ring-rose-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 228 230 / var(--tw-ring-opacity, 1));
}
.ring-rose-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity, 1));
}
.ring-rose-500\\/10 {
  --tw-ring-color: rgb(244 63 94 / 0.1);
}
.ring-rose-500\\/60 {
  --tw-ring-color: rgb(244 63 94 / 0.6);
}
.ring-sky-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 242 254 / var(--tw-ring-opacity, 1));
}
.ring-sky-500\\/60 {
  --tw-ring-color: rgb(14 165 233 / 0.6);
}
.ring-slate-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 245 249 / var(--tw-ring-opacity, 1));
}
.ring-slate-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}
.ring-slate-300\\/50 {
  --tw-ring-color: rgb(203 213 225 / 0.5);
}
.ring-teal-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(204 251 241 / var(--tw-ring-opacity, 1));
}
.ring-teal-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 246 228 / var(--tw-ring-opacity, 1));
}
.ring-teal-200\\/40 {
  --tw-ring-color: rgb(153 246 228 / 0.4);
}
.ring-teal-200\\/60 {
  --tw-ring-color: rgb(153 246 228 / 0.6);
}
.ring-teal-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(94 234 212 / var(--tw-ring-opacity, 1));
}
.ring-teal-300\\/50 {
  --tw-ring-color: rgb(94 234 212 / 0.5);
}
.ring-teal-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 212 191 / var(--tw-ring-opacity, 1));
}
.ring-teal-400\\/40 {
  --tw-ring-color: rgb(45 212 191 / 0.4);
}
.ring-teal-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 253 250 / var(--tw-ring-opacity, 1));
}
.ring-teal-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(20 184 166 / var(--tw-ring-opacity, 1));
}
.ring-teal-500\\/10 {
  --tw-ring-color: rgb(20 184 166 / 0.1);
}
.ring-teal-500\\/20 {
  --tw-ring-color: rgb(20 184 166 / 0.2);
}
.ring-teal-500\\/30 {
  --tw-ring-color: rgb(20 184 166 / 0.3);
}
.ring-teal-500\\/50 {
  --tw-ring-color: rgb(20 184 166 / 0.5);
}
.ring-transparent {
  --tw-ring-color: transparent;
}
.ring-violet-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(237 233 254 / var(--tw-ring-opacity, 1));
}
.ring-violet-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(221 214 254 / var(--tw-ring-opacity, 1));
}
.ring-violet-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(196 181 253 / var(--tw-ring-opacity, 1));
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-white\\/10 {
  --tw-ring-color: rgb(255 255 255 / 0.1);
}
.ring-white\\/20 {
  --tw-ring-color: rgb(255 255 255 / 0.2);
}
.ring-white\\/30 {
  --tw-ring-color: rgb(255 255 255 / 0.3);
}
.ring-white\\/50 {
  --tw-ring-color: rgb(255 255 255 / 0.5);
}
.ring-opacity-5 {
  --tw-ring-opacity: 0.05;
}
.ring-offset-1 {
  --tw-ring-offset-width: 1px;
}
.ring-offset-2 {
  --tw-ring-offset-width: 2px;
}
.ring-offset-\\[1\\.5px\\] {
  --tw-ring-offset-width: 1.5px;
}
.ring-offset-\\[1px\\] {
  --tw-ring-offset-width: 1px;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl {
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm {
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl {
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-100 {
  --tw-brightness: brightness(1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.contrast-150 {
  --tw-contrast: contrast(1.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_24px_35px_rgba\\(13\\2c 148\\2c 136\\2c 0\\.12\\)\\] {
  --tw-drop-shadow: drop-shadow(0 24px 35px rgba(13,148,136,0.12));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm {
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-2xl {
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[1px\\] {
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\] {
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-150 {
  --tw-backdrop-saturate: saturate(1.5);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\] {
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-700 {
  transition-delay: 700ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-\\[cubic-bezier\\(0\\.16\\2c 1\\2c 0\\.3\\2c 1\\)\\] {
  transition-timing-function: cubic-bezier(0.16,1,0.3,1);
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  transition-timing-function: linear;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.scrollbar-hide {
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
  /* Inforiver-style financial figures: Inter with tabular lining numbers */
  .font-financial {
    font-family: 'Montserrat', system-ui, sans-serif;
    font-feature-settings: 'tnum' 1, 'lnum' 1;
    font-variant-numeric: tabular-nums lining-nums;
    letter-spacing: -0.01em;
  }
.\\[-ms-overflow-style\\:none\\] {
  -ms-overflow-style: none;
}
.\\[appearance\\:textfield\\] {
  appearance: textfield;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}

/* Custom Fonts (used in print/PDF and public pages only) - woff2 optimized */
@font-face {
  font-family: 'Auro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Auro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Auro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2');
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Amaranth';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Amaranth';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Baloo Bhai 2';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Baloo Bhai 2';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Baloo Bhai 2';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Dubai';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff2');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Dubai';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Dubai';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

/* Custom scrollbar - DISABLED to hide scrollbar */
/*
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #f8f9fa;
  border-radius: 10px;
}

.dark ::-webkit-scrollbar-track {
  background: #1f2937;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #1a9179 0%, #168069 100%);
  border-radius: 10px;
  border: 2px solid #f8f9fa;
}

.dark ::-webkit-scrollbar-thumb {
  border: 2px solid #1f2937;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #168069 0%, #136f5a 100%);
}
*/

/* Utility to hide scrollbar but keep scrolling */
.no-scrollbar {
  -ms-overflow-style: none;
  /* IE/Edge */
  scrollbar-width: none;
  /* Firefox */
}

.no-scrollbar::-webkit-scrollbar {
  display: none !important;
  /* Chrome/Safari */
}

/* Smooth animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-out;
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Page fade-in animation for public pages */
@keyframes pageFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.animate-pageFadeIn {
  animation: pageFadeIn 0.5s ease-out;
}

/* Image fade-in with subtle scale */
@keyframes imageFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-imageFadeIn {
  animation: imageFadeIn 0.8s ease-out;
}

/* Hero image carousel transition - GPU-accelerated */
@keyframes fadeInImage {
  from {
    opacity: 0;
    transform: scale(1.02);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.animate-fadeInImage {
  animation: fadeInImage 0.6s ease-out;
  will-change: opacity, transform;
}

/* Slow blink/pulse animation for pricing savings */
@keyframes slowBlink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }
}

.animate-slow-blink {
  animation: slowBlink 8s ease-in-out infinite;
}

/* Page transition for module navigation */
@keyframes pageTransition {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.page-transition {
  animation: pageTransition 0.4s ease-out;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(100%);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-slide-in-right {
  animation: slideInRight 0.3s ease-out;
}

/* Ultramodern Toast Animations */
@keyframes toastEnter {
  from {
    opacity: 0;
    transform: translateX(100%) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes toastExit {
  from {
    opacity: 1;
    transform: translateX(0) scale(1);
  }

  to {
    opacity: 0;
    transform: translateX(120%) scale(0.95);
  }
}

@keyframes iconBounce {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}

.toast-enter {
  animation: toastEnter 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.toast-exit {
  animation: toastExit 0.3s cubic-bezier(0.4, 0, 1, 1) forwards;
}

.icon-bounce {
  animation: iconBounce 0.5s ease-in-out;
}

/* Tab content transitions - macOS Sonoma style */
@keyframes tabSlideIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tab-content {
  animation: tabSlideIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Vertical centering for table cells inside paginated PDF documents */
.paginated-page th,
.paginated-page td {
  vertical-align: middle !important;
}

/* Slide down animation - ultramodern smooth reveal */
@keyframes slideDown {
  0% {
    opacity: 0;
    clip-path: inset(0 0 100% 0);
    transform: translateY(-8px);
  }

  100% {
    opacity: 1;
    clip-path: inset(0 0 0 0);
    transform: translateY(0);
  }
}

.animate-slideDown {
  animation: slideDown 0.35s cubic-bezier(0.32, 0.72, 0, 1);
  will-change: clip-path, opacity, transform;
}

/* Slide up animation - ultramodern smooth collapse */
@keyframes slideUp {
  0% {
    opacity: 1;
    clip-path: inset(0 0 0 0);
    transform: translateY(0);
  }

  100% {
    opacity: 0;
    clip-path: inset(0 0 100% 0);
    transform: translateY(-8px);
  }
}

.animate-slideUp {
  animation: slideUp 0.25s cubic-bezier(0.32, 0.72, 0, 1) forwards;
  will-change: clip-path, opacity, transform;
}

/* Bed card expansion - smooth modern reveal */
@keyframes bedExpandIn {
  0% {
    opacity: 0.7;
    transform: scale(0.98);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.animate-bedExpandIn {
  animation: bedExpandIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
}

/* Care view inline reveal - slide down with fade */
@keyframes careViewReveal {
  0% {
    opacity: 0;
    transform: translateY(-12px);
    max-height: 0;
  }
  60% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    max-height: 2000px;
  }
}

.animate-careViewReveal {
  animation: careViewReveal 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity, max-height;
}

/* Smooth collapse for header/toolbar sections */
@keyframes sectionCollapse {
  0% {
    opacity: 1;
    max-height: 80px;
  }
  100% {
    opacity: 0;
    max-height: 0;
  }
}

/* Smooth expand for header/toolbar sections */
@keyframes sectionExpand {
  0% {
    opacity: 0;
    max-height: 0;
  }
  100% {
    opacity: 1;
    max-height: 80px;
  }
}

/* Modal animations - macOS Sonoma style */
@keyframes modalBackdropFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes modalBackdropFadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes modalSlideOut {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }

  to {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
}

.modal-backdrop {
  animation: modalBackdropFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  /* Ensure backdrop covers entire viewport */
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 40;
}

.modal-backdrop.closing {
  animation: modalBackdropFadeOut 0.15s cubic-bezier(0.16, 1, 0.3, 1);
}

.modal-content {
  animation: modalSlideIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  z-index: 50;
}

.modal-content.closing {
  animation: modalSlideOut 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Confirm Dialog animations - ultramodern & compact */
@keyframes confirmBackdropIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes confirmBackdropOut {
  from { opacity: 1; }
  to { opacity: 0; }
}

@keyframes confirmSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes confirmSlideOut {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: scale(0.95) translateY(5px);
  }
}

.confirm-backdrop {
  animation: confirmBackdropIn 0.15s ease-out;
}

.confirm-backdrop.closing {
  animation: confirmBackdropOut 0.15s ease-out forwards;
}

.confirm-content {
  animation: confirmSlideIn 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.confirm-content.closing {
  animation: confirmSlideOut 0.15s ease-out forwards;
}

/* Print styles for purchase orders */
@media print {
  @page {
    size: A4;
    margin: 1.5cm;
  }

  body {
    background: white !important;
  }

  /* Hide sidebar and main app UI */
  nav,
  aside,
  header,
  footer,
  .sidebar,
  [role="navigation"],
  .print\\:hidden {
    display: none !important;
  }

  /* Reset modal styling for print */
  #po-print-modal {
    position: static !important;
    background: white !important;
    padding: 0 !important;
    max-width: none !important;
    box-shadow: none !important;
  }

  /* Make PO content take full width */
  #po-print-content {
    max-width: 100% !important;
    overflow: visible !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  /* Quick report inline preview — hide everything except the preview. Scoped
     with :has() so the nuke only engages while such a preview is actually on
     the page — an unconditional body * rule blanks every in-place print. The
     dedicated print path appends .quick-report-print-clone instead, which
     must stay visible. */
  body:has(.quick-report-inline-preview):not(:has(.quick-report-print-clone)) * {
    visibility: hidden !important;
  }
  body:has(.quick-report-inline-preview):not(:has(.quick-report-print-clone)) .quick-report-inline-preview,
  body:has(.quick-report-inline-preview):not(:has(.quick-report-print-clone)) .quick-report-inline-preview * {
    visibility: visible !important;
  }
  .quick-report-inline-preview {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    max-height: none !important;
    overflow: visible !important;
    background: white !important;
    border: none !important;
  }
  .quick-report-inline-preview .preview-only { display: none !important; }

  /* Safety net: if an in-place print happens while a paginated preview is on
     screen, auto-size the page shells — a fixed sheet-height box overflows
     the printable area and gets its top clipped. Dedicated print paths apply
     their own stricter rules (higher specificity / popup stylesheets). */
  .paginated-document { padding: 0 !important; background: #fff !important; }
  .paginated-document > div[aria-hidden="true"] { display: none !important; }
  .paginated-document-pages { padding: 0 !important; }
  .paginated-page {
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    margin: 0 !important;
    box-shadow: none !important;
    border: none !important;
    page-break-after: always;
    break-after: page;
  }
  .paginated-page:last-child { page-break-after: auto; break-after: auto; }
  .paginated-page-number { display: none !important; }
}

/* Gemini-style Animations & Effects */

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

.animate-shimmer {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 100%);
  background-size: 200% 100%;
  animation: shimmer 2s infinite;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

.animate-float-delayed {
  animation: float 6s ease-in-out 3s infinite;
}

@keyframes glow {

  0%,
  100% {
    opacity: 0.5;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

.animate-glow {
  animation: glow 4s ease-in-out infinite;
}

/* Reviews scroll animation */
@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

.scroll-container {
  animation: scroll-left 120s linear infinite;
}

.scroll-container:hover {
  animation-play-state: paused;
}

/* Hide scrollbar but keep scroll functionality */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Clinical Queue expanded row styles */
.clinical-row-expanded {
  color: white;
  border: none;
}

.clinical-cell-expanded {
  border: none;
  background: #0d9488;
}

/* ============================================================
   PUBLIC PAGES — ULTRAMODERN MARKETING EFFECTS
   (Purely visual; additive only)
   ============================================================ */

/* Slow floating aurora blob */
@keyframes blob {
  0%, 100% { transform: translate(0, 0) scale(1); }
  25% { transform: translate(20px, -30px) scale(1.08); }
  50% { transform: translate(-15px, 15px) scale(0.95); }
  75% { transform: translate(10px, 25px) scale(1.05); }
}

.animate-blob {
  animation: blob 14s ease-in-out infinite;
  will-change: transform;
}

.animation-delay-2000 { animation-delay: 2s; }
.animation-delay-4000 { animation-delay: 4s; }
.animation-delay-6000 { animation-delay: 6s; }

/* Animated gradient text sweep */
@keyframes gradient-x {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.animate-gradient-x {
  background-size: 200% auto;
  animation: gradient-x 6s ease infinite;
}

/* Shimmering highlight sweep for pills/badges */
@keyframes shine-sweep {
  0% { transform: translateX(-100%) skewX(-15deg); }
  60%, 100% { transform: translateX(250%) skewX(-15deg); }
}

.shine-sweep {
  position: relative;
  overflow: hidden;
}

.shine-sweep::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 40%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.35), transparent);
  animation: shine-sweep 4.5s ease-in-out infinite;
  pointer-events: none;
}

/* Infinite horizontal marquee (module / proof strips) */
@keyframes marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.animate-marquee {
  animation: marquee 40s linear infinite;
  will-change: transform;
}

.animate-marquee:hover {
  animation-play-state: paused;
}

/* Scroll-triggered reveal (paired with components/public/Reveal.js) */
.landing-page .animate-blob,
.landing-page .animate-glow,
.landing-page .animate-gradient-x {
  animation: none;
}

.landing-page .animate-gradient-x {
  background-size: 100% 100%;
}

.landing-page .animate-blob {
  will-change: auto;
}

.reveal {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1), transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.reveal-visible {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
  .animate-blob,
  .animate-marquee,
  .animate-gradient-x,
  .animate-float,
  .animate-float-delayed,
  .animate-glow,
  .animate-pulse,
  .animate-spin,
  .animate-fadeIn,
  .animate-pageFadeIn,
  .animate-imageFadeIn,
  .animate-fadeInImage,
  .shine-sweep::after,
  .bar-critical-glow,
  .pulse-ring {
    animation: none !important;
  }
  /* Ensure elements that start hidden via animation are visible */
  .animate-fadeIn,
  .animate-pageFadeIn,
  .animate-imageFadeIn,
  .animate-fadeInImage {
    opacity: 1 !important;
  }
}

/* ── Low-power / mobile: disable expensive decorative animations ────── */
/* Applied via the \`low-power\` class on a container element.            */
.low-power .animate-blob,
.low-power .animate-glow,
.low-power .animate-float,
.low-power .animate-float-delayed,
.low-power .animate-marquee,
.low-power .animate-gradient-x,
.low-power .animate-pulse,
.low-power .animate-fadeIn,
.low-power .animate-pageFadeIn,
.low-power .animate-imageFadeIn,
.low-power .animate-slow-blink,
.low-power .animate-slide-in-right,
.low-power .blur-3xl,
.low-power .blur-2xl {
  animation: none !important;
}

/* Remove heavy blur filters on low-power devices (very GPU-expensive) */
.low-power .reveal {
  opacity: 1;
  transform: none;
  transition: none;
}

.low-power .blur-3xl,
.low-power .blur-2xl {
  filter: none !important;
  opacity: 0.5 !important;
}

/* Static marquee: show content without scrolling */
.low-power .animate-marquee {
  transform: none !important;
  flex-wrap: wrap !important;
  overflow: hidden !important;
}

/* Critical pulsing glow when the plan is about to expire */
@keyframes bar-critical-glow {
  0%, 100% { box-shadow: 0 0 2px 1px rgba(239, 68, 68, 0.45); opacity: 0.55; }
  50% { box-shadow: 0 0 9px 3px rgba(239, 68, 68, 0.8); opacity: 1; }
}

.bar-critical-glow {
  animation: bar-critical-glow 1.4s ease-in-out infinite;
}

/* Gentle pulsing ring for CTA emphasis */
@keyframes pulse-ring {
  0% { box-shadow: 0 0 0 0 rgba(20, 184, 166, 0.35); }
  70% { box-shadow: 0 0 0 12px rgba(20, 184, 166, 0); }
  100% { box-shadow: 0 0 0 0 rgba(20, 184, 166, 0); }
}

.animate-pulse-ring {
  animation: pulse-ring 2.6s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Subtle dotted grid backdrop for dark sections */
.dot-grid {
  background-image: radial-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 22px 22px;
}

.dot-grid-light {
  background-image: radial-gradient(rgba(13, 148, 136, 0.10) 1px, transparent 1px);
  background-size: 22px 22px;
}
  .after\\:bg-white::after {
    content: var(--tw-content);
  }
  .after\\:bg-white:is(.dark *)::after {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-white:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

  .hover\\:border-gray-200:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

  .hover\\:text-gray-900:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

  .hover\\:text-gray-700:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

  .hover\\:text-gray-500:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

  .hover\\:text-gray-600:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
  .focus\\:bg-white:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

  .disabled\\:border-gray-200:disabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
  .disabled\\:hover\\:bg-white:hover:disabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

  .disabled\\:hover\\:border-gray-200:hover:disabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

  .group:hover .group-hover\\:text-gray-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

  .group:hover .group-hover\\:text-gray-700:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

  .group:hover .group-hover\\:text-gray-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

  .group:hover .group-hover\\:text-gray-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
  .dark\\:bg-white:is(.dark *):is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

  .dark\\:text-gray-900:is(.dark *):is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

  .dark\\:text-gray-700:is(.dark *):is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

  .dark\\:text-gray-500:is(.dark *):is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

  .dark\\:text-gray-600:is(.dark *):is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

  .dark\\:placeholder\\:text-gray-500:is(.dark *):is(.dark *)::placeholder {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

  .dark\\:placeholder\\:text-gray-600:is(.dark *):is(.dark *)::placeholder {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

  .dark\\:disabled\\:text-gray-500:disabled:is(.dark *):is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.selection\\:bg-teal-500\\/30 *::selection {
  background-color: rgb(20 184 166 / 0.3);
}

.selection\\:bg-teal-500\\/30::selection {
  background-color: rgb(20 184 166 / 0.3);
}

.file\\:mr-2::file-selector-button {
  margin-right: 0.5rem;
}

.file\\:rounded-lg::file-selector-button {
  border-radius: 0.5rem;
}

.file\\:border-0::file-selector-button {
  border-width: 0px;
}

.file\\:bg-indigo-100::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.file\\:px-2\\.5::file-selector-button {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}

.file\\:py-1::file-selector-button {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.file\\:text-\\[11px\\]::file-selector-button {
  font-size: 11px;
}

.file\\:font-semibold::file-selector-button {
  font-weight: 600;
}

.file\\:text-indigo-700::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-base::placeholder {
  font-size: 1rem;
  line-height: 1.5rem;
}

.placeholder\\:tracking-normal::placeholder {
  letter-spacing: 0em;
}

.placeholder\\:text-gray-300::placeholder {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-gray-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:left-\\[2px\\]::after {
  content: var(--tw-content);
  left: 2px;
}

.after\\:top-\\[2px\\]::after {
  content: var(--tw-content);
  top: 2px;
}

.after\\:h-2\\.5::after {
  content: var(--tw-content);
  height: 0.625rem;
}

.after\\:h-3::after {
  content: var(--tw-content);
  height: 0.75rem;
}

.after\\:w-2\\.5::after {
  content: var(--tw-content);
  width: 0.625rem;
}

.after\\:w-3::after {
  content: var(--tw-content);
  width: 0.75rem;
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}

.after\\:border-gray-300::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

.last\\:mb-0:last-child {
  margin-bottom: 0px;
}

.last\\:border-0:last-child {
  border-width: 0px;
}

.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}

.last\\:pb-0:last-child {
  padding-bottom: 0px;
}

.focus-within\\:border-pink-300:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / var(--tw-border-opacity, 1));
}

.focus-within\\:border-teal-300:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity, 1));
}

.focus-within\\:border-teal-400\\/60:focus-within {
  border-color: rgb(45 212 191 / 0.6);
}

.focus-within\\:bg-white\\/80:focus-within {
  background-color: rgb(255 255 255 / 0.8);
}

.focus-within\\:shadow-sm:focus-within {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus-within\\:ring-1:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-teal-400:focus-within {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 212 191 / var(--tw-ring-opacity, 1));
}

.focus-within\\:ring-teal-400\\/20:focus-within {
  --tw-ring-color: rgb(45 212 191 / 0.2);
}

.focus-within\\:ring-offset-1:focus-within {
  --tw-ring-offset-width: 1px;
}

.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-px:hover {
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:translate-x-0\\.5:hover {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:rotate-3:hover {
  --tw-rotate: 3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:rotate-90:hover {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.005\\]:hover {
  --tw-scale-x: 1.005;
  --tw-scale-y: 1.005;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.01\\]:hover {
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.03\\]:hover {
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-amber-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}

.hover\\:border-amber-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}

.hover\\:border-amber-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}

.hover\\:border-amber-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-300\\/70:hover {
  border-color: rgb(147 197 253 / 0.7);
}

.hover\\:border-blue-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.hover\\:border-cyan-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity, 1));
}

.hover\\:border-emerald-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}

.hover\\:border-emerald-200\\/50:hover {
  border-color: rgb(167 243 208 / 0.5);
}

.hover\\:border-emerald-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-300\\/80:hover {
  border-color: rgb(209 213 219 / 0.8);
}

.hover\\:border-gray-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-900\\/30:hover {
  border-color: rgb(17 24 39 / 0.3);
}

.hover\\:border-green-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}

.hover\\:border-green-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}

.hover\\:border-green-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}

.hover\\:border-orange-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}

.hover\\:border-orange-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
}

.hover\\:border-orange-300\\/70:hover {
  border-color: rgb(253 186 116 / 0.7);
}

.hover\\:border-pink-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}

.hover\\:border-pink-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / var(--tw-border-opacity, 1));
}

.hover\\:border-pink-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(128 218 202 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-300\\/70:hover {
  border-color: rgb(216 180 254 / 0.7);
}

.hover\\:border-purple-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

.hover\\:border-rose-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}

.hover\\:border-rose-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}

.hover\\:border-sky-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity, 1));
}

.hover\\:border-slate-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}

.hover\\:border-teal-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(204 251 241 / var(--tw-border-opacity, 1));
}

.hover\\:border-teal-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity, 1));
}

.hover\\:border-teal-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity, 1));
}

.hover\\:border-teal-300\\/70:hover {
  border-color: rgb(94 234 212 / 0.7);
}

.hover\\:border-teal-300\\/80:hover {
  border-color: rgb(94 234 212 / 0.8);
}

.hover\\:border-teal-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity, 1));
}

.hover\\:border-teal-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}

.hover\\:border-teal-500\\/30:hover {
  border-color: rgb(20 184 166 / 0.3);
}

.hover\\:border-teal-500\\/50:hover {
  border-color: rgb(20 184 166 / 0.5);
}

.hover\\:border-transparent:hover {
  border-color: transparent;
}

.hover\\:border-violet-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-yellow-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}

.hover\\:bg-amber-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-50\\/30:hover {
  background-color: rgb(255 251 235 / 0.3);
}

.hover\\:bg-amber-50\\/40:hover {
  background-color: rgb(255 251 235 / 0.4);
}

.hover\\:bg-amber-50\\/50:hover {
  background-color: rgb(255 251 235 / 0.5);
}

.hover\\:bg-amber-50\\/60:hover {
  background-color: rgb(255 251 235 / 0.6);
}

.hover\\:bg-amber-50\\/80:hover {
  background-color: rgb(255 251 235 / 0.8);
}

.hover\\:bg-amber-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-black\\/10:hover {
  background-color: rgb(0 0 0 / 0.1);
}

.hover\\:bg-black\\/\\[0\\.05\\]:hover {
  background-color: rgb(0 0 0 / 0.05);
}

.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-100\\/80:hover {
  background-color: rgb(219 234 254 / 0.8);
}

.hover\\:bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50\\/30:hover {
  background-color: rgb(239 246 255 / 0.3);
}

.hover\\:bg-blue-50\\/40:hover {
  background-color: rgb(239 246 255 / 0.4);
}

.hover\\:bg-blue-50\\/50:hover {
  background-color: rgb(239 246 255 / 0.5);
}

.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-50\\/20:hover {
  background-color: rgb(236 253 245 / 0.2);
}

.hover\\:bg-emerald-50\\/40:hover {
  background-color: rgb(236 253 245 / 0.4);
}

.hover\\:bg-emerald-50\\/80:hover {
  background-color: rgb(236 253 245 / 0.8);
}

.hover\\:bg-emerald-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-500\\/20:hover {
  background-color: rgb(16 185 129 / 0.2);
}

.hover\\:bg-emerald-500\\/30:hover {
  background-color: rgb(16 185 129 / 0.3);
}

.hover\\:bg-emerald-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100\\/50:hover {
  background-color: rgb(243 244 246 / 0.5);
}

.hover\\:bg-gray-100\\/80:hover {
  background-color: rgb(243 244 246 / 0.8);
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200\\/60:hover {
  background-color: rgb(229 231 235 / 0.6);
}

.hover\\:bg-gray-200\\/70:hover {
  background-color: rgb(229 231 235 / 0.7);
}

.hover\\:bg-gray-200\\/80:hover {
  background-color: rgb(229 231 235 / 0.8);
}

.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-300\\/60:hover {
  background-color: rgb(209 213 219 / 0.6);
}

.hover\\:bg-gray-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50\\/30:hover {
  background-color: rgb(249 250 251 / 0.3);
}

.hover\\:bg-gray-50\\/40:hover {
  background-color: rgb(249 250 251 / 0.4);
}

.hover\\:bg-gray-50\\/50:hover {
  background-color: rgb(249 250 251 / 0.5);
}

.hover\\:bg-gray-50\\/60:hover {
  background-color: rgb(249 250 251 / 0.6);
}

.hover\\:bg-gray-50\\/70:hover {
  background-color: rgb(249 250 251 / 0.7);
}

.hover\\:bg-gray-50\\/80:hover {
  background-color: rgb(249 250 251 / 0.8);
}

.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-500\\/20:hover {
  background-color: rgb(107 114 128 / 0.2);
}

.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700\\/50:hover {
  background-color: rgb(55 65 81 / 0.5);
}

.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-900\\/\\[0\\.04\\]:hover {
  background-color: rgb(17 24 39 / 0.04);
}

.hover\\:bg-green-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-50\\/40:hover {
  background-color: rgb(240 253 244 / 0.4);
}

.hover\\:bg-green-50\\/80:hover {
  background-color: rgb(240 253 244 / 0.8);
}

.hover\\:bg-green-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-500\\/20:hover {
  background-color: rgb(34 197 94 / 0.2);
}

.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-50\\/20:hover {
  background-color: rgb(238 242 255 / 0.2);
}

.hover\\:bg-indigo-50\\/40:hover {
  background-color: rgb(238 242 255 / 0.4);
}

.hover\\:bg-indigo-500\\/30:hover {
  background-color: rgb(99 102 241 / 0.3);
}

.hover\\:bg-indigo-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-100\\/80:hover {
  background-color: rgb(255 237 213 / 0.8);
}

.hover\\:bg-orange-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-500\\/20:hover {
  background-color: rgb(249 115 22 / 0.2);
}

.hover\\:bg-orange-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(154 52 18 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-pink-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 232 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-pink-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-pink-50\\/50:hover {
  background-color: rgb(253 242 248 / 0.5);
}

.hover\\:bg-pink-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(190 24 93 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(179 232 224 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(230 247 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-50\\/80:hover {
  background-color: rgb(230 247 245 / 0.8);
}

.hover\\:bg-primary-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 128 105 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(19 111 90 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-100\\/50:hover {
  background-color: rgb(243 232 255 / 0.5);
}

.hover\\:bg-purple-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-50\\/20:hover {
  background-color: rgb(250 245 255 / 0.2);
}

.hover\\:bg-purple-50\\/30:hover {
  background-color: rgb(250 245 255 / 0.3);
}

.hover\\:bg-purple-50\\/40:hover {
  background-color: rgb(250 245 255 / 0.4);
}

.hover\\:bg-purple-50\\/50:hover {
  background-color: rgb(250 245 255 / 0.5);
}

.hover\\:bg-purple-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-200\\/80:hover {
  background-color: rgb(254 202 202 / 0.8);
}

.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50\\/30:hover {
  background-color: rgb(254 242 242 / 0.3);
}

.hover\\:bg-red-50\\/50:hover {
  background-color: rgb(254 242 242 / 0.5);
}

.hover\\:bg-red-50\\/60:hover {
  background-color: rgb(254 242 242 / 0.6);
}

.hover\\:bg-red-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-500\\/20:hover {
  background-color: rgb(239 68 68 / 0.2);
}

.hover\\:bg-red-500\\/30:hover {
  background-color: rgb(239 68 68 / 0.3);
}

.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-50\\/30:hover {
  background-color: rgb(255 241 242 / 0.3);
}

.hover\\:bg-rose-50\\/70:hover {
  background-color: rgb(255 241 242 / 0.7);
}

.hover\\:bg-rose-500\\/20:hover {
  background-color: rgb(244 63 94 / 0.2);
}

.hover\\:bg-rose-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-sky-50\\/60:hover {
  background-color: rgb(240 249 255 / 0.6);
}

.hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50\\/40:hover {
  background-color: rgb(248 250 252 / 0.4);
}

.hover\\:bg-slate-500\\/20:hover {
  background-color: rgb(100 116 139 / 0.2);
}

.hover\\:bg-slate-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-100\\/50:hover {
  background-color: rgb(204 251 241 / 0.5);
}

.hover\\:bg-teal-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-50\\/20:hover {
  background-color: rgb(240 253 250 / 0.2);
}

.hover\\:bg-teal-50\\/30:hover {
  background-color: rgb(240 253 250 / 0.3);
}

.hover\\:bg-teal-50\\/40:hover {
  background-color: rgb(240 253 250 / 0.4);
}

.hover\\:bg-teal-50\\/50:hover {
  background-color: rgb(240 253 250 / 0.5);
}

.hover\\:bg-teal-50\\/60:hover {
  background-color: rgb(240 253 250 / 0.6);
}

.hover\\:bg-teal-50\\/80:hover {
  background-color: rgb(240 253 250 / 0.8);
}

.hover\\:bg-teal-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-500\\/20:hover {
  background-color: rgb(20 184 166 / 0.2);
}

.hover\\:bg-teal-500\\/30:hover {
  background-color: rgb(20 184 166 / 0.3);
}

.hover\\:bg-teal-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-violet-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-violet-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-violet-50\\/30:hover {
  background-color: rgb(245 243 255 / 0.3);
}

.hover\\:bg-violet-500\\/20:hover {
  background-color: rgb(139 92 246 / 0.2);
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-white\\/15:hover {
  background-color: rgb(255 255 255 / 0.15);
}

.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:bg-white\\/25:hover {
  background-color: rgb(255 255 255 / 0.25);
}

.hover\\:bg-white\\/30:hover {
  background-color: rgb(255 255 255 / 0.3);
}

.hover\\:bg-white\\/35:hover {
  background-color: rgb(255 255 255 / 0.35);
}

.hover\\:bg-white\\/40:hover {
  background-color: rgb(255 255 255 / 0.4);
}

.hover\\:bg-white\\/5:hover {
  background-color: rgb(255 255 255 / 0.05);
}

.hover\\:bg-white\\/50:hover {
  background-color: rgb(255 255 255 / 0.5);
}

.hover\\:bg-white\\/60:hover {
  background-color: rgb(255 255 255 / 0.6);
}

.hover\\:bg-white\\/70:hover {
  background-color: rgb(255 255 255 / 0.7);
}

.hover\\:bg-white\\/80:hover {
  background-color: rgb(255 255 255 / 0.8);
}

.hover\\:bg-white\\/90:hover {
  background-color: rgb(255 255 255 / 0.9);
}

.hover\\:bg-yellow-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-yellow-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-yellow-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gradient-to-r:hover {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.hover\\:from-amber-500:hover {
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-amber-600:hover {
  --tw-gradient-from: #d97706 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 119 6 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blue-100:hover {
  --tw-gradient-from: #dbeafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 234 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blue-50\\/40:hover {
  --tw-gradient-from: rgb(239 246 255 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blue-600:hover {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-cyan-600:hover {
  --tw-gradient-from: #0891b2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(8 145 178 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-cyan-700:hover {
  --tw-gradient-from: #0e7490 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 116 144 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-emerald-50\\/30:hover {
  --tw-gradient-from: rgb(236 253 245 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-emerald-600:hover {
  --tw-gradient-from: #059669 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 150 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-emerald-700:hover {
  --tw-gradient-from: #047857 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(4 120 87 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-gray-50\\/80:hover {
  --tw-gradient-from: rgb(249 250 251 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-gray-800:hover {
  --tw-gradient-from: #1f2937 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(31 41 55 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-green-600:hover {
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-indigo-100:hover {
  --tw-gradient-from: #e0e7ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(224 231 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-indigo-600:hover {
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-indigo-700:hover {
  --tw-gradient-from: #4338ca var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 56 202 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-orange-100:hover {
  --tw-gradient-from: #ffedd5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 237 213 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-orange-600:hover {
  --tw-gradient-from: #ea580c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 88 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-pink-600:hover {
  --tw-gradient-from: #db2777 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 39 119 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-primary-600:hover {
  --tw-gradient-from: #168069 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 128 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-600:hover {
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-700:hover {
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-red-600:hover {
  --tw-gradient-from: #dc2626 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 38 38 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-red-700:hover {
  --tw-gradient-from: #b91c1c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(185 28 28 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-rose-600:hover {
  --tw-gradient-from: #e11d48 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(225 29 72 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-sky-600:hover {
  --tw-gradient-from: #0284c7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 132 199 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-slate-700:hover {
  --tw-gradient-from: #334155 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(51 65 85 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-teal-100:hover {
  --tw-gradient-from: #ccfbf1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(204 251 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-teal-50:hover {
  --tw-gradient-from: #f0fdfa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-teal-50\\/80:hover {
  --tw-gradient-from: rgb(240 253 250 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-teal-500:hover {
  --tw-gradient-from: #14b8a6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-teal-600:hover {
  --tw-gradient-from: #0d9488 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(13 148 136 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-teal-700:hover {
  --tw-gradient-from: #0f766e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 118 110 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-violet-600:hover {
  --tw-gradient-from: #7c3aed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:via-white:hover {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.hover\\:to-amber-100:hover {
  --tw-gradient-to: #fef3c7 var(--tw-gradient-to-position);
}

.hover\\:to-amber-600:hover {
  --tw-gradient-to: #d97706 var(--tw-gradient-to-position);
}

.hover\\:to-amber-700:hover {
  --tw-gradient-to: #b45309 var(--tw-gradient-to-position);
}

.hover\\:to-blue-100:hover {
  --tw-gradient-to: #dbeafe var(--tw-gradient-to-position);
}

.hover\\:to-blue-50:hover {
  --tw-gradient-to: #eff6ff var(--tw-gradient-to-position);
}

.hover\\:to-blue-50\\/40:hover {
  --tw-gradient-to: rgb(239 246 255 / 0.4) var(--tw-gradient-to-position);
}

.hover\\:to-blue-600:hover {
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}

.hover\\:to-blue-700:hover {
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}

.hover\\:to-cyan-100:hover {
  --tw-gradient-to: #cffafe var(--tw-gradient-to-position);
}

.hover\\:to-cyan-50:hover {
  --tw-gradient-to: #ecfeff var(--tw-gradient-to-position);
}

.hover\\:to-cyan-600:hover {
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}

.hover\\:to-cyan-700:hover {
  --tw-gradient-to: #0e7490 var(--tw-gradient-to-position);
}

.hover\\:to-emerald-500:hover {
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}

.hover\\:to-emerald-600:hover {
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}

.hover\\:to-emerald-700:hover {
  --tw-gradient-to: #047857 var(--tw-gradient-to-position);
}

.hover\\:to-emerald-800:hover {
  --tw-gradient-to: #065f46 var(--tw-gradient-to-position);
}

.hover\\:to-fuchsia-700:hover {
  --tw-gradient-to: #a21caf var(--tw-gradient-to-position);
}

.hover\\:to-gray-50\\/80:hover {
  --tw-gradient-to: rgb(249 250 251 / 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-gray-800:hover {
  --tw-gradient-to: #1f2937 var(--tw-gradient-to-position);
}

.hover\\:to-gray-900:hover {
  --tw-gradient-to: #111827 var(--tw-gradient-to-position);
}

.hover\\:to-green-700:hover {
  --tw-gradient-to: #15803d var(--tw-gradient-to-position);
}

.hover\\:to-indigo-600:hover {
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}

.hover\\:to-indigo-700:hover {
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}

.hover\\:to-orange-500:hover {
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}

.hover\\:to-orange-600:hover {
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}

.hover\\:to-orange-700:hover {
  --tw-gradient-to: #c2410c var(--tw-gradient-to-position);
}

.hover\\:to-pink-600:hover {
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}

.hover\\:to-primary-500:hover {
  --tw-gradient-to: #1a9179 var(--tw-gradient-to-position);
}

.hover\\:to-primary-700:hover {
  --tw-gradient-to: #136f5a var(--tw-gradient-to-position);
}

.hover\\:to-purple-600:hover {
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}

.hover\\:to-purple-700:hover {
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}

.hover\\:to-red-600:hover {
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}

.hover\\:to-red-700:hover {
  --tw-gradient-to: #b91c1c var(--tw-gradient-to-position);
}

.hover\\:to-red-800:hover {
  --tw-gradient-to: #991b1b var(--tw-gradient-to-position);
}

.hover\\:to-rose-600:hover {
  --tw-gradient-to: #e11d48 var(--tw-gradient-to-position);
}

.hover\\:to-rose-700:hover {
  --tw-gradient-to: #be123c var(--tw-gradient-to-position);
}

.hover\\:to-sky-700:hover {
  --tw-gradient-to: #0369a1 var(--tw-gradient-to-position);
}

.hover\\:to-teal-50\\/30:hover {
  --tw-gradient-to: rgb(240 253 250 / 0.3) var(--tw-gradient-to-position);
}

.hover\\:to-teal-500:hover {
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}

.hover\\:to-teal-600:hover {
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}

.hover\\:to-teal-700:hover {
  --tw-gradient-to: #0f766e var(--tw-gradient-to-position);
}

.hover\\:to-transparent:hover {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}

.hover\\:to-violet-600:hover {
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}

.hover\\:to-violet-700:hover {
  --tw-gradient-to: #6d28d9 var(--tw-gradient-to-position);
}

.hover\\:text-amber-500:hover {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}

.hover\\:text-amber-600:hover {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}

.hover\\:text-amber-700:hover {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}

.hover\\:text-amber-800:hover {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-900:hover {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}

.hover\\:text-cyan-600:hover {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-500:hover {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-600:hover {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-700:hover {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-800:hover {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-200:hover {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-400:hover {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-500:hover {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-600:hover {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-700:hover {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-600:hover {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-700:hover {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-800:hover {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}

.hover\\:text-orange-500:hover {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}

.hover\\:text-orange-600:hover {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}

.hover\\:text-orange-700:hover {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}

.hover\\:text-orange-800:hover {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}

.hover\\:text-orange-900:hover {
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity, 1));
}

.hover\\:text-pink-600:hover {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}

.hover\\:text-pink-700:hover {
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}

.hover\\:text-pink-800:hover {
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-600:hover {
  --tw-text-opacity: 1;
  color: rgb(22 128 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-700:hover {
  --tw-text-opacity: 1;
  color: rgb(19 111 90 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-800:hover {
  --tw-text-opacity: 1;
  color: rgb(15 93 74 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-500:hover {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-600:hover {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-700:hover {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-800:hover {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-900:hover {
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-400:hover {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-800:hover {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-900:hover {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-500:hover {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-600:hover {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-700:hover {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-800:hover {
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}

.hover\\:text-sky-600:hover {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-500:hover {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-600:hover {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-700:hover {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.hover\\:text-teal-400:hover {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}

.hover\\:text-teal-500:hover {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity, 1));
}

.hover\\:text-teal-600:hover {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}

.hover\\:text-teal-700:hover {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}

.hover\\:text-teal-800:hover {
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity, 1));
}

.hover\\:text-teal-900:hover {
  --tw-text-opacity: 1;
  color: rgb(19 78 74 / var(--tw-text-opacity, 1));
}

.hover\\:text-violet-600:hover {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}

.hover\\:text-violet-700:hover {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.hover\\:opacity-90:hover {
  opacity: 0.9;
}

.hover\\:shadow:hover {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_2px_6px_rgba\\(124\\2c 58\\2c 237\\2c 0\\.3\\)\\]:hover {
  --tw-shadow: 0 2px 6px rgba(124,58,237,0.3);
  --tw-shadow-colored: 0 2px 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_2px_8px_rgba\\(13\\2c 148\\2c 136\\2c 0\\.3\\)\\]:hover {
  --tw-shadow: 0 2px 8px rgba(13,148,136,0.3);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_4px_12px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.25\\)\\]:hover {
  --tw-shadow: 0 4px 12px rgba(16,185,129,0.25);
  --tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_6px_16px_-2px_rgba\\(20\\2c 184\\2c 166\\2c 0\\.5\\)\\]:hover {
  --tw-shadow: 0 6px 16px -2px rgba(20,184,166,0.5);
  --tw-shadow-colored: 0 6px 16px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-amber-100\\/50:hover {
  --tw-shadow-color: rgb(254 243 199 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-amber-500\\/20:hover {
  --tw-shadow-color: rgb(245 158 11 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-amber-500\\/30:hover {
  --tw-shadow-color: rgb(245 158 11 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-500\\/25:hover {
  --tw-shadow-color: rgb(59 130 246 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-500\\/30:hover {
  --tw-shadow-color: rgb(59 130 246 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-cyan-500\\/25:hover {
  --tw-shadow-color: rgb(6 182 212 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-cyan-500\\/30:hover {
  --tw-shadow-color: rgb(6 182 212 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-emerald-500\\/25:hover {
  --tw-shadow-color: rgb(16 185 129 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-emerald-500\\/30:hover {
  --tw-shadow-color: rgb(16 185 129 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-gray-200\\/50:hover {
  --tw-shadow-color: rgb(229 231 235 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-gray-400\\/25:hover {
  --tw-shadow-color: rgb(156 163 175 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-gray-500\\/25:hover {
  --tw-shadow-color: rgb(107 114 128 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-gray-900\\/5:hover {
  --tw-shadow-color: rgb(17 24 39 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-green-100\\/50:hover {
  --tw-shadow-color: rgb(220 252 231 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-indigo-400\\/40:hover {
  --tw-shadow-color: rgb(129 140 248 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-indigo-500\\/25:hover {
  --tw-shadow-color: rgb(99 102 241 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-orange-500\\/25:hover {
  --tw-shadow-color: rgb(249 115 22 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-orange-500\\/30:hover {
  --tw-shadow-color: rgb(249 115 22 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-pink-500\\/25:hover {
  --tw-shadow-color: rgb(236 72 153 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-purple-500\\/25:hover {
  --tw-shadow-color: rgb(168 85 247 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-purple-500\\/30:hover {
  --tw-shadow-color: rgb(168 85 247 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-red-100\\/50:hover {
  --tw-shadow-color: rgb(254 226 226 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-red-500\\/25:hover {
  --tw-shadow-color: rgb(239 68 68 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-red-500\\/30:hover {
  --tw-shadow-color: rgb(239 68 68 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-rose-500\\/25:hover {
  --tw-shadow-color: rgb(244 63 94 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-slate-500\\/25:hover {
  --tw-shadow-color: rgb(100 116 139 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-teal-500\\/10:hover {
  --tw-shadow-color: rgb(20 184 166 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-teal-500\\/20:hover {
  --tw-shadow-color: rgb(20 184 166 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-teal-500\\/25:hover {
  --tw-shadow-color: rgb(20 184 166 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-teal-500\\/30:hover {
  --tw-shadow-color: rgb(20 184 166 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-teal-500\\/40:hover {
  --tw-shadow-color: rgb(20 184 166 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-teal-500\\/5:hover {
  --tw-shadow-color: rgb(20 184 166 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-white\\/10:hover {
  --tw-shadow-color: rgb(255 255 255 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:ring-1:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.hover\\:ring-2:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.hover\\:ring-gray-300:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}

.hover\\:ring-purple-300:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(216 180 254 / var(--tw-ring-opacity, 1));
}

.hover\\:ring-rose-200:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity, 1));
}

.hover\\:ring-teal-200:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 246 228 / var(--tw-ring-opacity, 1));
}

.hover\\:ring-teal-500:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(20 184 166 / var(--tw-ring-opacity, 1));
}

.hover\\:brightness-95:hover {
  --tw-brightness: brightness(.95);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:grayscale-0:hover {
  --tw-grayscale: grayscale(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:file\\:bg-indigo-200::file-selector-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity, 1));
}

.focus\\:border-amber-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}

.focus\\:border-amber-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}

.focus\\:border-blue-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.focus\\:border-blue-400\\/60:focus {
  border-color: rgb(96 165 250 / 0.6);
}

.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.focus\\:border-emerald-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}

.focus\\:border-emerald-500\\/50:focus {
  border-color: rgb(16 185 129 / 0.5);
}

.focus\\:border-gray-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}

.focus\\:border-gray-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}

.focus\\:border-green-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-300:focus {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-400\\/60:focus {
  border-color: rgb(129 140 248 / 0.6);
}

.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.focus\\:border-orange-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
}

.focus\\:border-pink-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(244 114 182 / var(--tw-border-opacity, 1));
}

.focus\\:border-pink-400\\/60:focus {
  border-color: rgb(244 114 182 / 0.6);
}

.focus\\:border-primary-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(45 190 165 / var(--tw-border-opacity, 1));
}

.focus\\:border-primary-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(26 145 121 / var(--tw-border-opacity, 1));
}

.focus\\:border-purple-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
}

.focus\\:border-purple-400\\/60:focus {
  border-color: rgb(192 132 252 / 0.6);
}

.focus\\:border-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}

.focus\\:border-red-300\\/60:focus {
  border-color: rgb(252 165 165 / 0.6);
}

.focus\\:border-rose-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity, 1));
}

.focus\\:border-sky-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / var(--tw-border-opacity, 1));
}

.focus\\:border-slate-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}

.focus\\:border-slate-700:focus {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}

.focus\\:border-teal-300\\/50:focus {
  border-color: rgb(94 234 212 / 0.5);
}

.focus\\:border-teal-300\\/60:focus {
  border-color: rgb(94 234 212 / 0.6);
}

.focus\\:border-teal-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity, 1));
}

.focus\\:border-teal-400\\/30:focus {
  border-color: rgb(45 212 191 / 0.3);
}

.focus\\:border-teal-400\\/60:focus {
  border-color: rgb(45 212 191 / 0.6);
}

.focus\\:border-teal-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}

.focus\\:border-teal-500\\/50:focus {
  border-color: rgb(20 184 166 / 0.5);
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:border-violet-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}

.focus\\:border-violet-400\\/60:focus {
  border-color: rgb(167 139 250 / 0.6);
}

.focus\\:bg-slate-50:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:shadow-md:focus {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:shadow-sm:focus {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:shadow-green-100:focus {
  --tw-shadow-color: #dcfce7;
  --tw-shadow: var(--tw-shadow-colored);
}

.focus\\:shadow-primary-100:focus {
  --tw-shadow-color: #b3e8e0;
  --tw-shadow: var(--tw-shadow-colored);
}

.focus\\:shadow-teal-100\\/30:focus {
  --tw-shadow-color: rgb(204 251 241 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[0\\.5px\\]:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0.5px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[1px\\]:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-amber-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-amber-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 158 11 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-amber-500\\/20:focus {
  --tw-ring-color: rgb(245 158 11 / 0.2);
}

.focus\\:ring-amber-500\\/30:focus {
  --tw-ring-color: rgb(245 158 11 / 0.3);
}

.focus\\:ring-blue-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-500\\/20:focus {
  --tw-ring-color: rgb(59 130 246 / 0.2);
}

.focus\\:ring-blue-500\\/30:focus {
  --tw-ring-color: rgb(59 130 246 / 0.3);
}

.focus\\:ring-cyan-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 211 238 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-cyan-500\\/20:focus {
  --tw-ring-color: rgb(6 182 212 / 0.2);
}

.focus\\:ring-emerald-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(52 211 153 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-emerald-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-emerald-500\\/20:focus {
  --tw-ring-color: rgb(16 185 129 / 0.2);
}

.focus\\:ring-emerald-500\\/30:focus {
  --tw-ring-color: rgb(16 185 129 / 0.3);
}

.focus\\:ring-gray-400\\/30:focus {
  --tw-ring-color: rgb(156 163 175 / 0.3);
}

.focus\\:ring-gray-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-gray-500\\/30:focus {
  --tw-ring-color: rgb(107 114 128 / 0.3);
}

.focus\\:ring-green-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(187 247 208 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-green-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 222 128 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-green-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-100:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-400\\/30:focus {
  --tw-ring-color: rgb(129 140 248 / 0.3);
}

.focus\\:ring-indigo-400\\/50:focus {
  --tw-ring-color: rgb(129 140 248 / 0.5);
}

.focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-500\\/15:focus {
  --tw-ring-color: rgb(99 102 241 / 0.15);
}

.focus\\:ring-indigo-500\\/30:focus {
  --tw-ring-color: rgb(99 102 241 / 0.3);
}

.focus\\:ring-indigo-500\\/40:focus {
  --tw-ring-color: rgb(99 102 241 / 0.4);
}

.focus\\:ring-orange-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-orange-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 146 60 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-orange-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 115 22 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-orange-500\\/20:focus {
  --tw-ring-color: rgb(249 115 22 / 0.2);
}

.focus\\:ring-pink-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 114 182 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-pink-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(236 72 153 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-pink-500\\/20:focus {
  --tw-ring-color: rgb(236 72 153 / 0.2);
}

.focus\\:ring-pink-500\\/30:focus {
  --tw-ring-color: rgb(236 72 153 / 0.3);
}

.focus\\:ring-primary-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 190 165 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-primary-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(26 145 121 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(192 132 252 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-500\\/20:focus {
  --tw-ring-color: rgb(168 85 247 / 0.2);
}

.focus\\:ring-purple-500\\/30:focus {
  --tw-ring-color: rgb(168 85 247 / 0.3);
}

.focus\\:ring-purple-500\\/40:focus {
  --tw-ring-color: rgb(168 85 247 / 0.4);
}

.focus\\:ring-red-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-400\\/50:focus {
  --tw-ring-color: rgb(248 113 113 / 0.5);
}

.focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-500\\/20:focus {
  --tw-ring-color: rgb(239 68 68 / 0.2);
}

.focus\\:ring-rose-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 63 94 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-rose-500\\/30:focus {
  --tw-ring-color: rgb(244 63 94 / 0.3);
}

.focus\\:ring-sky-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(56 189 248 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-slate-500\\/20:focus {
  --tw-ring-color: rgb(100 116 139 / 0.2);
}

.focus\\:ring-teal-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 246 228 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-teal-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 212 191 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-teal-400\\/20:focus {
  --tw-ring-color: rgb(45 212 191 / 0.2);
}

.focus\\:ring-teal-400\\/30:focus {
  --tw-ring-color: rgb(45 212 191 / 0.3);
}

.focus\\:ring-teal-400\\/40:focus {
  --tw-ring-color: rgb(45 212 191 / 0.4);
}

.focus\\:ring-teal-400\\/50:focus {
  --tw-ring-color: rgb(45 212 191 / 0.5);
}

.focus\\:ring-teal-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(20 184 166 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-teal-500\\/15:focus {
  --tw-ring-color: rgb(20 184 166 / 0.15);
}

.focus\\:ring-teal-500\\/20:focus {
  --tw-ring-color: rgb(20 184 166 / 0.2);
}

.focus\\:ring-teal-500\\/30:focus {
  --tw-ring-color: rgb(20 184 166 / 0.3);
}

.focus\\:ring-teal-500\\/40:focus {
  --tw-ring-color: rgb(20 184 166 / 0.4);
}

.focus\\:ring-teal-500\\/50:focus {
  --tw-ring-color: rgb(20 184 166 / 0.5);
}

.focus\\:ring-violet-500\\/40:focus {
  --tw-ring-color: rgb(139 92 246 / 0.4);
}

.focus\\:ring-offset-0:focus {
  --tw-ring-offset-width: 0px;
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-inset:focus-visible {
  --tw-ring-inset: inset;
}

.focus-visible\\:ring-indigo-400:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-indigo-500:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-rose-200:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-teal-500:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(20 184 166 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-violet-300\\/50:focus-visible {
  --tw-ring-color: rgb(196 181 253 / 0.5);
}

.active\\:scale-90:active {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.97\\]:active {
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.99\\]:active {
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active {
  cursor: grabbing;
}

.disabled\\:cursor-default:disabled {
  cursor: default;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:border-gray-200:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}

.disabled\\:bg-gray-100:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-200:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-300:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-400:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.disabled\\:from-gray-300:disabled {
  --tw-gradient-from: #d1d5db var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(209 213 219 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.disabled\\:to-gray-400:disabled {
  --tw-gradient-to: #9ca3af var(--tw-gradient-to-position);
}

.disabled\\:text-gray-300:disabled {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.disabled\\:text-gray-400:disabled {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.disabled\\:no-underline:disabled {
  text-decoration-line: none;
}

.disabled\\:opacity-25:disabled {
  opacity: 0.25;
}

.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}

.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

.disabled\\:hover\\:scale-100:hover:disabled {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.disabled\\:hover\\:border-gray-200:hover:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}

.disabled\\:hover\\:bg-white:hover:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.disabled\\:active\\:scale-100:active:disabled {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:focus-within .group-focus-within\\:border-teal-300\\/60 {
  border-color: rgb(94 234 212 / 0.6);
}

.group:focus-within .group-focus-within\\:bg-teal-50\\/80 {
  background-color: rgb(240 253 250 / 0.8);
}

.group:focus-within .group-focus-within\\:text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity, 1));
}

.group:focus-within .group-focus-within\\:text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}

.group\\/tooltip:hover .group-hover\\/tooltip\\:visible {
  visibility: visible;
}

.group:hover .group-hover\\:visible {
  visibility: visible;
}

.group\\/act:hover .group-hover\\/act\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/action:hover .group-hover\\/action\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/approve:hover .group-hover\\/approve\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/btn:hover .group-hover\\/btn\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/consult:hover .group-hover\\/consult\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/continue:hover .group-hover\\/continue\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/del:hover .group-hover\\/del\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/delete:hover .group-hover\\/delete\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/delivery:hover .group-hover\\/delivery\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/details:hover .group-hover\\/details\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/dispo:hover .group-hover\\/dispo\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/edit:hover .group-hover\\/edit\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/history:hover .group-hover\\/history\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/idel:hover .group-hover\\/idel\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/pdf:hover .group-hover\\/pdf\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/print:hover .group-hover\\/print\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/reject:hover .group-hover\\/reject\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/services:hover .group-hover\\/services\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/view:hover .group-hover\\/view\\:ml-1 {
  margin-left: 0.25rem;
}

.group\\/visit:hover .group-hover\\/visit\\:ml-1 {
  margin-left: 0.25rem;
}

.group:hover .group-hover\\:ml-0\\.5 {
  margin-left: 0.125rem;
}

.group:hover .group-hover\\:ml-1 {
  margin-left: 0.25rem;
}

.group:hover .group-hover\\:ml-1\\.5 {
  margin-left: 0.375rem;
}

.group:hover .group-hover\\:block {
  display: block;
}

.group\\/action:hover .group-hover\\/action\\:inline {
  display: inline;
}

.group:hover .group-hover\\:inline {
  display: inline;
}

.group:hover .group-hover\\:flex {
  display: flex;
}

.group:hover .group-hover\\:inline-flex {
  display: inline-flex;
}

.group\\/action:hover .group-hover\\/action\\:hidden {
  display: none;
}

.group:hover .group-hover\\:hidden {
  display: none;
}

.group\\/act:hover .group-hover\\/act\\:max-w-\\[60px\\] {
  max-width: 60px;
}

.group\\/action:hover .group-hover\\/action\\:max-w-\\[54px\\] {
  max-width: 54px;
}

.group\\/action:hover .group-hover\\/action\\:max-w-\\[60px\\] {
  max-width: 60px;
}

.group\\/action:hover .group-hover\\/action\\:max-w-\\[64px\\] {
  max-width: 64px;
}

.group\\/approve:hover .group-hover\\/approve\\:max-w-\\[54px\\] {
  max-width: 54px;
}

.group\\/btn:hover .group-hover\\/btn\\:max-w-\\[50px\\] {
  max-width: 50px;
}

.group\\/btn:hover .group-hover\\/btn\\:max-w-\\[60px\\] {
  max-width: 60px;
}

.group\\/consult:hover .group-hover\\/consult\\:max-w-\\[50px\\] {
  max-width: 50px;
}

.group\\/continue:hover .group-hover\\/continue\\:max-w-\\[60px\\] {
  max-width: 60px;
}

.group\\/del:hover .group-hover\\/del\\:max-w-\\[44px\\] {
  max-width: 44px;
}

.group\\/delete:hover .group-hover\\/delete\\:max-w-\\[50px\\] {
  max-width: 50px;
}

.group\\/delivery:hover .group-hover\\/delivery\\:max-w-\\[70px\\] {
  max-width: 70px;
}

.group\\/delivery:hover .group-hover\\/delivery\\:max-w-\\[80px\\] {
  max-width: 80px;
}

.group\\/details:hover .group-hover\\/details\\:max-w-\\[60px\\] {
  max-width: 60px;
}

.group\\/dispo:hover .group-hover\\/dispo\\:max-w-\\[80px\\] {
  max-width: 80px;
}

.group\\/edit:hover .group-hover\\/edit\\:max-w-\\[28px\\] {
  max-width: 28px;
}

.group\\/history:hover .group-hover\\/history\\:max-w-\\[50px\\] {
  max-width: 50px;
}

.group\\/history:hover .group-hover\\/history\\:max-w-\\[60px\\] {
  max-width: 60px;
}

.group\\/idel:hover .group-hover\\/idel\\:max-w-\\[44px\\] {
  max-width: 44px;
}

.group\\/pdf:hover .group-hover\\/pdf\\:max-w-\\[28px\\] {
  max-width: 28px;
}

.group\\/print:hover .group-hover\\/print\\:max-w-\\[60px\\] {
  max-width: 60px;
}

.group\\/reject:hover .group-hover\\/reject\\:max-w-\\[44px\\] {
  max-width: 44px;
}

.group\\/services:hover .group-hover\\/services\\:max-w-\\[55px\\] {
  max-width: 55px;
}

.group\\/view:hover .group-hover\\/view\\:max-w-\\[50px\\] {
  max-width: 50px;
}

.group\\/view:hover .group-hover\\/view\\:max-w-\\[60px\\] {
  max-width: 60px;
}

.group\\/visit:hover .group-hover\\/visit\\:max-w-\\[90px\\] {
  max-width: 90px;
}

.group:hover .group-hover\\:max-w-\\[100px\\] {
  max-width: 100px;
}

.group:hover .group-hover\\:max-w-\\[40px\\] {
  max-width: 40px;
}

.group:hover .group-hover\\:max-w-\\[48px\\] {
  max-width: 48px;
}

.group:hover .group-hover\\:max-w-\\[50px\\] {
  max-width: 50px;
}

.group:hover .group-hover\\:max-w-\\[60px\\] {
  max-width: 60px;
}

.group:hover .group-hover\\:max-w-\\[80px\\] {
  max-width: 80px;
}

.group\\/tooltip:hover .group-hover\\/tooltip\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/btn:hover .group-hover\\/btn\\:rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/tooltip:hover .group-hover\\/tooltip\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/tooltip:hover .group-hover\\/tooltip\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-\\[1\\.03\\] {
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes pulse {
  50% {
    opacity: .5;
  }
}

.group\\/del:hover .group-hover\\/del\\:animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.group:hover .group-hover\\:gap-1\\.5 {
  gap: 0.375rem;
}

.group:hover .group-hover\\:border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}

.group:hover .group-hover\\:border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}

.group:hover .group-hover\\:border-purple-400 {
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
}

.group:hover .group-hover\\:bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}

.group:hover .group-hover\\:bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}

.group:hover .group-hover\\:bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-teal-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-teal-500\\/20 {
  background-color: rgb(20 184 166 / 0.2);
}

.group:hover .group-hover\\:bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}

.group:hover .group-hover\\:bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}

.group:hover .group-hover\\:from-purple-500 {
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.group:hover .group-hover\\:from-teal-500 {
  --tw-gradient-from: #14b8a6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.group:hover .group-hover\\:via-teal-400 {
  --tw-gradient-to: rgb(45 212 191 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #2dd4bf var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.group:hover .group-hover\\:to-amber-400 {
  --tw-gradient-to: #fbbf24 var(--tw-gradient-to-position);
}

.group:hover .group-hover\\:to-cyan-500 {
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}

.group:hover .group-hover\\:pr-3 {
  padding-right: 0.75rem;
}

.group:hover .group-hover\\:text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-pink-600 {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-purple-400 {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-teal-400 {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-teal-600\\/70 {
  color: rgb(13 148 136 / 0.7);
}

.group:hover .group-hover\\:text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-violet-600 {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group\\/act:hover .group-hover\\/act\\:opacity-100 {
  opacity: 1;
}

.group\\/action:hover .group-hover\\/action\\:opacity-100 {
  opacity: 1;
}

.group\\/approve:hover .group-hover\\/approve\\:opacity-100 {
  opacity: 1;
}

.group\\/btn:hover .group-hover\\/btn\\:opacity-100 {
  opacity: 1;
}

.group\\/consult:hover .group-hover\\/consult\\:opacity-100 {
  opacity: 1;
}

.group\\/continue:hover .group-hover\\/continue\\:opacity-100 {
  opacity: 1;
}

.group\\/del:hover .group-hover\\/del\\:opacity-100 {
  opacity: 1;
}

.group\\/delete:hover .group-hover\\/delete\\:opacity-100 {
  opacity: 1;
}

.group\\/delivery:hover .group-hover\\/delivery\\:opacity-100 {
  opacity: 1;
}

.group\\/details:hover .group-hover\\/details\\:opacity-100 {
  opacity: 1;
}

.group\\/dispo:hover .group-hover\\/dispo\\:opacity-100 {
  opacity: 1;
}

.group\\/edit:hover .group-hover\\/edit\\:opacity-100 {
  opacity: 1;
}

.group\\/ghdr:hover .group-hover\\/ghdr\\:opacity-100 {
  opacity: 1;
}

.group\\/history:hover .group-hover\\/history\\:opacity-100 {
  opacity: 1;
}

.group\\/idel:hover .group-hover\\/idel\\:opacity-100 {
  opacity: 1;
}

.group\\/message:hover .group-hover\\/message\\:opacity-100 {
  opacity: 1;
}

.group\\/pdf:hover .group-hover\\/pdf\\:opacity-100 {
  opacity: 1;
}

.group\\/print:hover .group-hover\\/print\\:opacity-100 {
  opacity: 1;
}

.group\\/reject:hover .group-hover\\/reject\\:opacity-100 {
  opacity: 1;
}

.group\\/row:hover .group-hover\\/row\\:opacity-100 {
  opacity: 1;
}

.group\\/services:hover .group-hover\\/services\\:opacity-100 {
  opacity: 1;
}

.group\\/tok:hover .group-hover\\/tok\\:opacity-100 {
  opacity: 1;
}

.group\\/tooltip:hover .group-hover\\/tooltip\\:opacity-100 {
  opacity: 1;
}

.group\\/view:hover .group-hover\\/view\\:opacity-100 {
  opacity: 1;
}

.group\\/visit:hover .group-hover\\/visit\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:opacity-80 {
  opacity: 0.8;
}

.group:hover .group-hover\\:shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-purple-500\\/25 {
  --tw-shadow-color: rgb(168 85 247 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.peer:checked ~ .peer-checked\\:border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}

.peer:checked ~ .peer-checked\\:bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.peer:checked ~ .peer-checked\\:bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}

.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.peer:focus ~ .peer-focus\\:outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.dark\\:block:is(.dark *) {
  display: block;
}

.dark\\:hidden:is(.dark *) {
  display: none;
}

.dark\\:divide-amber-800\\/50:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(146 64 14 / 0.5);
}

.dark\\:divide-gray-700:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-divide-opacity, 1));
}

.dark\\:divide-gray-700\\/30:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(55 65 81 / 0.3);
}

.dark\\:divide-gray-700\\/40:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(55 65 81 / 0.4);
}

.dark\\:divide-gray-700\\/50:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(55 65 81 / 0.5);
}

.dark\\:divide-gray-800:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-divide-opacity, 1));
}

.dark\\:border-amber-500\\/25:is(.dark *) {
  border-color: rgb(245 158 11 / 0.25);
}

.dark\\:border-amber-500\\/30:is(.dark *) {
  border-color: rgb(245 158 11 / 0.3);
}

.dark\\:border-amber-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity, 1));
}

.dark\\:border-amber-600\\/40:is(.dark *) {
  border-color: rgb(217 119 6 / 0.4);
}

.dark\\:border-amber-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity, 1));
}

.dark\\:border-amber-700\\/30:is(.dark *) {
  border-color: rgb(180 83 9 / 0.3);
}

.dark\\:border-amber-700\\/70:is(.dark *) {
  border-color: rgb(180 83 9 / 0.7);
}

.dark\\:border-amber-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity, 1));
}

.dark\\:border-amber-800\\/30:is(.dark *) {
  border-color: rgb(146 64 14 / 0.3);
}

.dark\\:border-amber-800\\/40:is(.dark *) {
  border-color: rgb(146 64 14 / 0.4);
}

.dark\\:border-amber-800\\/50:is(.dark *) {
  border-color: rgb(146 64 14 / 0.5);
}

.dark\\:border-amber-900\\/50:is(.dark *) {
  border-color: rgb(120 53 15 / 0.5);
}

.dark\\:border-blue-500\\/25:is(.dark *) {
  border-color: rgb(59 130 246 / 0.25);
}

.dark\\:border-blue-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}

.dark\\:border-blue-700\\/30:is(.dark *) {
  border-color: rgb(29 78 216 / 0.3);
}

.dark\\:border-blue-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity, 1));
}

.dark\\:border-blue-800\\/30:is(.dark *) {
  border-color: rgb(30 64 175 / 0.3);
}

.dark\\:border-blue-800\\/40:is(.dark *) {
  border-color: rgb(30 64 175 / 0.4);
}

.dark\\:border-cyan-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / var(--tw-border-opacity, 1));
}

.dark\\:border-cyan-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(21 94 117 / var(--tw-border-opacity, 1));
}

.dark\\:border-cyan-800\\/40:is(.dark *) {
  border-color: rgb(21 94 117 / 0.4);
}

.dark\\:border-emerald-500\\/20:is(.dark *) {
  border-color: rgb(16 185 129 / 0.2);
}

.dark\\:border-emerald-500\\/25:is(.dark *) {
  border-color: rgb(16 185 129 / 0.25);
}

.dark\\:border-emerald-500\\/30:is(.dark *) {
  border-color: rgb(16 185 129 / 0.3);
}

.dark\\:border-emerald-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity, 1));
}

.dark\\:border-emerald-800\\/30:is(.dark *) {
  border-color: rgb(6 95 70 / 0.3);
}

.dark\\:border-emerald-800\\/40:is(.dark *) {
  border-color: rgb(6 95 70 / 0.4);
}

.dark\\:border-emerald-900\\/30:is(.dark *) {
  border-color: rgb(6 78 59 / 0.3);
}

.dark\\:border-fuchsia-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(134 25 143 / var(--tw-border-opacity, 1));
}

.dark\\:border-fuchsia-800\\/40:is(.dark *) {
  border-color: rgb(134 25 143 / 0.4);
}

.dark\\:border-gray-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-600\\/20:is(.dark *) {
  border-color: rgb(75 85 99 / 0.2);
}

.dark\\:border-gray-600\\/30:is(.dark *) {
  border-color: rgb(75 85 99 / 0.3);
}

.dark\\:border-gray-600\\/40:is(.dark *) {
  border-color: rgb(75 85 99 / 0.4);
}

.dark\\:border-gray-600\\/50:is(.dark *) {
  border-color: rgb(75 85 99 / 0.5);
}

.dark\\:border-gray-600\\/60:is(.dark *) {
  border-color: rgb(75 85 99 / 0.6);
}

.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-700\\/20:is(.dark *) {
  border-color: rgb(55 65 81 / 0.2);
}

.dark\\:border-gray-700\\/30:is(.dark *) {
  border-color: rgb(55 65 81 / 0.3);
}

.dark\\:border-gray-700\\/40:is(.dark *) {
  border-color: rgb(55 65 81 / 0.4);
}

.dark\\:border-gray-700\\/50:is(.dark *) {
  border-color: rgb(55 65 81 / 0.5);
}

.dark\\:border-gray-700\\/60:is(.dark *) {
  border-color: rgb(55 65 81 / 0.6);
}

.dark\\:border-gray-700\\/70:is(.dark *) {
  border-color: rgb(55 65 81 / 0.7);
}

.dark\\:border-gray-700\\/80:is(.dark *) {
  border-color: rgb(55 65 81 / 0.8);
}

.dark\\:border-gray-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-800\\/30:is(.dark *) {
  border-color: rgb(31 41 55 / 0.3);
}

.dark\\:border-gray-950:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(3 7 18 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-600\\/40:is(.dark *) {
  border-color: rgb(22 163 74 / 0.4);
}

.dark\\:border-green-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-700\\/30:is(.dark *) {
  border-color: rgb(21 128 61 / 0.3);
}

.dark\\:border-green-700\\/40:is(.dark *) {
  border-color: rgb(21 128 61 / 0.4);
}

.dark\\:border-green-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-800\\/30:is(.dark *) {
  border-color: rgb(22 101 52 / 0.3);
}

.dark\\:border-indigo-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 48 163 / var(--tw-border-opacity, 1));
}

.dark\\:border-indigo-800\\/40:is(.dark *) {
  border-color: rgb(55 48 163 / 0.4);
}

.dark\\:border-orange-500\\/25:is(.dark *) {
  border-color: rgb(249 115 22 / 0.25);
}

.dark\\:border-orange-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(194 65 12 / var(--tw-border-opacity, 1));
}

.dark\\:border-orange-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(154 52 18 / var(--tw-border-opacity, 1));
}

.dark\\:border-orange-800\\/30:is(.dark *) {
  border-color: rgb(154 52 18 / 0.3);
}

.dark\\:border-orange-800\\/40:is(.dark *) {
  border-color: rgb(154 52 18 / 0.4);
}

.dark\\:border-pink-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(190 24 93 / var(--tw-border-opacity, 1));
}

.dark\\:border-pink-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(157 23 77 / var(--tw-border-opacity, 1));
}

.dark\\:border-primary-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(15 93 74 / var(--tw-border-opacity, 1));
}

.dark\\:border-purple-500\\/30:is(.dark *) {
  border-color: rgb(168 85 247 / 0.3);
}

.dark\\:border-purple-600\\/40:is(.dark *) {
  border-color: rgb(147 51 234 / 0.4);
}

.dark\\:border-purple-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(126 34 206 / var(--tw-border-opacity, 1));
}

.dark\\:border-purple-700\\/40:is(.dark *) {
  border-color: rgb(126 34 206 / 0.4);
}

.dark\\:border-purple-700\\/50:is(.dark *) {
  border-color: rgb(126 34 206 / 0.5);
}

.dark\\:border-purple-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity, 1));
}

.dark\\:border-purple-800\\/30:is(.dark *) {
  border-color: rgb(107 33 168 / 0.3);
}

.dark\\:border-purple-800\\/40:is(.dark *) {
  border-color: rgb(107 33 168 / 0.4);
}

.dark\\:border-red-500\\/25:is(.dark *) {
  border-color: rgb(239 68 68 / 0.25);
}

.dark\\:border-red-500\\/30:is(.dark *) {
  border-color: rgb(239 68 68 / 0.3);
}

.dark\\:border-red-600\\/40:is(.dark *) {
  border-color: rgb(220 38 38 / 0.4);
}

.dark\\:border-red-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-700\\/30:is(.dark *) {
  border-color: rgb(185 28 28 / 0.3);
}

.dark\\:border-red-700\\/40:is(.dark *) {
  border-color: rgb(185 28 28 / 0.4);
}

.dark\\:border-red-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-800\\/30:is(.dark *) {
  border-color: rgb(153 27 27 / 0.3);
}

.dark\\:border-red-800\\/50:is(.dark *) {
  border-color: rgb(153 27 27 / 0.5);
}

.dark\\:border-red-900\\/50:is(.dark *) {
  border-color: rgb(127 29 29 / 0.5);
}

.dark\\:border-rose-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}

.dark\\:border-rose-500\\/20:is(.dark *) {
  border-color: rgb(244 63 94 / 0.2);
}

.dark\\:border-rose-500\\/25:is(.dark *) {
  border-color: rgb(244 63 94 / 0.25);
}

.dark\\:border-rose-500\\/30:is(.dark *) {
  border-color: rgb(244 63 94 / 0.3);
}

.dark\\:border-rose-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(190 18 60 / var(--tw-border-opacity, 1));
}

.dark\\:border-rose-700\\/70:is(.dark *) {
  border-color: rgb(190 18 60 / 0.7);
}

.dark\\:border-rose-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(159 18 57 / var(--tw-border-opacity, 1));
}

.dark\\:border-rose-800\\/40:is(.dark *) {
  border-color: rgb(159 18 57 / 0.4);
}

.dark\\:border-rose-900\\/40:is(.dark *) {
  border-color: rgb(136 19 55 / 0.4);
}

.dark\\:border-sky-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(7 89 133 / var(--tw-border-opacity, 1));
}

.dark\\:border-sky-800\\/40:is(.dark *) {
  border-color: rgb(7 89 133 / 0.4);
}

.dark\\:border-teal-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity, 1));
}

.dark\\:border-teal-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}

.dark\\:border-teal-500\\/20:is(.dark *) {
  border-color: rgb(20 184 166 / 0.2);
}

.dark\\:border-teal-500\\/25:is(.dark *) {
  border-color: rgb(20 184 166 / 0.25);
}

.dark\\:border-teal-500\\/30:is(.dark *) {
  border-color: rgb(20 184 166 / 0.3);
}

.dark\\:border-teal-500\\/40:is(.dark *) {
  border-color: rgb(20 184 166 / 0.4);
}

.dark\\:border-teal-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(13 148 136 / var(--tw-border-opacity, 1));
}

.dark\\:border-teal-600\\/40:is(.dark *) {
  border-color: rgb(13 148 136 / 0.4);
}

.dark\\:border-teal-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(15 118 110 / var(--tw-border-opacity, 1));
}

.dark\\:border-teal-700\\/30:is(.dark *) {
  border-color: rgb(15 118 110 / 0.3);
}

.dark\\:border-teal-700\\/50:is(.dark *) {
  border-color: rgb(15 118 110 / 0.5);
}

.dark\\:border-teal-700\\/60:is(.dark *) {
  border-color: rgb(15 118 110 / 0.6);
}

.dark\\:border-teal-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(17 94 89 / var(--tw-border-opacity, 1));
}

.dark\\:border-teal-800\\/20:is(.dark *) {
  border-color: rgb(17 94 89 / 0.2);
}

.dark\\:border-teal-800\\/30:is(.dark *) {
  border-color: rgb(17 94 89 / 0.3);
}

.dark\\:border-teal-800\\/40:is(.dark *) {
  border-color: rgb(17 94 89 / 0.4);
}

.dark\\:border-teal-800\\/60:is(.dark *) {
  border-color: rgb(17 94 89 / 0.6);
}

.dark\\:border-teal-900\\/30:is(.dark *) {
  border-color: rgb(19 78 74 / 0.3);
}

.dark\\:border-teal-900\\/40:is(.dark *) {
  border-color: rgb(19 78 74 / 0.4);
}

.dark\\:border-teal-900\\/50:is(.dark *) {
  border-color: rgb(19 78 74 / 0.5);
}

.dark\\:border-violet-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(109 40 217 / var(--tw-border-opacity, 1));
}

.dark\\:border-violet-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(91 33 182 / var(--tw-border-opacity, 1));
}

.dark\\:border-violet-800\\/30:is(.dark *) {
  border-color: rgb(91 33 182 / 0.3);
}

.dark\\:border-violet-800\\/40:is(.dark *) {
  border-color: rgb(91 33 182 / 0.4);
}

.dark\\:border-white:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.dark\\:border-white\\/10:is(.dark *) {
  border-color: rgb(255 255 255 / 0.1);
}

.dark\\:border-yellow-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(161 98 7 / var(--tw-border-opacity, 1));
}

.dark\\:border-yellow-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(133 77 14 / var(--tw-border-opacity, 1));
}

.dark\\:border-yellow-900\\/20:is(.dark *) {
  border-color: rgb(113 63 18 / 0.2);
}

.dark\\:bg-amber-500\\/10:is(.dark *) {
  background-color: rgb(245 158 11 / 0.1);
}

.dark\\:bg-amber-500\\/20:is(.dark *) {
  background-color: rgb(245 158 11 / 0.2);
}

.dark\\:bg-amber-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-amber-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(146 64 14 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-amber-900\\/10:is(.dark *) {
  background-color: rgb(120 53 15 / 0.1);
}

.dark\\:bg-amber-900\\/15:is(.dark *) {
  background-color: rgb(120 53 15 / 0.15);
}

.dark\\:bg-amber-900\\/20:is(.dark *) {
  background-color: rgb(120 53 15 / 0.2);
}

.dark\\:bg-amber-900\\/30:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}

.dark\\:bg-amber-900\\/40:is(.dark *) {
  background-color: rgb(120 53 15 / 0.4);
}

.dark\\:bg-amber-900\\/50:is(.dark *) {
  background-color: rgb(120 53 15 / 0.5);
}

.dark\\:bg-black\\/20:is(.dark *) {
  background-color: rgb(0 0 0 / 0.2);
}

.dark\\:bg-blue-500\\/10:is(.dark *) {
  background-color: rgb(59 130 246 / 0.1);
}

.dark\\:bg-blue-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-900\\/10:is(.dark *) {
  background-color: rgb(30 58 138 / 0.1);
}

.dark\\:bg-blue-900\\/20:is(.dark *) {
  background-color: rgb(30 58 138 / 0.2);
}

.dark\\:bg-blue-900\\/30:is(.dark *) {
  background-color: rgb(30 58 138 / 0.3);
}

.dark\\:bg-blue-900\\/40:is(.dark *) {
  background-color: rgb(30 58 138 / 0.4);
}

.dark\\:bg-blue-900\\/50:is(.dark *) {
  background-color: rgb(30 58 138 / 0.5);
}

.dark\\:bg-cyan-500\\/10:is(.dark *) {
  background-color: rgb(6 182 212 / 0.1);
}

.dark\\:bg-cyan-800\\/20:is(.dark *) {
  background-color: rgb(21 94 117 / 0.2);
}

.dark\\:bg-cyan-800\\/50:is(.dark *) {
  background-color: rgb(21 94 117 / 0.5);
}

.dark\\:bg-cyan-900\\/10:is(.dark *) {
  background-color: rgb(22 78 99 / 0.1);
}

.dark\\:bg-cyan-900\\/15:is(.dark *) {
  background-color: rgb(22 78 99 / 0.15);
}

.dark\\:bg-cyan-900\\/20:is(.dark *) {
  background-color: rgb(22 78 99 / 0.2);
}

.dark\\:bg-cyan-900\\/30:is(.dark *) {
  background-color: rgb(22 78 99 / 0.3);
}

.dark\\:bg-cyan-900\\/40:is(.dark *) {
  background-color: rgb(22 78 99 / 0.4);
}

.dark\\:bg-emerald-500\\/10:is(.dark *) {
  background-color: rgb(16 185 129 / 0.1);
}

.dark\\:bg-emerald-500\\/20:is(.dark *) {
  background-color: rgb(16 185 129 / 0.2);
}

.dark\\:bg-emerald-900\\/10:is(.dark *) {
  background-color: rgb(6 78 59 / 0.1);
}

.dark\\:bg-emerald-900\\/15:is(.dark *) {
  background-color: rgb(6 78 59 / 0.15);
}

.dark\\:bg-emerald-900\\/20:is(.dark *) {
  background-color: rgb(6 78 59 / 0.2);
}

.dark\\:bg-emerald-900\\/30:is(.dark *) {
  background-color: rgb(6 78 59 / 0.3);
}

.dark\\:bg-emerald-900\\/40:is(.dark *) {
  background-color: rgb(6 78 59 / 0.4);
}

.dark\\:bg-fuchsia-900\\/10:is(.dark *) {
  background-color: rgb(112 26 117 / 0.1);
}

.dark\\:bg-fuchsia-900\\/15:is(.dark *) {
  background-color: rgb(112 26 117 / 0.15);
}

.dark\\:bg-fuchsia-900\\/30:is(.dark *) {
  background-color: rgb(112 26 117 / 0.3);
}

.dark\\:bg-gray-500\\/10:is(.dark *) {
  background-color: rgb(107 114 128 / 0.1);
}

.dark\\:bg-gray-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-600\\/30:is(.dark *) {
  background-color: rgb(75 85 99 / 0.3);
}

.dark\\:bg-gray-600\\/40:is(.dark *) {
  background-color: rgb(75 85 99 / 0.4);
}

.dark\\:bg-gray-600\\/50:is(.dark *) {
  background-color: rgb(75 85 99 / 0.5);
}

.dark\\:bg-gray-600\\/70:is(.dark *) {
  background-color: rgb(75 85 99 / 0.7);
}

.dark\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-700\\/20:is(.dark *) {
  background-color: rgb(55 65 81 / 0.2);
}

.dark\\:bg-gray-700\\/30:is(.dark *) {
  background-color: rgb(55 65 81 / 0.3);
}

.dark\\:bg-gray-700\\/40:is(.dark *) {
  background-color: rgb(55 65 81 / 0.4);
}

.dark\\:bg-gray-700\\/50:is(.dark *) {
  background-color: rgb(55 65 81 / 0.5);
}

.dark\\:bg-gray-700\\/60:is(.dark *) {
  background-color: rgb(55 65 81 / 0.6);
}

.dark\\:bg-gray-700\\/80:is(.dark *) {
  background-color: rgb(55 65 81 / 0.8);
}

.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-800\\/30:is(.dark *) {
  background-color: rgb(31 41 55 / 0.3);
}

.dark\\:bg-gray-800\\/40:is(.dark *) {
  background-color: rgb(31 41 55 / 0.4);
}

.dark\\:bg-gray-800\\/50:is(.dark *) {
  background-color: rgb(31 41 55 / 0.5);
}

.dark\\:bg-gray-800\\/60:is(.dark *) {
  background-color: rgb(31 41 55 / 0.6);
}

.dark\\:bg-gray-800\\/70:is(.dark *) {
  background-color: rgb(31 41 55 / 0.7);
}

.dark\\:bg-gray-800\\/80:is(.dark *) {
  background-color: rgb(31 41 55 / 0.8);
}

.dark\\:bg-gray-800\\/90:is(.dark *) {
  background-color: rgb(31 41 55 / 0.9);
}

.dark\\:bg-gray-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-900\\/0:is(.dark *) {
  background-color: rgb(17 24 39 / 0);
}

.dark\\:bg-gray-900\\/10:is(.dark *) {
  background-color: rgb(17 24 39 / 0.1);
}

.dark\\:bg-gray-900\\/20:is(.dark *) {
  background-color: rgb(17 24 39 / 0.2);
}

.dark\\:bg-gray-900\\/30:is(.dark *) {
  background-color: rgb(17 24 39 / 0.3);
}

.dark\\:bg-gray-900\\/40:is(.dark *) {
  background-color: rgb(17 24 39 / 0.4);
}

.dark\\:bg-gray-900\\/50:is(.dark *) {
  background-color: rgb(17 24 39 / 0.5);
}

.dark\\:bg-gray-900\\/60:is(.dark *) {
  background-color: rgb(17 24 39 / 0.6);
}

.dark\\:bg-gray-900\\/70:is(.dark *) {
  background-color: rgb(17 24 39 / 0.7);
}

.dark\\:bg-gray-900\\/80:is(.dark *) {
  background-color: rgb(17 24 39 / 0.8);
}

.dark\\:bg-gray-900\\/90:is(.dark *) {
  background-color: rgb(17 24 39 / 0.9);
}

.dark\\:bg-gray-900\\/95:is(.dark *) {
  background-color: rgb(17 24 39 / 0.95);
}

.dark\\:bg-gray-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-900\\/10:is(.dark *) {
  background-color: rgb(20 83 45 / 0.1);
}

.dark\\:bg-green-900\\/20:is(.dark *) {
  background-color: rgb(20 83 45 / 0.2);
}

.dark\\:bg-green-900\\/30:is(.dark *) {
  background-color: rgb(20 83 45 / 0.3);
}

.dark\\:bg-green-900\\/40:is(.dark *) {
  background-color: rgb(20 83 45 / 0.4);
}

.dark\\:bg-green-900\\/50:is(.dark *) {
  background-color: rgb(20 83 45 / 0.5);
}

.dark\\:bg-indigo-500\\/10:is(.dark *) {
  background-color: rgb(99 102 241 / 0.1);
}

.dark\\:bg-indigo-500\\/20:is(.dark *) {
  background-color: rgb(99 102 241 / 0.2);
}

.dark\\:bg-indigo-900\\/10:is(.dark *) {
  background-color: rgb(49 46 129 / 0.1);
}

.dark\\:bg-indigo-900\\/20:is(.dark *) {
  background-color: rgb(49 46 129 / 0.2);
}

.dark\\:bg-indigo-900\\/30:is(.dark *) {
  background-color: rgb(49 46 129 / 0.3);
}

.dark\\:bg-indigo-900\\/40:is(.dark *) {
  background-color: rgb(49 46 129 / 0.4);
}

.dark\\:bg-orange-500\\/10:is(.dark *) {
  background-color: rgb(249 115 22 / 0.1);
}

.dark\\:bg-orange-800\\/50:is(.dark *) {
  background-color: rgb(154 52 18 / 0.5);
}

.dark\\:bg-orange-900\\/10:is(.dark *) {
  background-color: rgb(124 45 18 / 0.1);
}

.dark\\:bg-orange-900\\/15:is(.dark *) {
  background-color: rgb(124 45 18 / 0.15);
}

.dark\\:bg-orange-900\\/20:is(.dark *) {
  background-color: rgb(124 45 18 / 0.2);
}

.dark\\:bg-orange-900\\/30:is(.dark *) {
  background-color: rgb(124 45 18 / 0.3);
}

.dark\\:bg-orange-900\\/40:is(.dark *) {
  background-color: rgb(124 45 18 / 0.4);
}

.dark\\:bg-pink-900\\/20:is(.dark *) {
  background-color: rgb(131 24 67 / 0.2);
}

.dark\\:bg-pink-900\\/30:is(.dark *) {
  background-color: rgb(131 24 67 / 0.3);
}

.dark\\:bg-pink-900\\/40:is(.dark *) {
  background-color: rgb(131 24 67 / 0.4);
}

.dark\\:bg-primary-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(12 75 59 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-primary-900\\/20:is(.dark *) {
  background-color: rgb(12 75 59 / 0.2);
}

.dark\\:bg-purple-500\\/10:is(.dark *) {
  background-color: rgb(168 85 247 / 0.1);
}

.dark\\:bg-purple-900\\/10:is(.dark *) {
  background-color: rgb(88 28 135 / 0.1);
}

.dark\\:bg-purple-900\\/20:is(.dark *) {
  background-color: rgb(88 28 135 / 0.2);
}

.dark\\:bg-purple-900\\/30:is(.dark *) {
  background-color: rgb(88 28 135 / 0.3);
}

.dark\\:bg-purple-900\\/40:is(.dark *) {
  background-color: rgb(88 28 135 / 0.4);
}

.dark\\:bg-purple-900\\/50:is(.dark *) {
  background-color: rgb(88 28 135 / 0.5);
}

.dark\\:bg-red-500\\/10:is(.dark *) {
  background-color: rgb(239 68 68 / 0.1);
}

.dark\\:bg-red-500\\/20:is(.dark *) {
  background-color: rgb(239 68 68 / 0.2);
}

.dark\\:bg-red-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-red-900\\/10:is(.dark *) {
  background-color: rgb(127 29 29 / 0.1);
}

.dark\\:bg-red-900\\/20:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}

.dark\\:bg-red-900\\/30:is(.dark *) {
  background-color: rgb(127 29 29 / 0.3);
}

.dark\\:bg-red-900\\/40:is(.dark *) {
  background-color: rgb(127 29 29 / 0.4);
}

.dark\\:bg-rose-500\\/10:is(.dark *) {
  background-color: rgb(244 63 94 / 0.1);
}

.dark\\:bg-rose-500\\/20:is(.dark *) {
  background-color: rgb(244 63 94 / 0.2);
}

.dark\\:bg-rose-900\\/10:is(.dark *) {
  background-color: rgb(136 19 55 / 0.1);
}

.dark\\:bg-rose-900\\/15:is(.dark *) {
  background-color: rgb(136 19 55 / 0.15);
}

.dark\\:bg-rose-900\\/20:is(.dark *) {
  background-color: rgb(136 19 55 / 0.2);
}

.dark\\:bg-rose-900\\/30:is(.dark *) {
  background-color: rgb(136 19 55 / 0.3);
}

.dark\\:bg-rose-900\\/40:is(.dark *) {
  background-color: rgb(136 19 55 / 0.4);
}

.dark\\:bg-rose-900\\/50:is(.dark *) {
  background-color: rgb(136 19 55 / 0.5);
}

.dark\\:bg-sky-900\\/10:is(.dark *) {
  background-color: rgb(12 74 110 / 0.1);
}

.dark\\:bg-sky-900\\/15:is(.dark *) {
  background-color: rgb(12 74 110 / 0.15);
}

.dark\\:bg-sky-900\\/20:is(.dark *) {
  background-color: rgb(12 74 110 / 0.2);
}

.dark\\:bg-sky-900\\/30:is(.dark *) {
  background-color: rgb(12 74 110 / 0.3);
}

.dark\\:bg-sky-900\\/40:is(.dark *) {
  background-color: rgb(12 74 110 / 0.4);
}

.dark\\:bg-teal-400:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-teal-500\\/10:is(.dark *) {
  background-color: rgb(20 184 166 / 0.1);
}

.dark\\:bg-teal-500\\/15:is(.dark *) {
  background-color: rgb(20 184 166 / 0.15);
}

.dark\\:bg-teal-500\\/20:is(.dark *) {
  background-color: rgb(20 184 166 / 0.2);
}

.dark\\:bg-teal-500\\/5:is(.dark *) {
  background-color: rgb(20 184 166 / 0.05);
}

.dark\\:bg-teal-800\\/20:is(.dark *) {
  background-color: rgb(17 94 89 / 0.2);
}

.dark\\:bg-teal-900\\/10:is(.dark *) {
  background-color: rgb(19 78 74 / 0.1);
}

.dark\\:bg-teal-900\\/15:is(.dark *) {
  background-color: rgb(19 78 74 / 0.15);
}

.dark\\:bg-teal-900\\/20:is(.dark *) {
  background-color: rgb(19 78 74 / 0.2);
}

.dark\\:bg-teal-900\\/30:is(.dark *) {
  background-color: rgb(19 78 74 / 0.3);
}

.dark\\:bg-teal-900\\/35:is(.dark *) {
  background-color: rgb(19 78 74 / 0.35);
}

.dark\\:bg-teal-900\\/40:is(.dark *) {
  background-color: rgb(19 78 74 / 0.4);
}

.dark\\:bg-teal-900\\/50:is(.dark *) {
  background-color: rgb(19 78 74 / 0.5);
}

.dark\\:bg-violet-500\\/10:is(.dark *) {
  background-color: rgb(139 92 246 / 0.1);
}

.dark\\:bg-violet-900\\/10:is(.dark *) {
  background-color: rgb(76 29 149 / 0.1);
}

.dark\\:bg-violet-900\\/15:is(.dark *) {
  background-color: rgb(76 29 149 / 0.15);
}

.dark\\:bg-violet-900\\/20:is(.dark *) {
  background-color: rgb(76 29 149 / 0.2);
}

.dark\\:bg-violet-900\\/30:is(.dark *) {
  background-color: rgb(76 29 149 / 0.3);
}

.dark\\:bg-violet-900\\/40:is(.dark *) {
  background-color: rgb(76 29 149 / 0.4);
}

.dark\\:bg-white:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-white\\/5:is(.dark *) {
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:bg-yellow-900\\/10:is(.dark *) {
  background-color: rgb(113 63 18 / 0.1);
}

.dark\\:bg-yellow-900\\/20:is(.dark *) {
  background-color: rgb(113 63 18 / 0.2);
}

.dark\\:bg-yellow-900\\/30:is(.dark *) {
  background-color: rgb(113 63 18 / 0.3);
}

.dark\\:from-amber-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(120 53 15 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(120 53 15 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-blue-800\\/40:is(.dark *) {
  --tw-gradient-from: rgb(30 64 175 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 64 175 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-blue-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(30 58 138 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-blue-900\\/30:is(.dark *) {
  --tw-gradient-from: rgb(30 58 138 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-cyan-800\\/40:is(.dark *) {
  --tw-gradient-from: rgb(21 94 117 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(21 94 117 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-cyan-900\\/30:is(.dark *) {
  --tw-gradient-from: rgb(22 78 99 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 78 99 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-emerald-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(6 78 59 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 78 59 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-gray-700:is(.dark *) {
  --tw-gradient-from: #374151 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(55 65 81 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-gray-700\\/20:is(.dark *) {
  --tw-gradient-from: rgb(55 65 81 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(55 65 81 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-gray-700\\/50:is(.dark *) {
  --tw-gradient-from: rgb(55 65 81 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(55 65 81 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-gray-800:is(.dark *) {
  --tw-gradient-from: #1f2937 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(31 41 55 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-gray-900:is(.dark *) {
  --tw-gradient-from: #111827 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-indigo-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(49 46 129 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-indigo-900\\/30:is(.dark *) {
  --tw-gradient-from: rgb(49 46 129 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-orange-400:is(.dark *) {
  --tw-gradient-from: #fb923c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-orange-800\\/40:is(.dark *) {
  --tw-gradient-from: rgb(154 52 18 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(154 52 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-orange-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(124 45 18 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 45 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-orange-900\\/30:is(.dark *) {
  --tw-gradient-from: rgb(124 45 18 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 45 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-primary-900\\/30:is(.dark *) {
  --tw-gradient-from: rgb(12 75 59 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(12 75 59 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-purple-500\\/60:is(.dark *) {
  --tw-gradient-from: rgb(168 85 247 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-purple-700:is(.dark *) {
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-purple-800\\/40:is(.dark *) {
  --tw-gradient-from: rgb(107 33 168 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(107 33 168 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-purple-900\\/10:is(.dark *) {
  --tw-gradient-from: rgb(88 28 135 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-purple-900\\/15:is(.dark *) {
  --tw-gradient-from: rgb(88 28 135 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-purple-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(88 28 135 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-purple-900\\/30:is(.dark *) {
  --tw-gradient-from: rgb(88 28 135 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-purple-900\\/40:is(.dark *) {
  --tw-gradient-from: rgb(88 28 135 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-slate-700\\/40:is(.dark *) {
  --tw-gradient-from: rgb(51 65 85 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(51 65 85 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-teal-400:is(.dark *) {
  --tw-gradient-from: #2dd4bf var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(45 212 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-teal-500\\/10:is(.dark *) {
  --tw-gradient-from: rgb(20 184 166 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-teal-900\\/10:is(.dark *) {
  --tw-gradient-from: rgb(19 78 74 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(19 78 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-teal-900\\/15:is(.dark *) {
  --tw-gradient-from: rgb(19 78 74 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(19 78 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-teal-900\\/20:is(.dark *) {
  --tw-gradient-from: rgb(19 78 74 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(19 78 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-white:is(.dark *) {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:via-cyan-400:is(.dark *) {
  --tw-gradient-to: rgb(34 211 238 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #22d3ee var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-gray-200:is(.dark *) {
  --tw-gradient-to: rgb(229 231 235 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #e5e7eb var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-gray-700:is(.dark *) {
  --tw-gradient-to: rgb(55 65 81 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #374151 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-gray-800:is(.dark *) {
  --tw-gradient-to: rgb(31 41 55 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1f2937 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-gray-900:is(.dark *) {
  --tw-gradient-to: rgb(17 24 39 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #111827 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-gray-900\\/30:is(.dark *) {
  --tw-gradient-to: rgb(17 24 39 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(17 24 39 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-teal-400\\/50:is(.dark *) {
  --tw-gradient-to: rgb(45 212 191 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(45 212 191 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-teal-600:is(.dark *) {
  --tw-gradient-to: rgb(13 148 136 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0d9488 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:to-amber-400:is(.dark *) {
  --tw-gradient-to: #fbbf24 var(--tw-gradient-to-position);
}

.dark\\:to-amber-400\\/60:is(.dark *) {
  --tw-gradient-to: rgb(251 191 36 / 0.6) var(--tw-gradient-to-position);
}

.dark\\:to-amber-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(120 53 15 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-amber-900\\/30:is(.dark *) {
  --tw-gradient-to: rgb(120 53 15 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-blue-900\\/30:is(.dark *) {
  --tw-gradient-to: rgb(30 58 138 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-cyan-400:is(.dark *) {
  --tw-gradient-to: #22d3ee var(--tw-gradient-to-position);
}

.dark\\:to-cyan-500\\/10:is(.dark *) {
  --tw-gradient-to: rgb(6 182 212 / 0.1) var(--tw-gradient-to-position);
}

.dark\\:to-cyan-700:is(.dark *) {
  --tw-gradient-to: #0e7490 var(--tw-gradient-to-position);
}

.dark\\:to-cyan-900\\/10:is(.dark *) {
  --tw-gradient-to: rgb(22 78 99 / 0.1) var(--tw-gradient-to-position);
}

.dark\\:to-cyan-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(22 78 99 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-emerald-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(6 78 59 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-gray-700:is(.dark *) {
  --tw-gradient-to: #374151 var(--tw-gradient-to-position);
}

.dark\\:to-gray-700\\/30:is(.dark *) {
  --tw-gradient-to: rgb(55 65 81 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-gray-800:is(.dark *) {
  --tw-gradient-to: #1f2937 var(--tw-gradient-to-position);
}

.dark\\:to-gray-800\\/50:is(.dark *) {
  --tw-gradient-to: rgb(31 41 55 / 0.5) var(--tw-gradient-to-position);
}

.dark\\:to-gray-900:is(.dark *) {
  --tw-gradient-to: #111827 var(--tw-gradient-to-position);
}

.dark\\:to-indigo-900\\/10:is(.dark *) {
  --tw-gradient-to: rgb(49 46 129 / 0.1) var(--tw-gradient-to-position);
}

.dark\\:to-indigo-900\\/30:is(.dark *) {
  --tw-gradient-to: rgb(49 46 129 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-orange-900\\/10:is(.dark *) {
  --tw-gradient-to: rgb(124 45 18 / 0.1) var(--tw-gradient-to-position);
}

.dark\\:to-pink-900\\/20:is(.dark *) {
  --tw-gradient-to: rgb(131 24 67 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-primary-800\\/10:is(.dark *) {
  --tw-gradient-to: rgb(15 93 74 / 0.1) var(--tw-gradient-to-position);
}

.dark\\:to-sky-900\\/30:is(.dark *) {
  --tw-gradient-to: rgb(12 74 110 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-teal-900\\/10:is(.dark *) {
  --tw-gradient-to: rgb(19 78 74 / 0.1) var(--tw-gradient-to-position);
}

.dark\\:to-teal-900\\/15:is(.dark *) {
  --tw-gradient-to: rgb(19 78 74 / 0.15) var(--tw-gradient-to-position);
}

.dark\\:to-teal-900\\/40:is(.dark *) {
  --tw-gradient-to: rgb(19 78 74 / 0.4) var(--tw-gradient-to-position);
}

.dark\\:to-violet-400:is(.dark *) {
  --tw-gradient-to: #a78bfa var(--tw-gradient-to-position);
}

.dark\\:to-violet-900\\/30:is(.dark *) {
  --tw-gradient-to: rgb(76 29 149 / 0.3) var(--tw-gradient-to-position);
}

.dark\\:to-white:is(.dark *) {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}

.dark\\:fill-amber-600:is(.dark *) {
  fill: #d97706;
}

.dark\\:fill-purple-700:is(.dark *) {
  fill: #7e22ce;
}

.dark\\:fill-teal-700:is(.dark *) {
  fill: #0f766e;
}

.dark\\:text-amber-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-400\\/60:is(.dark *) {
  color: rgb(251 191 36 / 0.6);
}

.dark\\:text-amber-400\\/70:is(.dark *) {
  color: rgb(251 191 36 / 0.7);
}

.dark\\:text-amber-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-400\\/70:is(.dark *) {
  color: rgb(96 165 250 / 0.7);
}

.dark\\:text-blue-400\\/80:is(.dark *) {
  color: rgb(96 165 250 / 0.8);
}

.dark\\:text-cyan-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(207 250 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-400\\/70:is(.dark *) {
  color: rgb(34 211 238 / 0.7);
}

.dark\\:text-emerald-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-400\\/70:is(.dark *) {
  color: rgb(52 211 153 / 0.7);
}

.dark\\:text-fuchsia-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(232 121 249 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-700:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-400\\/70:is(.dark *) {
  color: rgb(129 140 248 / 0.7);
}

.dark\\:text-orange-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}

.dark\\:text-orange-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}

.dark\\:text-pink-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity, 1));
}

.dark\\:text-pink-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}

.dark\\:text-primary-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(77 203 181 / var(--tw-text-opacity, 1));
}

.dark\\:text-primary-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(45 190 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-300\\/80:is(.dark *) {
  color: rgb(253 164 175 / 0.8);
}

.dark\\:text-rose-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-400\\/70:is(.dark *) {
  color: rgb(251 113 133 / 0.7);
}

.dark\\:text-rose-500\\/70:is(.dark *) {
  color: rgb(244 63 94 / 0.7);
}

.dark\\:text-sky-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-sky-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(204 251 241 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(153 246 228 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-300\\/70:is(.dark *) {
  color: rgb(94 234 212 / 0.7);
}

.dark\\:text-teal-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-400\\/70:is(.dark *) {
  color: rgb(45 212 191 / 0.7);
}

.dark\\:text-teal-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-700:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-400\\/70:is(.dark *) {
  color: rgb(167 139 250 / 0.7);
}

.dark\\:text-violet-400\\/80:is(.dark *) {
  color: rgb(167 139 250 / 0.8);
}

.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}

.dark\\:opacity-20:is(.dark *) {
  opacity: 0.2;
}

.dark\\:opacity-\\[0\\.03\\]:is(.dark *) {
  opacity: 0.03;
}

.dark\\:shadow-\\[0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.4\\)\\]:is(.dark *) {
  --tw-shadow: 0 1px 2px rgba(0,0,0,0.4);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[inset_0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\]:is(.dark *) {
  --tw-shadow: inset 0 1px 2px rgba(0,0,0,0.3);
  --tw-shadow-colored: inset 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-black\\/20:is(.dark *) {
  --tw-shadow-color: rgb(0 0 0 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:shadow-indigo-900\\/50:is(.dark *) {
  --tw-shadow-color: rgb(49 46 129 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:ring-amber-500\\/20:is(.dark *) {
  --tw-ring-color: rgb(245 158 11 / 0.2);
}

.dark\\:ring-amber-700:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(180 83 9 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-amber-800\\/50:is(.dark *) {
  --tw-ring-color: rgb(146 64 14 / 0.5);
}

.dark\\:ring-blue-500\\/20:is(.dark *) {
  --tw-ring-color: rgb(59 130 246 / 0.2);
}

.dark\\:ring-blue-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 64 175 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-cyan-500\\/20:is(.dark *) {
  --tw-ring-color: rgb(6 182 212 / 0.2);
}

.dark\\:ring-emerald-500\\/20:is(.dark *) {
  --tw-ring-color: rgb(16 185 129 / 0.2);
}

.dark\\:ring-emerald-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 95 70 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-gray-600:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(75 85 99 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-gray-700:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(55 65 81 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-gray-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-gray-900:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-indigo-500\\/20:is(.dark *) {
  --tw-ring-color: rgb(99 102 241 / 0.2);
}

.dark\\:ring-orange-500\\/20:is(.dark *) {
  --tw-ring-color: rgb(249 115 22 / 0.2);
}

.dark\\:ring-primary-700:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(19 111 90 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-red-500\\/20:is(.dark *) {
  --tw-ring-color: rgb(239 68 68 / 0.2);
}

.dark\\:ring-rose-500\\/20:is(.dark *) {
  --tw-ring-color: rgb(244 63 94 / 0.2);
}

.dark\\:ring-teal-400:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 212 191 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-teal-500\\/20:is(.dark *) {
  --tw-ring-color: rgb(20 184 166 / 0.2);
}

.dark\\:ring-teal-700:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(15 118 110 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-teal-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 94 89 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-violet-500\\/20:is(.dark *) {
  --tw-ring-color: rgb(139 92 246 / 0.2);
}

.dark\\:ring-violet-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(91 33 182 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-white\\/10:is(.dark *) {
  --tw-ring-color: rgb(255 255 255 / 0.1);
}

.dark\\:ring-white\\/20:is(.dark *) {
  --tw-ring-color: rgb(255 255 255 / 0.2);
}

.dark\\:ring-white\\/5:is(.dark *) {
  --tw-ring-color: rgb(255 255 255 / 0.05);
}

.dark\\:placeholder\\:text-gray-500:is(.dark *)::placeholder {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.dark\\:placeholder\\:text-gray-600:is(.dark *)::placeholder {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.dark\\:focus-within\\:bg-white\\/10:focus-within:is(.dark *) {
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:focus-within\\:ring-offset-gray-900:focus-within:is(.dark *) {
  --tw-ring-offset-color: #111827;
}

.dark\\:hover\\:border-amber-700:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-amber-800:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-emerald-800:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-gray-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-gray-500\\/60:hover:is(.dark *) {
  border-color: rgb(107 114 128 / 0.6);
}

.dark\\:hover\\:border-gray-600:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-gray-700:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-indigo-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-orange-700\\/50:hover:is(.dark *) {
  border-color: rgb(194 65 12 / 0.5);
}

.dark\\:hover\\:border-red-700:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-rose-500\\/50:hover:is(.dark *) {
  border-color: rgb(244 63 94 / 0.5);
}

.dark\\:hover\\:border-teal-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-teal-500\\/40:hover:is(.dark *) {
  border-color: rgb(20 184 166 / 0.4);
}

.dark\\:hover\\:border-teal-700:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(15 118 110 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-teal-700\\/50:hover:is(.dark *) {
  border-color: rgb(15 118 110 / 0.5);
}

.dark\\:hover\\:border-teal-800:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(17 94 89 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-white\\/20:hover:is(.dark *) {
  border-color: rgb(255 255 255 / 0.2);
}

.dark\\:hover\\:border-white\\/30:hover:is(.dark *) {
  border-color: rgb(255 255 255 / 0.3);
}

.dark\\:hover\\:bg-amber-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-amber-900\\/20:hover:is(.dark *) {
  background-color: rgb(120 53 15 / 0.2);
}

.dark\\:hover\\:bg-amber-900\\/30:hover:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}

.dark\\:hover\\:bg-blue-900\\/20:hover:is(.dark *) {
  background-color: rgb(30 58 138 / 0.2);
}

.dark\\:hover\\:bg-blue-900\\/30:hover:is(.dark *) {
  background-color: rgb(30 58 138 / 0.3);
}

.dark\\:hover\\:bg-cyan-900\\/20:hover:is(.dark *) {
  background-color: rgb(22 78 99 / 0.2);
}

.dark\\:hover\\:bg-cyan-900\\/30:hover:is(.dark *) {
  background-color: rgb(22 78 99 / 0.3);
}

.dark\\:hover\\:bg-cyan-900\\/50:hover:is(.dark *) {
  background-color: rgb(22 78 99 / 0.5);
}

.dark\\:hover\\:bg-emerald-900\\/20:hover:is(.dark *) {
  background-color: rgb(6 78 59 / 0.2);
}

.dark\\:hover\\:bg-emerald-900\\/30:hover:is(.dark *) {
  background-color: rgb(6 78 59 / 0.3);
}

.dark\\:hover\\:bg-gray-100:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-500:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-600\\/50:hover:is(.dark *) {
  background-color: rgb(75 85 99 / 0.5);
}

.dark\\:hover\\:bg-gray-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-700\\/10:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.1);
}

.dark\\:hover\\:bg-gray-700\\/20:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.2);
}

.dark\\:hover\\:bg-gray-700\\/30:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.3);
}

.dark\\:hover\\:bg-gray-700\\/40:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.4);
}

.dark\\:hover\\:bg-gray-700\\/50:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.5);
}

.dark\\:hover\\:bg-gray-700\\/60:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.6);
}

.dark\\:hover\\:bg-gray-700\\/70:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.7);
}

.dark\\:hover\\:bg-gray-700\\/80:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.8);
}

.dark\\:hover\\:bg-gray-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-800\\/50:hover:is(.dark *) {
  background-color: rgb(31 41 55 / 0.5);
}

.dark\\:hover\\:bg-gray-900\\/30:hover:is(.dark *) {
  background-color: rgb(17 24 39 / 0.3);
}

.dark\\:hover\\:bg-gray-900\\/50:hover:is(.dark *) {
  background-color: rgb(17 24 39 / 0.5);
}

.dark\\:hover\\:bg-gray-900\\/90:hover:is(.dark *) {
  background-color: rgb(17 24 39 / 0.9);
}

.dark\\:hover\\:bg-green-900\\/30:hover:is(.dark *) {
  background-color: rgb(20 83 45 / 0.3);
}

.dark\\:hover\\:bg-indigo-900\\/20:hover:is(.dark *) {
  background-color: rgb(49 46 129 / 0.2);
}

.dark\\:hover\\:bg-indigo-900\\/30:hover:is(.dark *) {
  background-color: rgb(49 46 129 / 0.3);
}

.dark\\:hover\\:bg-orange-900\\/20:hover:is(.dark *) {
  background-color: rgb(124 45 18 / 0.2);
}

.dark\\:hover\\:bg-orange-900\\/30:hover:is(.dark *) {
  background-color: rgb(124 45 18 / 0.3);
}

.dark\\:hover\\:bg-primary-900\\/30:hover:is(.dark *) {
  background-color: rgb(12 75 59 / 0.3);
}

.dark\\:hover\\:bg-purple-900\\/20:hover:is(.dark *) {
  background-color: rgb(88 28 135 / 0.2);
}

.dark\\:hover\\:bg-purple-900\\/30:hover:is(.dark *) {
  background-color: rgb(88 28 135 / 0.3);
}

.dark\\:hover\\:bg-red-500\\/20:hover:is(.dark *) {
  background-color: rgb(239 68 68 / 0.2);
}

.dark\\:hover\\:bg-red-900\\/20:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}

.dark\\:hover\\:bg-red-900\\/30:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.3);
}

.dark\\:hover\\:bg-rose-500\\/10:hover:is(.dark *) {
  background-color: rgb(244 63 94 / 0.1);
}

.dark\\:hover\\:bg-rose-500\\/20:hover:is(.dark *) {
  background-color: rgb(244 63 94 / 0.2);
}

.dark\\:hover\\:bg-rose-900\\/20:hover:is(.dark *) {
  background-color: rgb(136 19 55 / 0.2);
}

.dark\\:hover\\:bg-rose-900\\/40:hover:is(.dark *) {
  background-color: rgb(136 19 55 / 0.4);
}

.dark\\:hover\\:bg-teal-500\\/10:hover:is(.dark *) {
  background-color: rgb(20 184 166 / 0.1);
}

.dark\\:hover\\:bg-teal-900\\/20:hover:is(.dark *) {
  background-color: rgb(19 78 74 / 0.2);
}

.dark\\:hover\\:bg-teal-900\\/30:hover:is(.dark *) {
  background-color: rgb(19 78 74 / 0.3);
}

.dark\\:hover\\:bg-teal-900\\/40:hover:is(.dark *) {
  background-color: rgb(19 78 74 / 0.4);
}

.dark\\:hover\\:bg-teal-900\\/60:hover:is(.dark *) {
  background-color: rgb(19 78 74 / 0.6);
}

.dark\\:hover\\:bg-violet-900\\/30:hover:is(.dark *) {
  background-color: rgb(76 29 149 / 0.3);
}

.dark\\:hover\\:bg-white\\/10:hover:is(.dark *) {
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:hover\\:bg-white\\/5:hover:is(.dark *) {
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:hover\\:text-gray-200:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-gray-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-indigo-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-primary-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(77 203 181 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-primary-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(45 190 165 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-purple-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-red-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-red-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-teal-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-teal-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-violet-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-violet-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-white:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:shadow-black\\/20:hover:is(.dark *) {
  --tw-shadow-color: rgb(0 0 0 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:hover\\:shadow-black\\/30:hover:is(.dark *) {
  --tw-shadow-color: rgb(0 0 0 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:focus\\:border-purple-500:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:border-red-500\\/50:focus:is(.dark *) {
  border-color: rgb(239 68 68 / 0.5);
}

.dark\\:focus\\:border-teal-600:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(13 148 136 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:bg-gray-700:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:focus\\:ring-red-400\\/40:focus:is(.dark *) {
  --tw-ring-color: rgb(248 113 113 / 0.4);
}

.dark\\:disabled\\:bg-gray-700:disabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:disabled\\:text-gray-500:disabled:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.group:focus-within .dark\\:group-focus-within\\:border-teal-700\\/60:is(.dark *) {
  border-color: rgb(15 118 110 / 0.6);
}

.group:focus-within .dark\\:group-focus-within\\:bg-teal-900\\/30:is(.dark *) {
  background-color: rgb(19 78 74 / 0.3);
}

.group:focus-within .dark\\:group-focus-within\\:text-teal-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-gray-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-gray-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-red-900\\/60:is(.dark *) {
  background-color: rgb(127 29 29 / 0.6);
}

.group:hover .dark\\:group-hover\\:bg-teal-900\\/30:is(.dark *) {
  background-color: rgb(19 78 74 / 0.3);
}

.group:hover .dark\\:group-hover\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-emerald-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-indigo-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-teal-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-violet-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

@media (min-width: 640px) {
  .sm\\:-left-4 {
    left: -1rem;
  }
  .sm\\:bottom-24 {
    bottom: 6rem;
  }
  .sm\\:right-3 {
    right: 0.75rem;
  }
  .sm\\:right-\\[7\\.5rem\\] {
    right: 7.5rem;
  }
  .sm\\:top-\\[17rem\\] {
    top: 17rem;
  }
  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .sm\\:block {
    display: block;
  }
  .sm\\:inline {
    display: inline;
  }
  .sm\\:flex {
    display: flex;
  }
  .sm\\:inline-flex {
    display: inline-flex;
  }
  .sm\\:table-cell {
    display: table-cell;
  }
  .sm\\:hidden {
    display: none;
  }
  .sm\\:h-12 {
    height: 3rem;
  }
  .sm\\:h-5 {
    height: 1.25rem;
  }
  .sm\\:w-5 {
    width: 1.25rem;
  }
  .sm\\:w-auto {
    width: auto;
  }
  .sm\\:w-full {
    width: 100%;
  }
  .sm\\:min-w-\\[180px\\] {
    min-width: 180px;
  }
  .sm\\:max-w-3xl {
    max-width: 48rem;
  }
  .sm\\:max-w-\\[52rem\\] {
    max-width: 52rem;
  }
  .sm\\:max-w-sm {
    max-width: 24rem;
  }
  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .sm\\:flex-row {
    flex-direction: row;
  }
  .sm\\:items-start {
    align-items: flex-start;
  }
  .sm\\:items-end {
    align-items: flex-end;
  }
  .sm\\:items-center {
    align-items: center;
  }
  .sm\\:justify-end {
    justify-content: flex-end;
  }
  .sm\\:justify-center {
    justify-content: center;
  }
  .sm\\:justify-between {
    justify-content: space-between;
  }
  .sm\\:gap-2 {
    gap: 0.5rem;
  }
  .sm\\:gap-4 {
    gap: 1rem;
  }
  .sm\\:gap-6 {
    gap: 1.5rem;
  }
  .sm\\:gap-y-1\\.5 {
    row-gap: 0.375rem;
  }
  .sm\\:divide-x > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }
  .sm\\:divide-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }
  .sm\\:self-end {
    align-self: flex-end;
  }
  .sm\\:p-5 {
    padding: 1.25rem;
  }
  .sm\\:p-6 {
    padding: 1.5rem;
  }
  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .sm\\:px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .sm\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .sm\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }
  .sm\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .sm\\:pb-20 {
    padding-bottom: 5rem;
  }
  .sm\\:pl-11 {
    padding-left: 2.75rem;
  }
  .sm\\:pr-12 {
    padding-right: 3rem;
  }
  .sm\\:pt-20 {
    padding-top: 5rem;
  }
  .sm\\:pt-28 {
    padding-top: 7rem;
  }
  .sm\\:pt-32 {
    padding-top: 8rem;
  }
  .sm\\:text-right {
    text-align: right;
  }
  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 768px) {
  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }
  .md\\:block {
    display: block;
  }
  .md\\:flex {
    display: flex;
  }
  .md\\:table-cell {
    display: table-cell;
  }
  .md\\:hidden {
    display: none;
  }
  .md\\:h-10 {
    height: 2.5rem;
  }
  .md\\:w-1\\/6 {
    width: 16.666667%;
  }
  .md\\:w-44 {
    width: 11rem;
  }
  .md\\:w-48 {
    width: 12rem;
  }
  .md\\:w-80 {
    width: 20rem;
  }
  .md\\:columns-2 {
    columns: 2;
  }
  .md\\:columns-3 {
    columns: 3;
  }
  .md\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .md\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .md\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .md\\:flex-row {
    flex-direction: row;
  }
  .md\\:flex-col {
    flex-direction: column;
  }
  .md\\:items-start {
    align-items: flex-start;
  }
  .md\\:items-center {
    align-items: center;
  }
  .md\\:justify-start {
    justify-content: flex-start;
  }
  .md\\:justify-between {
    justify-content: space-between;
  }
  .md\\:space-x-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:divide-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }
  .md\\:border-b-0 {
    border-bottom-width: 0px;
  }
  .md\\:border-r {
    border-right-width: 1px;
  }
  .md\\:p-12 {
    padding: 3rem;
  }
  .md\\:text-left {
    text-align: left;
  }
  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }
  .md\\:text-\\[1\\.35rem\\] {
    font-size: 1.35rem;
  }
  .md\\:text-\\[4\\.25rem\\] {
    font-size: 4.25rem;
  }
  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 1024px) {
  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .lg\\:col-span-10 {
    grid-column: span 10 / span 10;
  }
  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }
  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }
  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }
  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }
  .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }
  .lg\\:col-span-9 {
    grid-column: span 9 / span 9;
  }
  .lg\\:-mb-20 {
    margin-bottom: -5rem;
  }
  .lg\\:block {
    display: block;
  }
  .lg\\:flex {
    display: flex;
  }
  .lg\\:table-cell {
    display: table-cell;
  }
  .lg\\:aspect-auto {
    aspect-ratio: auto;
  }
  .lg\\:h-16 {
    height: 4rem;
  }
  .lg\\:w-1\\/2 {
    width: 50%;
  }
  .lg\\:w-auto {
    width: auto;
  }
  .lg\\:max-w-md {
    max-width: 28rem;
  }
  .lg\\:max-w-none {
    max-width: none;
  }
  .lg\\:-translate-y-2 {
    --tw-translate-y: -0.5rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .lg\\:columns-3 {
    columns: 3;
  }
  .lg\\:columns-5 {
    columns: 5;
  }
  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .lg\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .lg\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .lg\\:grid-cols-\\[0\\.7fr_3\\.3fr\\] {
    grid-template-columns: 0.7fr 3.3fr;
  }
  .lg\\:grid-cols-\\[0\\.88fr_1\\.12fr\\] {
    grid-template-columns: 0.88fr 1.12fr;
  }
  .lg\\:grid-cols-\\[1fr_240px_auto\\] {
    grid-template-columns: 1fr 240px auto;
  }
  .lg\\:grid-cols-\\[minmax\\(0\\2c 0\\.42fr\\)_minmax\\(0\\2c 0\\.58fr\\)\\] {
    grid-template-columns: minmax(0,0.42fr) minmax(0,0.58fr);
  }
  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_350px\\] {
    grid-template-columns: minmax(0,1fr) 350px;
  }
  .lg\\:grid-cols-\\[minmax\\(220px\\2c 0\\.85fr\\)_minmax\\(0\\2c 1\\.5fr\\)\\] {
    grid-template-columns: minmax(220px,0.85fr) minmax(0,1.5fr);
  }
  .lg\\:flex-row {
    flex-direction: row;
  }
  .lg\\:items-center {
    align-items: center;
  }
  .lg\\:justify-start {
    justify-content: flex-start;
  }
  .lg\\:justify-end {
    justify-content: flex-end;
  }
  .lg\\:justify-between {
    justify-content: space-between;
  }
  .lg\\:gap-12 {
    gap: 3rem;
  }
  .lg\\:gap-14 {
    gap: 3.5rem;
  }
  .lg\\:gap-16 {
    gap: 4rem;
  }
  .lg\\:gap-6 {
    gap: 1.5rem;
  }
  .lg\\:divide-x > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }
  .lg\\:divide-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }
  .lg\\:divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
  }
  .lg\\:border-b-0 {
    border-bottom-width: 0px;
  }
  .lg\\:border-l {
    border-left-width: 1px;
  }
  .lg\\:border-r {
    border-right-width: 1px;
  }
  .lg\\:border-gray-100 {
    --tw-border-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
  }
  .lg\\:border-gray-200\\/70 {
    border-color: rgb(229 231 235 / 0.7);
  }
  .lg\\:p-10 {
    padding: 2.5rem;
  }
  .lg\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .lg\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }
  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:pb-12 {
    padding-bottom: 3rem;
  }
  .lg\\:pb-\\[80px\\] {
    padding-bottom: 80px;
  }
  .lg\\:pl-4 {
    padding-left: 1rem;
  }
  .lg\\:pl-6 {
    padding-left: 1.5rem;
  }
  .lg\\:pt-10 {
    padding-top: 2.5rem;
  }
  .lg\\:pt-28 {
    padding-top: 7rem;
  }
  .lg\\:pt-32 {
    padding-top: 8rem;
  }
  .lg\\:text-left {
    text-align: left;
  }
  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .lg\\:text-\\[15px\\] {
    font-size: 15px;
  }
  .lg\\:text-\\[5rem\\] {
    font-size: 5rem;
  }
  .first\\:lg\\:pl-0:first-child {
    padding-left: 0px;
  }
  .last\\:lg\\:pr-0:last-child {
    padding-right: 0px;
  }
  .dark\\:lg\\:divide-gray-800:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-opacity: 1;
    border-color: rgb(31 41 55 / var(--tw-divide-opacity, 1));
  }
  .dark\\:lg\\:border-gray-700\\/60:is(.dark *) {
    border-color: rgb(55 65 81 / 0.6);
  }
}

@media (min-width: 1280px) {
  .xl\\:col-span-10 {
    grid-column: span 10 / span 10;
  }
  .xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .xl\\:col-span-5 {
    grid-column: span 5 / span 5;
  }
  .xl\\:col-span-7 {
    grid-column: span 7 / span 7;
  }
  .xl\\:col-start-1 {
    grid-column-start: 1;
  }
  .xl\\:col-start-2 {
    grid-column-start: 2;
  }
  .xl\\:col-start-3 {
    grid-column-start: 3;
  }
  .xl\\:row-start-1 {
    grid-row-start: 1;
  }
  .xl\\:row-start-2 {
    grid-row-start: 2;
  }
  .xl\\:row-start-3 {
    grid-row-start: 3;
  }
  .xl\\:row-start-4 {
    grid-row-start: 4;
  }
  .xl\\:row-start-5 {
    grid-row-start: 5;
  }
  .xl\\:block {
    display: block;
  }
  .xl\\:flex {
    display: flex;
  }
  .xl\\:inline-flex {
    display: inline-flex;
  }
  .xl\\:contents {
    display: contents;
  }
  .xl\\:min-w-0 {
    min-width: 0px;
  }
  .xl\\:flex-1 {
    flex: 1 1;
  }
  .xl\\:columns-2 {
    columns: 2;
  }
  .xl\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .xl\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .xl\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .xl\\:grid-cols-\\[1fr_360px\\] {
    grid-template-columns: 1fr 360px;
  }
  .xl\\:grid-cols-\\[minmax\\(0\\2c 0\\.7fr\\)_minmax\\(0\\2c 1\\.3fr\\)\\] {
    grid-template-columns: minmax(0,0.7fr) minmax(0,1.3fr);
  }
  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1\\.18fr\\)\\] {
    grid-template-columns: minmax(0,1fr) minmax(0,1fr) minmax(0,1.18fr);
  }
  .xl\\:flex-row {
    flex-direction: row;
  }
  .xl\\:flex-col {
    flex-direction: column;
  }
  .xl\\:items-start {
    align-items: flex-start;
  }
  .xl\\:gap-3 {
    gap: 0.75rem;
  }
  .xl\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .xl\\:divide-x > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }
  .xl\\:divide-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }
  .xl\\:border-r {
    border-right-width: 1px;
  }
  .xl\\:border-teal-200\\/50 {
    border-color: rgb(153 246 228 / 0.5);
  }
  .xl\\:pr-4 {
    padding-right: 1rem;
  }
}

@media print {
  .print\\:hidden {
    display: none;
  }
  .print\\:max-w-none {
    max-width: none;
  }
  .print\\:overflow-visible {
    overflow: visible;
  }
  .print\\:p-1 {
    padding: 0.25rem;
  }
  .print\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none::-webkit-inner-spin-button {
  appearance: none;
}

.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none::-webkit-outer-spin-button {
  appearance: none;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-gray-300::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.dark\\:\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-gray-600:is(.dark *)::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-transparent::-webkit-scrollbar-track {
  background-color: transparent;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-2::-webkit-scrollbar {
  width: 0.5rem;
}

.\\[\\&\\:empty\\]\\:before\\:text-gray-300:empty::before {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.\\[\\&\\:empty\\]\\:before\\:content-\\[attr\\(data-placeholder\\)\\]:empty::before {
  --tw-content: attr(data-placeholder);
  content: var(--tw-content);
}

.\\[\\&_\\*\\]\\:cursor-pointer * {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/index.css","<no source>"],"names":[],"mappings":"AAAA;;4DAE4D;;AAE5D,sDAAsD;AACtD;EACE,wBAAwB;AAC1B;;AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd,kEAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,yGAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,mCAAc;IAAd,kCAAc;IAAd,kCAAc;IAAd,qCAAc;IAAd,gBAAc;IAAd,SAAc;IAAd,UAAc;IAAd,mCAAc;IAAd,2BAAc;IAAd,4CAAc;IAAd,wBAAc;IAAd,gBAAc;IAAd,qBAAc;IAAd,YAAc;EAAA;;EAAd;;;;;IAAc;EAAd;;IAAA,2BAAc;IAAd,wBAAc;IAAd,oCAAc;EAAA;;EAAd,gDAAc;EAAd;IAAA,aAAc;EAAA;;EAAd;EAAA,oBAAc;EAAd;AAAc;;EAAd;EAAA,kBAAc;EAAd,kBAAc;EAAd,4DAAc;EAAd,yGAAc;EAAd,oBAAc;EAAd,gDAAc;EAAd,mCAAc;EAAd;AAAc;;EAAd;EAAA,kBAAc;EAAd,yDAAc;EAAd,oBAAc;EAAd;AAAc;;EAAd;IAAA,iBAAc;IAAd,mDAAc;IAAd,SAAc;IAAd,UAAc;IAAd,kBAAc;IAAd,6CAAc;EAAA;;EAAd;IAAA,6CAAc;IAAd,iBAAc;IAAd,kBAAc;EAAA;;EAAd,uDAAc;EAAd;IAAA,2BAAc;EAAA;;EAAd;IAAA,0BAAc;IAAd,iBAAc;IAAd,mBAAc;IAAd,kBAAc;IAAd,sBAAc;IAAd,uCAAc;EAAA;;EAAd;;;sEAAc;EAAd;IAAA;MAAA,qCAAc;MAAd,gCAAc;MAAd,oCAAc;IAAA;;IAAd;MAAA,oCAAc;IAAA;EAAA;;EAAd;;IAAA,wBAAc;IAAd,SAAc;EAAA;;EAAd;IAAA,qBAAc;EAAA;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;;EAmNhB;EAAA,kBAA+I;EAA/I;AAA+I;;EAA/I;EAAA,mBAA+I;EAA/I,iBAA+I;EAA/I,sBAA+I;EAA/I,4DAA+I;EAA/I,kBAA+I;EAA/I,4DAA+I;EAA/I,eAA+I;EAA/I,0CAA+I;EAA/I,qDAA+I;EAA/I,uGAA+I;EAA/I,wBAA+I;EAA/I,wDAA+I;EAA/I;AAA+I;;EAA/I;EAAA,2CAA+I;EAA/I,sDAA+I;EAA/I;AAA+I;;EAA/I;EAAA,sBAA+I;EAA/I,yDAA+I;EAA/I,kBAA+I;EAA/I;AAA+I;;EAI/I;EAAA,WAA+M;EAA/M,qBAA+M;EAA/M,iBAA+M;EAA/M,kBAA+M;EAA/M,4DAA+M;EAA/M,sBAA+M;EAA/M,uBAA+M;EAA/M,qBAA+M;EAA/M,wBAA+M;EAA/M,mBAA+M;EAA/M,oBAA+M;EAA/M,wBAA+M;EAA/M,wDAA+M;EAA/M;AAA+M;;EAA/M;EAAA,kBAA+M;EAA/M;AAA+M;;EAA/M;EAAA,8BAA+M;EAA/M,mBAA+M;EAA/M,2GAA+M;EAA/M,yGAA+M;EAA/M,4FAA+M;EAA/M,oBAA+M;EAA/M;AAA+M;;EAA/M;EAAA,kBAA+M;EAA/M,yDAA+M;EAA/M,oBAA+M;EAA/M;AAA+M;;EAA/M;EAAA,kBAA+M;EAA/M;AAA+M;;EAGjN,0DAA0D;;EAK1D,8BAA8B;EAE5B;EAAA,eAAqJ;EAArJ,gBAAqJ;EAArJ,kBAAqJ;EAArJ,4DAAqJ;EAArJ;AAAqJ;EAArJ;EAAA,kBAAqJ;EAArJ;AAAqJ;EAArJ;EAAA,kBAAqJ;EAArJ;AAAqJ;EAArJ;EAAA,kBAAqJ;EAArJ;AAAqJ;EAArJ;EAAA,kBAAqJ;EAArJ;AAAqJ;EAArJ;EAAA,kBAAqJ;EAArJ;AAAqJ;EAArJ;EAAA,kBAAqJ;EAArJ;AAAqJ;EADvJ;IAEE,yDAAmP;IACnP,wCAAwC;IACxC,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA,gCAAgC;EAE9B;EAAA;AAAe;;EAGjB,uDAAuD;EAErD;EAAA,sBAA2P;EAA3P,yDAA2P;EAA3P,oBAA2P;EAA3P;AAA2P;EAA3P;EAAA,WAA2P;EAA3P,iBAA2P;EAA3P,wBAA2P;EAA3P,sBAA2P;EAA3P,4DAA2P;EAA3P,6BAA2P;EAA3P,YAA2P;EAA3P,wBAA2P;EAA3P,mBAA2P;EAA3P,oBAA2P;EAA3P,oBAA2P;EAA3P,gDAA2P;EAA3P,+FAA2P;EAA3P,wDAA2P;EAA3P;AAA2P;EAA3P;EAAA,oBAA2P;EAA3P;AAA2P;EAA3P;EAAA,oBAA2P;EAA3P;AAA2P;EAA3P;EAAA,sBAA2P;EAA3P,2DAA2P;EAA3P,8BAA2P;EAA3P;AAA2P;EAA3P;EAAA,sBAA2P;EAA3P,yDAA2P;EAA3P,oBAA2P;EAA3P;AAA2P;EAA3P;EAAA,oBAA2P;EAA3P;AAA2P;;EAI3P;EAAA,2GAAa;EAAb,yGAAa;EAAb;AAAa;;EAIb;EAAA,sBAA2F;EAA3F,yDAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;EAA3F;EAAA,eAA2F;EAA3F,sBAA2F;EAA3F,4DAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;EAA3F;EAAA,sBAA2F;EAA3F,yDAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;EAG7F,mBAAmB;EAEjB;EAAA,oBAAkG;EAAlG;AAAkG;EAAlG;EAAA,sBAAkG;EAAlG,cAAkG;EAAlG,eAAkG;EAAlG,gBAAkG;EAAlG,yBAAkG;EAAlG,uBAAkG;EAAlG,oBAAkG;EAAlG;AAAkG;EAAlG;EAAA,oBAAkG;EAAlG;AAAkG;;EAGpG,qCAAqC;EACrC;IACE,aAAa;IACb,oBAAmB;IAAnB,iDAAmB;EACrB;;EAEA,oBAAoB;EAElB;EAAA,eAAyD;EAAzD,gBAAyD;EAAzD,6BAAyD;EAAzD,qBAAyD;IACzD,yDAA2N;IAC3N,qCAAqC;IACrC,4BAA4B;IAC5B;AAJyD;;EAO3D,sBAAsB;EAEpB;EAAA,gBAA4B;EAA5B;AAA4B;;EAG9B;sEACoE;EACpE;;;IAGE,iBAAiB;EACnB;;EAEA,4BAA4B;EAE1B;EAAA,oBAAyB;EAAzB;AAAyB;;EAIzB;EAAA,kBAAuB;EAAvB;AAAuB;;EAIvB;EAAA,sBAA8C;EAA9C,yDAA8C;EAA9C,oBAA8C;EAA9C;AAA8C;;EAI9C;EAAA,kBAAuB;EAAvB;AAAuB;;EAIvB;EAAA,sBAAkD;EAAlD;AAAkD;;EAAlD;EAAA,kBAAkD;EAAlD;AAAkD;;EAIlD;EAAA,sBAA8C;EAA9C,yDAA8C;EAA9C,oBAA8C;EAA9C;AAA8C;;EAGhD,+CAA+C;EAE7C;EAAA,kBAAuB;EAAvB;AAAuB;;EAIvB;EAAA,sBAA2B;EAA3B;AAA2B;;EAI3B;EAAA,oBAAsB;EAAtB;AAAsB;;EAItB;EAAA,oBAAyB;EAAzB;AAAyB;;EAIzB;EAAA,oBAAyB;EAAzB;AAAyB;;EAIzB;EAAA,oBAAyB;EAAzB;AAAyB;AAzU7B;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,+FAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB,yFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,2FAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,2GAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,2GAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;AAAA;AAAnB;EAAA;AAAmB;EA+LjB,yEAAyE;EACzE;IACE,gDAAgD;IAChD,yCAAyC;IACzC,8CAA8C;IAC9C,uBAAuB;EACzB;AArMF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,6EAA6E;AAC7E;EACE,mBAAmB;EACnB,4DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4DAAiE;EACjE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4DAAiE;EACjE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,6DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6DAAmE;EACnE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6DAAgE;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,6DAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,6DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAoPA,kDAAkD;AAClD;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC;;AAED,iDAAiD;AACjD;EACE,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA,oCAAoC;AACpC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qDAAqD;AACrD;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA,mDAAmD;AACnD;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,0CAA0C;AAC1C;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,uCAAuC;EACzC;AACF;;AAEA;;EAEE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,sCAAsC;AACxC;;AAEA,iDAAiD;AACjD;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,sEAAsE;AACtE;;EAEE,iCAAiC;AACnC;;AAEA,qDAAqD;AACrD;EACE;IACE,UAAU;IACV,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,yBAAyB;IACzB,wBAAwB;EAC1B;AACF;;AAEA;EACE,yDAAyD;EACzD,0CAA0C;AAC5C;;AAEA,qDAAqD;AACrD;EACE;IACE,UAAU;IACV,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF;;AAEA;EACE,gEAAgE;EAChE,0CAA0C;AAC5C;;AAEA,8CAA8C;AAC9C;EACE;IACE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,yDAAyD;EACzD,+BAA+B;AACjC;;AAEA,mDAAmD;AACnD;EACE;IACE,UAAU;IACV,4BAA4B;IAC5B,aAAa;EACf;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA;EACE,4DAA4D;EAC5D,2CAA2C;AAC7C;;AAEA,gDAAgD;AAChD;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,uCAAuC;EACzC;AACF;;AAEA;EACE,iEAAiE;EACjE,2CAA2C;EAC3C,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,2DAA2D;AAC7D;;AAEA,sDAAsD;AACtD;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,kDAAkD;AACpD;;AAEA,qCAAqC;AACrC;EACE;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,iCAAiC;EACjC;;;;;;;IAOE,wBAAwB;EAC1B;;EAEA,kCAAkC;EAClC;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA,oCAAoC;EACpC;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;;;yBAIuB;EACvB;IACE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAC5B,uBAAuB;EACzB;EACA,6CAA6C,wBAAwB,EAAE;;EAEvE;;;yEAGuE;EACvE,sBAAsB,qBAAqB,EAAE,2BAA2B,EAAE;EAC1E,gDAAgD,wBAAwB,EAAE;EAC1E,4BAA4B,qBAAqB,EAAE;EACnD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,oBAAoB;IACpB,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;EACnB;EACA,6BAA6B,sBAAsB,EAAE,iBAAiB,EAAE;EACxE,yBAAyB,wBAAwB,EAAE;AACrD;;AAEA,sCAAsC;;AAetC;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,wHAAwH;EACxH,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE;;IAEE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA,6BAA6B;AAC7B;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;iEAGiE;;AAEjE,8BAA8B;AAC9B;EACE,WAAW,mCAAmC,EAAE;EAChD,MAAM,6CAA6C,EAAE;EACrD,MAAM,6CAA6C,EAAE;EACrD,MAAM,4CAA4C,EAAE;AACtD;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;;AAE7C,iCAAiC;AACjC;EACE,WAAW,2BAA2B,EAAE;EACxC,MAAM,6BAA6B,EAAE;AACvC;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA,gDAAgD;AAChD;EACE,KAAK,0CAA0C,EAAE;EACjD,YAAY,yCAAyC,EAAE;AACzD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,uFAAuF;EACvF,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA,wDAAwD;AACxD;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sEAAsE;AACtE;;;EAGE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,oGAAoG;AACtG;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;EACA;;;;;;;;;;;;;;;IAeE,0BAA0B;EAC5B;EACA,gEAAgE;EAChE;;;;IAIE,qBAAqB;EACvB;AACF;;AAEA,0EAA0E;AAC1E,yEAAyE;AACzE;;;;;;;;;;;;;;EAcE,0BAA0B;AAC5B;;AAEA,wEAAwE;AACxE;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,mDAAmD;AACnD;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE,WAAW,+CAA+C,EAAE,aAAa,EAAE;EAC3E,MAAM,8CAA8C,EAAE,UAAU,EAAE;AACpE;;AAEA;EACE,sDAAsD;AACxD;;AAEA,yCAAyC;AACzC;EACE,KAAK,4CAA4C,EAAE;EACnD,MAAM,4CAA4C,EAAE;EACpD,OAAO,yCAAyC,EAAE;AACpD;;AAEA;EACE,gEAAgE;AAClE;;AAEA,kDAAkD;AAClD;EACE,iFAAiF;EACjF,0BAA0B;AAC5B;;AAEA;EACE,gFAAgF;EAChF,0BAA0B;AAC5B;EAt3BE;IC/TF,2BAAA;EDiUE;EADE;EAAA,kBAAuB;EAAvB;AAAuB;EAAvB;EAAA,kBAAuB;EAAvB;AAAuB;;EAIvB;EAAA,sBAA2B;EAA3B;AAA2B;;EAI3B;EAAA,oBAAsB;EAAtB;AAAsB;;EAItB;EAAA,oBAAyB;EAAzB;AAAyB;;EAIzB;EAAA,oBAAyB;EAAzB;AAAyB;;EAIzB;EAAA,oBAAyB;EAAzB;AAAyB;EApBzB;EAAA,kBAAuB;EAAvB;AAAuB;;EAIvB;EAAA,sBAA2B;EAA3B;AAA2B;EAJ3B;EAAA,kBAAuB;EAAvB;AAAuB;;EAIvB;EAAA,sBAA2B;EAA3B;AAA2B;;EAI3B;EAAA,oBAAsB;EAAtB;AAAsB;;EAItB;EAAA,oBAAyB;EAAzB;AAAyB;;EAIzB;EAAA,oBAAyB;EAAzB;AAAyB;;EAIzB;EAAA,oBAAyB;EAAzB;AAAyB;EApBzB;EAAA,kBAAuB;EAAvB;AAAuB;;EAQvB;EAAA,oBAAsB;EAAtB;AAAsB;;EAItB;EAAA,oBAAyB;EAAzB;AAAyB;;EAIzB;EAAA,oBAAyB;EAAzB;AAAyB;;EAIzB;EAAA,oBAAyB;EAAzB;AAAyB;;EAJzB;EAAA,oBAAyB;EAAzB;AAAyB;;EAIzB;EAAA,oBAAyB;EAAzB;AAAyB;;EAJzB;EAAA,oBAAyB;EAAzB;AAAyB;;AAhV7B;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,eAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD,wBAqrCC;EArrCD,wDAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,gBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,0CAqrCC;EArrCD,uDAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,yGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,yGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,2BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,iBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,iBAqrCC;EArrCD,iBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,mBAqrCC;EArrCD,mBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2EAqrCC;EArrCD,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2EAqrCC;EArrCD,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2EAqrCC;EArrCD,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2EAqrCC;EArrCD,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,0EAqrCC;EArrCD,8FAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2CAqrCC;EArrCD,qDAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2CAqrCC;EArrCD,qDAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,6CAqrCC;EArrCD,sDAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,iDAqrCC;EArrCD,2DAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,+EAqrCC;EArrCD,mGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,6EAqrCC;EArrCD,iGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0CAqrCC;EArrCD,uDAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,gFAqrCC;EArrCD,oGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,uCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0CAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0CAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,uCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,uCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0CAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,yGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,yGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,gCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,6EAqrCC;EArrCD,iGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0CAqrCC;EArrCD,uDAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,8BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,yGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,yGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,yGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,yGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,2GAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,yGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,8BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,yGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,2GAqrCC;EArrCD,yGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,gBAqrCC;EArrCD,gBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,iBAqrCC;EArrCD,iBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,eAqrCC;EArrCD,eAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,eAqrCC;EArrCD,eAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,qBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,mBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,eAqrCC;EArrCD,eAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,iBAqrCC;EArrCD,iBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,eAqrCC;EArrCD,eAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,iBAqrCC;EArrCD,iBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;IAAA;EAqrCC;AAAA;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,+EAqrCC;EArrCD,mGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,6EAqrCC;EArrCD,iGAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,8BAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wEAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,uEAqrCC;EArrCD,iEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wEAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wEAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wEAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0EAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0EAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0EAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wEAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4DAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,0EAqrCC;EArrCD,oEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wEAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yEAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,wEAqrCC;EArrCD,kEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,yDAqrCC;EArrCD,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,mEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,qEAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sCAqrCC;EArrCD,qDAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,4CAqrCC;EArrCD,2DAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,mCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,uCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,mCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,mCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,sBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,wBAqrCC;IArrCD,0DAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,wBAqrCC;IArrCD,kEAqrCC;IArrCD;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,oBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,oBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,oBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,kBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,oBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,kBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,oBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,qBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,iBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,oBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,iBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,mBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,kBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,eAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,eAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,mBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,mBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,kBAqrCC;IArrCD;EAqrCC;AAAA;;AArrCD;EAAA;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,uBAqrCC;IArrCD,uDAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,uBAqrCC;IArrCD,uDAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,wBAqrCC;IArrCD,kEAqrCC;IArrCD;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,iBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,kBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,eAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,kBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,mBAqrCC;IArrCD;EAqrCC;AAAA;;AArrCD;EAAA;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,yBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,wBAqrCC;IArrCD,0DAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,wBAqrCC;IArrCD,kEAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,sBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,sBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,oBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,kBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,kBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,mBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,sBAqrCC;IArrCD;EAqrCC;EArrCD;IAAA;EAqrCC;AAAA;;AArrCD;EAAA;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,uBAqrCC;IArrCD,2DAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,wBAqrCC;IArrCD,0DAqrCC;IArrCD;EAqrCC;EArrCD;IAAA,wBAqrCC;IArrCD,kEAqrCC;IArrCD;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;AAAA;;AArrCD;EAAA;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA;EAqrCC;EArrCD;IAAA,sBAqrCC;IArrCD,8BAqrCC;IArrCD;EAqrCC;AAAA;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,kBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA;AAqrCC;;AArrCD;EAAA,0BAqrCC;EArrCD,oBAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA,oCAqrCC;EArrCD;AAqrCC;;AArrCD;EAAA;AAqrCC","sourcesContent":["/* Montserrat @font-face declaration\n   are in public/index.html <head> so they load immediately\n   with the page and are not affected by HMR/Fast Refresh. */\n\n/* Remove blinking caret from login form inputs only */\n.login-page input[type=\"text\"], .login-page input[type=\"password\"] {\n  caret-color: transparent;\n}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Custom Fonts (used in print/PDF and public pages only) - woff2 optimized */\n@font-face {\n  font-family: 'Auro';\n  src: url('./assets/fonts/Auro-Light.woff2') format('woff2');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Auro';\n  src: url('./assets/fonts/Auro-Light.woff2') format('woff2');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Auro';\n  src: url('./assets/fonts/Auro-LightItalic.woff2') format('woff2');\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Amaranth';\n  src: url('./assets/fonts/Amaranth-Regular.woff2') format('woff2');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Amaranth';\n  src: url('./assets/fonts/Amaranth-Bold.woff2') format('woff2');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Baloo Bhai 2';\n  src: url('./assets/fonts/BalooBhai2-Regular.woff2') format('woff2');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Baloo Bhai 2';\n  src: url('./assets/fonts/BalooBhai2-Medium.woff2') format('woff2');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Baloo Bhai 2';\n  src: url('./assets/fonts/BalooBhai2-Bold.woff2') format('woff2');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Dubai';\n  src: url('./assets/fonts/DUBAI-LIGHT.woff2') format('woff2');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Dubai';\n  src: url('./assets/fonts/DUBAI-REGULAR.woff2') format('woff2');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Dubai';\n  src: url('./assets/fonts/DUBAI-MEDIUM.woff2') format('woff2');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@layer base {\n  html {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    text-rendering: optimizeLegibility;\n    /* Allow document to grow naturally */\n    min-height: 100%;\n    margin: 0;\n    padding: 0;\n    /* Prevent bounce effect globally */\n    overscroll-behavior-y: none;\n    /* Hide scrollbar for IE, Edge and Firefox */\n    -ms-overflow-style: none;\n    /* IE and Edge */\n    scrollbar-width: none;\n    /* Firefox */\n  }\n\n  /*\n   * When the authenticated app shell is mounted (MainLayout), lock the\n   * document completely so wheel events that escape inner scroll containers\n   * can never shift the page.  !important ensures this wins over inline\n   * styles set by modal/dialog cleanup code (e.g. body.style.overflow='unset').\n   */\n  html.app-shell,\n  body.app-shell {\n    overflow: hidden !important;\n    height: 100vh !important;\n    overscroll-behavior: none !important;\n  }\n\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  html::-webkit-scrollbar {\n    display: none;\n  }\n\n  body {\n    @apply bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 font-sans antialiased overflow-x-hidden;\n    min-height: 100vh;\n    /* Remove fixed height to allow natural scrolling */\n    margin: 0;\n    padding: 0;\n    position: relative;\n    transition: background-color 0.2s, color 0.2s;\n  }\n\n  #root {\n    /* Ensure root container fills the viewport */\n    min-height: 100vh;\n    position: relative;\n  }\n\n  /* Ensure crisp rendering on high-resolution displays */\n  * {\n    -webkit-backface-visibility: hidden;\n    -moz-backface-visibility: hidden;\n    backface-visibility: hidden;\n  }\n\n  .public-header {\n    position: fixed !important;\n    top: 0 !important;\n    right: 0 !important;\n    left: 0 !important;\n    z-index: 50 !important;\n    -webkit-backface-visibility: visible !important;\n    -moz-backface-visibility: visible !important;\n    backface-visibility: visible !important;\n  }\n\n  /* Mobile: backdrop-filter on a position:fixed element is a known source of\n     the header flickering or vanishing during scroll on Android GPUs, and the\n     scrolled/unscrolled toggle re-animates it on every scroll. Use a solid\n     background instead — visually near-identical, compositing-safe. */\n  @media (max-width: 767px) {\n    .public-header {\n      -webkit-backdrop-filter: none !important;\n      -moz-backdrop-filter: none !important;\n      backdrop-filter: none !important;\n      background-color: #ffffff !important;\n    }\n\n    .dark .public-header {\n      background-color: #111827 !important;\n    }\n  }\n\n  input[type=\"number\"]::-webkit-outer-spin-button,\n  input[type=\"number\"]::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type=\"number\"] {\n    -moz-appearance: textfield;\n    appearance: textfield;\n  }\n}\n\n@layer utilities {\n  /* Inforiver-style financial figures: Inter with tabular lining numbers */\n  .font-financial {\n    font-family: 'Montserrat', system-ui, sans-serif;\n    font-feature-settings: 'tnum' 1, 'lnum' 1;\n    font-variant-numeric: tabular-nums lining-nums;\n    letter-spacing: -0.01em;\n  }\n}\n\n@layer components {\n  .btn-primary {\n    @apply bg-primary-500 hover:bg-primary-600 text-white font-medium py-2 px-4 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md;\n  }\n\n  .btn-secondary {\n    @apply bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded-xl transition-colors duration-200;\n  }\n\n  .card {\n    @apply bg-white dark:bg-gray-800 rounded-2xl shadow-card border border-gray-100 dark:border-gray-700 p-6 hover:shadow-card-hover transition-all;\n  }\n\n  .input-field {\n    @apply w-full px-2.5 py-1.5 text-sm border-0 rounded-lg focus:outline-none focus:ring-1 focus:ring-teal-500 bg-gray-50 dark:bg-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 transition-all;\n  }\n\n  /* Force white modal body background to override page bg */\n  .modal-body-white {\n    @apply bg-white;\n  }\n\n  /* macOS Sonoma style select */\n  select.input-field {\n    @apply appearance-none bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 focus:bg-white dark:focus:bg-gray-600 cursor-pointer pr-8;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M7 7l3 3 3-3' stroke='%239CA3AF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-position: right 0.3rem center;\n    background-repeat: no-repeat;\n    background-size: 1.25rem;\n  }\n\n  /* macOS Sonoma style textarea */\n  textarea.input-field {\n    @apply resize-y;\n  }\n\n  /* Rx-style underline inputs (like PrescriptionPanel) */\n  .input-rx {\n    @apply w-full text-sm text-gray-700 dark:text-gray-200 bg-transparent border-0 border-b border-gray-200 dark:border-gray-600 p-0 pb-1.5 focus:outline-none focus:border-teal-500 transition-colors placeholder:text-gray-300 dark:placeholder:text-gray-500;\n  }\n\n  .input-rx:focus {\n    @apply ring-0;\n  }\n\n  .input-rx.read-only {\n    @apply text-gray-500 dark:text-gray-400 border-gray-200 dark:border-gray-700 cursor-default;\n  }\n\n  /* Rx-style label */\n  .label-rx {\n    @apply block text-[10px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1;\n  }\n\n  /* Required indicator for Rx labels */\n  .label-rx-required::after {\n    content: ' *';\n    @apply text-red-500;\n  }\n\n  /* Rx-style select */\n  select.input-rx {\n    @apply appearance-none bg-transparent cursor-pointer pr-6;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n    background-position: right 0px center;\n    background-repeat: no-repeat;\n    background-size: 14px;\n  }\n\n  /* Rx-style textarea */\n  textarea.input-rx {\n    @apply resize-y min-h-[28px];\n  }\n\n  /* Triage check-in panel — fields render a touch larger than the text-xs\n     utility on the elements (13px instead of 12px) for readability. */\n  .triage-checkin input.input-rx,\n  .triage-checkin select.input-rx,\n  .triage-checkin textarea.input-rx {\n    font-size: 12.5px;\n  }\n\n  /* Dark mode table styling */\n  table {\n    @apply dark:text-gray-200;\n  }\n\n  thead {\n    @apply dark:bg-gray-800;\n  }\n\n  thead th {\n    @apply dark:text-gray-300 dark:border-gray-700;\n  }\n\n  tbody {\n    @apply dark:bg-gray-800;\n  }\n\n  tbody tr {\n    @apply dark:border-gray-700 dark:hover:bg-gray-700;\n  }\n\n  tbody td {\n    @apply dark:text-gray-300 dark:border-gray-700;\n  }\n\n  /* Dark mode for common table wrapper classes */\n  .bg-white {\n    @apply dark:bg-gray-800;\n  }\n\n  .border-gray-200 {\n    @apply dark:border-gray-700;\n  }\n\n  .text-gray-900 {\n    @apply dark:text-white;\n  }\n\n  .text-gray-700 {\n    @apply dark:text-gray-300;\n  }\n\n  .text-gray-500 {\n    @apply dark:text-gray-400;\n  }\n\n  .text-gray-600 {\n    @apply dark:text-gray-400;\n  }\n}\n\n/* Custom scrollbar - DISABLED to hide scrollbar */\n/*\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f8f9fa;\n  border-radius: 10px;\n}\n\n.dark ::-webkit-scrollbar-track {\n  background: #1f2937;\n}\n\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(180deg, #1a9179 0%, #168069 100%);\n  border-radius: 10px;\n  border: 2px solid #f8f9fa;\n}\n\n.dark ::-webkit-scrollbar-thumb {\n  border: 2px solid #1f2937;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(180deg, #168069 0%, #136f5a 100%);\n}\n*/\n\n/* Utility to hide scrollbar but keep scrolling */\n.no-scrollbar {\n  -ms-overflow-style: none;\n  /* IE/Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n.no-scrollbar::-webkit-scrollbar {\n  display: none !important;\n  /* Chrome/Safari */\n}\n\n/* Smooth animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fadeIn {\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Page fade-in animation for public pages */\n@keyframes pageFadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.animate-pageFadeIn {\n  animation: pageFadeIn 0.5s ease-out;\n}\n\n/* Image fade-in with subtle scale */\n@keyframes imageFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-imageFadeIn {\n  animation: imageFadeIn 0.8s ease-out;\n}\n\n/* Hero image carousel transition - GPU-accelerated */\n@keyframes fadeInImage {\n  from {\n    opacity: 0;\n    transform: scale(1.02);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.animate-fadeInImage {\n  animation: fadeInImage 0.6s ease-out;\n  will-change: opacity, transform;\n}\n\n/* Slow blink/pulse animation for pricing savings */\n@keyframes slowBlink {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.4;\n  }\n}\n\n.animate-slow-blink {\n  animation: slowBlink 8s ease-in-out infinite;\n}\n\n/* Page transition for module navigation */\n@keyframes pageTransition {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.page-transition {\n  animation: pageTransition 0.4s ease-out;\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.animate-slide-in-right {\n  animation: slideInRight 0.3s ease-out;\n}\n\n/* Ultramodern Toast Animations */\n@keyframes toastEnter {\n  from {\n    opacity: 0;\n    transform: translateX(100%) scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0) scale(1);\n  }\n}\n\n@keyframes toastExit {\n  from {\n    opacity: 1;\n    transform: translateX(0) scale(1);\n  }\n\n  to {\n    opacity: 0;\n    transform: translateX(120%) scale(0.95);\n  }\n}\n\n@keyframes iconBounce {\n\n  0%,\n  100% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.toast-enter {\n  animation: toastEnter 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.toast-exit {\n  animation: toastExit 0.3s cubic-bezier(0.4, 0, 1, 1) forwards;\n}\n\n.icon-bounce {\n  animation: iconBounce 0.5s ease-in-out;\n}\n\n/* Tab content transitions - macOS Sonoma style */\n@keyframes tabSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.tab-content {\n  animation: tabSlideIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* Vertical centering for table cells inside paginated PDF documents */\n.paginated-page th,\n.paginated-page td {\n  vertical-align: middle !important;\n}\n\n/* Slide down animation - ultramodern smooth reveal */\n@keyframes slideDown {\n  0% {\n    opacity: 0;\n    clip-path: inset(0 0 100% 0);\n    transform: translateY(-8px);\n  }\n\n  100% {\n    opacity: 1;\n    clip-path: inset(0 0 0 0);\n    transform: translateY(0);\n  }\n}\n\n.animate-slideDown {\n  animation: slideDown 0.35s cubic-bezier(0.32, 0.72, 0, 1);\n  will-change: clip-path, opacity, transform;\n}\n\n/* Slide up animation - ultramodern smooth collapse */\n@keyframes slideUp {\n  0% {\n    opacity: 1;\n    clip-path: inset(0 0 0 0);\n    transform: translateY(0);\n  }\n\n  100% {\n    opacity: 0;\n    clip-path: inset(0 0 100% 0);\n    transform: translateY(-8px);\n  }\n}\n\n.animate-slideUp {\n  animation: slideUp 0.25s cubic-bezier(0.32, 0.72, 0, 1) forwards;\n  will-change: clip-path, opacity, transform;\n}\n\n/* Bed card expansion - smooth modern reveal */\n@keyframes bedExpandIn {\n  0% {\n    opacity: 0.7;\n    transform: scale(0.98);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.animate-bedExpandIn {\n  animation: bedExpandIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n  will-change: transform, opacity;\n}\n\n/* Care view inline reveal - slide down with fade */\n@keyframes careViewReveal {\n  0% {\n    opacity: 0;\n    transform: translateY(-12px);\n    max-height: 0;\n  }\n  60% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n    max-height: 2000px;\n  }\n}\n\n.animate-careViewReveal {\n  animation: careViewReveal 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n  will-change: transform, opacity, max-height;\n}\n\n/* Smooth collapse for header/toolbar sections */\n@keyframes sectionCollapse {\n  0% {\n    opacity: 1;\n    max-height: 80px;\n  }\n  100% {\n    opacity: 0;\n    max-height: 0;\n  }\n}\n\n/* Smooth expand for header/toolbar sections */\n@keyframes sectionExpand {\n  0% {\n    opacity: 0;\n    max-height: 0;\n  }\n  100% {\n    opacity: 1;\n    max-height: 80px;\n  }\n}\n\n/* Modal animations - macOS Sonoma style */\n@keyframes modalBackdropFadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes modalBackdropFadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes modalSlideOut {\n  from {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0.95) translateY(10px);\n  }\n}\n\n.modal-backdrop {\n  animation: modalBackdropFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  /* Ensure backdrop covers entire viewport */\n  position: fixed !important;\n  top: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  z-index: 40;\n}\n\n.modal-backdrop.closing {\n  animation: modalBackdropFadeOut 0.15s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.modal-content {\n  animation: modalSlideIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n  position: relative;\n  z-index: 50;\n}\n\n.modal-content.closing {\n  animation: modalSlideOut 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* Confirm Dialog animations - ultramodern & compact */\n@keyframes confirmBackdropIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes confirmBackdropOut {\n  from { opacity: 1; }\n  to { opacity: 0; }\n}\n\n@keyframes confirmSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes confirmSlideOut {\n  from {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n  to {\n    opacity: 0;\n    transform: scale(0.95) translateY(5px);\n  }\n}\n\n.confirm-backdrop {\n  animation: confirmBackdropIn 0.15s ease-out;\n}\n\n.confirm-backdrop.closing {\n  animation: confirmBackdropOut 0.15s ease-out forwards;\n}\n\n.confirm-content {\n  animation: confirmSlideIn 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.confirm-content.closing {\n  animation: confirmSlideOut 0.15s ease-out forwards;\n}\n\n/* Print styles for purchase orders */\n@media print {\n  @page {\n    size: A4;\n    margin: 1.5cm;\n  }\n\n  body {\n    background: white !important;\n  }\n\n  /* Hide sidebar and main app UI */\n  nav,\n  aside,\n  header,\n  footer,\n  .sidebar,\n  [role=\"navigation\"],\n  .print\\:hidden {\n    display: none !important;\n  }\n\n  /* Reset modal styling for print */\n  #po-print-modal {\n    position: static !important;\n    background: white !important;\n    padding: 0 !important;\n    max-width: none !important;\n    box-shadow: none !important;\n  }\n\n  /* Make PO content take full width */\n  #po-print-content {\n    max-width: 100% !important;\n    overflow: visible !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  /* Quick report inline preview — hide everything except the preview. Scoped\n     with :has() so the nuke only engages while such a preview is actually on\n     the page — an unconditional body * rule blanks every in-place print. The\n     dedicated print path appends .quick-report-print-clone instead, which\n     must stay visible. */\n  body:has(.quick-report-inline-preview):not(:has(.quick-report-print-clone)) * {\n    visibility: hidden !important;\n  }\n  body:has(.quick-report-inline-preview):not(:has(.quick-report-print-clone)) .quick-report-inline-preview,\n  body:has(.quick-report-inline-preview):not(:has(.quick-report-print-clone)) .quick-report-inline-preview * {\n    visibility: visible !important;\n  }\n  .quick-report-inline-preview {\n    position: absolute !important;\n    left: 0 !important;\n    top: 0 !important;\n    width: 100% !important;\n    max-height: none !important;\n    overflow: visible !important;\n    background: white !important;\n    border: none !important;\n  }\n  .quick-report-inline-preview .preview-only { display: none !important; }\n\n  /* Safety net: if an in-place print happens while a paginated preview is on\n     screen, auto-size the page shells — a fixed sheet-height box overflows\n     the printable area and gets its top clipped. Dedicated print paths apply\n     their own stricter rules (higher specificity / popup stylesheets). */\n  .paginated-document { padding: 0 !important; background: #fff !important; }\n  .paginated-document > div[aria-hidden=\"true\"] { display: none !important; }\n  .paginated-document-pages { padding: 0 !important; }\n  .paginated-page {\n    width: auto !important;\n    height: auto !important;\n    min-height: 0 !important;\n    max-height: none !important;\n    margin: 0 !important;\n    box-shadow: none !important;\n    border: none !important;\n    page-break-after: always;\n    break-after: page;\n  }\n  .paginated-page:last-child { page-break-after: auto; break-after: auto; }\n  .paginated-page-number { display: none !important; }\n}\n\n/* Gemini-style Animations & Effects */\n@layer utilities {\n  .text-gradient {\n    @apply bg-clip-text text-transparent bg-gradient-to-r from-teal-600 via-cyan-500 to-blue-600 dark:from-teal-400 dark:via-cyan-300 dark:to-blue-400;\n  }\n\n  .bg-glass {\n    @apply bg-white/70 dark:bg-gray-900/70 backdrop-blur-xl border border-white/20 dark:border-gray-700/30;\n  }\n\n  .card-gemini {\n    @apply bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg border border-gray-100 dark:border-gray-700/50 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1;\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.animate-shimmer {\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 100%);\n  background-size: 200% 100%;\n  animation: shimmer 2s infinite;\n}\n\n@keyframes float {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.animate-float {\n  animation: float 6s ease-in-out infinite;\n}\n\n.animate-float-delayed {\n  animation: float 6s ease-in-out 3s infinite;\n}\n\n@keyframes glow {\n\n  0%,\n  100% {\n    opacity: 0.5;\n    transform: scale(1);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.1);\n  }\n}\n\n.animate-glow {\n  animation: glow 4s ease-in-out infinite;\n}\n\n/* Reviews scroll animation */\n@keyframes scroll-left {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n.scroll-container {\n  animation: scroll-left 120s linear infinite;\n}\n\n.scroll-container:hover {\n  animation-play-state: paused;\n}\n\n/* Hide scrollbar but keep scroll functionality */\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n.scrollbar-hide {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n/* Clinical Queue expanded row styles */\n.clinical-row-expanded {\n  color: white;\n  border: none;\n}\n\n.clinical-cell-expanded {\n  border: none;\n  background: #0d9488;\n}\n\n/* ============================================================\n   PUBLIC PAGES — ULTRAMODERN MARKETING EFFECTS\n   (Purely visual; additive only)\n   ============================================================ */\n\n/* Slow floating aurora blob */\n@keyframes blob {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  25% { transform: translate(20px, -30px) scale(1.08); }\n  50% { transform: translate(-15px, 15px) scale(0.95); }\n  75% { transform: translate(10px, 25px) scale(1.05); }\n}\n\n.animate-blob {\n  animation: blob 14s ease-in-out infinite;\n  will-change: transform;\n}\n\n.animation-delay-2000 { animation-delay: 2s; }\n.animation-delay-4000 { animation-delay: 4s; }\n.animation-delay-6000 { animation-delay: 6s; }\n\n/* Animated gradient text sweep */\n@keyframes gradient-x {\n  0%, 100% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n}\n\n.animate-gradient-x {\n  background-size: 200% auto;\n  animation: gradient-x 6s ease infinite;\n}\n\n/* Shimmering highlight sweep for pills/badges */\n@keyframes shine-sweep {\n  0% { transform: translateX(-100%) skewX(-15deg); }\n  60%, 100% { transform: translateX(250%) skewX(-15deg); }\n}\n\n.shine-sweep {\n  position: relative;\n  overflow: hidden;\n}\n\n.shine-sweep::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 40%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.35), transparent);\n  animation: shine-sweep 4.5s ease-in-out infinite;\n  pointer-events: none;\n}\n\n/* Infinite horizontal marquee (module / proof strips) */\n@keyframes marquee {\n  0% { transform: translateX(0); }\n  100% { transform: translateX(-50%); }\n}\n\n.animate-marquee {\n  animation: marquee 40s linear infinite;\n  will-change: transform;\n}\n\n.animate-marquee:hover {\n  animation-play-state: paused;\n}\n\n/* Scroll-triggered reveal (paired with components/public/Reveal.js) */\n.landing-page .animate-blob,\n.landing-page .animate-glow,\n.landing-page .animate-gradient-x {\n  animation: none;\n}\n\n.landing-page .animate-gradient-x {\n  background-size: 100% 100%;\n}\n\n.landing-page .animate-blob {\n  will-change: auto;\n}\n\n.reveal {\n  opacity: 0;\n  transform: translateY(28px);\n  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1), transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.reveal-visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .reveal {\n    opacity: 1;\n    transform: none;\n    transition: none;\n  }\n  .animate-blob,\n  .animate-marquee,\n  .animate-gradient-x,\n  .animate-float,\n  .animate-float-delayed,\n  .animate-glow,\n  .animate-pulse,\n  .animate-spin,\n  .animate-fadeIn,\n  .animate-pageFadeIn,\n  .animate-imageFadeIn,\n  .animate-fadeInImage,\n  .shine-sweep::after,\n  .bar-critical-glow,\n  .pulse-ring {\n    animation: none !important;\n  }\n  /* Ensure elements that start hidden via animation are visible */\n  .animate-fadeIn,\n  .animate-pageFadeIn,\n  .animate-imageFadeIn,\n  .animate-fadeInImage {\n    opacity: 1 !important;\n  }\n}\n\n/* ── Low-power / mobile: disable expensive decorative animations ────── */\n/* Applied via the `low-power` class on a container element.            */\n.low-power .animate-blob,\n.low-power .animate-glow,\n.low-power .animate-float,\n.low-power .animate-float-delayed,\n.low-power .animate-marquee,\n.low-power .animate-gradient-x,\n.low-power .animate-pulse,\n.low-power .animate-fadeIn,\n.low-power .animate-pageFadeIn,\n.low-power .animate-imageFadeIn,\n.low-power .animate-slow-blink,\n.low-power .animate-slide-in-right,\n.low-power .blur-3xl,\n.low-power .blur-2xl {\n  animation: none !important;\n}\n\n/* Remove heavy blur filters on low-power devices (very GPU-expensive) */\n.low-power .reveal {\n  opacity: 1;\n  transform: none;\n  transition: none;\n}\n\n.low-power .blur-3xl,\n.low-power .blur-2xl {\n  filter: none !important;\n  opacity: 0.5 !important;\n}\n\n/* Static marquee: show content without scrolling */\n.low-power .animate-marquee {\n  transform: none !important;\n  flex-wrap: wrap !important;\n  overflow: hidden !important;\n}\n\n/* Critical pulsing glow when the plan is about to expire */\n@keyframes bar-critical-glow {\n  0%, 100% { box-shadow: 0 0 2px 1px rgba(239, 68, 68, 0.45); opacity: 0.55; }\n  50% { box-shadow: 0 0 9px 3px rgba(239, 68, 68, 0.8); opacity: 1; }\n}\n\n.bar-critical-glow {\n  animation: bar-critical-glow 1.4s ease-in-out infinite;\n}\n\n/* Gentle pulsing ring for CTA emphasis */\n@keyframes pulse-ring {\n  0% { box-shadow: 0 0 0 0 rgba(20, 184, 166, 0.35); }\n  70% { box-shadow: 0 0 0 12px rgba(20, 184, 166, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(20, 184, 166, 0); }\n}\n\n.animate-pulse-ring {\n  animation: pulse-ring 2.6s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n/* Subtle dotted grid backdrop for dark sections */\n.dot-grid {\n  background-image: radial-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px);\n  background-size: 22px 22px;\n}\n\n.dot-grid-light {\n  background-image: radial-gradient(rgba(13, 148, 136, 0.10) 1px, transparent 1px);\n  background-size: 22px 22px;\n}",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
